// Generated by Avo VERSION 234.15.0. You should never have to make changes to this file.
// If you find yourself in the situation where you have to edit the file please contact us at hi@avo.app.
// If you encounter a git conflict in this file run `avo pull` and it will be resolved automatically.
/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// fetch() polyfill
(function () {
  if (typeof window === 'undefined') {
    return;
  }
  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob:
      'FileReader' in self &&
      'Blob' in self &&
      (function () {
        try {
          new Blob();
          return true
        } catch (e) {
          return false
        }
      })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  };

  function isDataView(obj: any) {
    return obj && DataView.prototype.isPrototypeOf(obj)
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ];

    var isArrayBufferView =
      ArrayBuffer.isView ||
      function (obj) {
        return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
      };
  }

  function normalizeName(name: any) {
    if (typeof name !== 'string') {
      name = String(name);
    }
    if (/[^a-z0-9\-#$%&'*+.^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value: any) {
    if (typeof value !== 'string') {
      value = String(value);
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items: any) {
    var iterator: any = {
      next: function () {
        var value = items.shift();
        return { done: value === undefined, value: value }
      }
    };

    if (support.iterable) {
      iterator[Symbol.iterator] = function () {
        return iterator
      };
    }

    return iterator
  }

  function Headers(headers: any) {
    // @ts-ignore
    (this as any).map = {};

    if (headers instanceof Headers) {
      (headers as any).forEach(function (value: any, name: any) {
        // @ts-ignore
        this.append(name, value);
        // @ts-ignore
      }, this);
    } else if (Array.isArray(headers)) {
      headers.forEach(function (header: any) {
        // @ts-ignore
        this.append(header[0], header[1]);
        // @ts-ignore
      }, this);
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function (name: any) {
        // @ts-ignore
        this.append(name, headers[name]);
        // @ts-ignore
      }, this);
    }
  }

  Headers.prototype.append = function (name: any, value: any) {
    name = normalizeName(name);
    value = normalizeValue(value);
    var oldValue = this.map[name];
    this.map[name] = oldValue ? oldValue + ', ' + value : value;
  };

  Headers.prototype['delete'] = function (name: any) {
    delete this.map[normalizeName(name)];
  };

  Headers.prototype.get = function (name: any) {
    name = normalizeName(name);
    return this.has(name) ? this.map[name] : null
  };

  Headers.prototype.has = function (name: any) {
    return this.map.hasOwnProperty(normalizeName(name))
  };

  Headers.prototype.set = function (name: any, value: any) {
    this.map[normalizeName(name)] = normalizeValue(value);
  };

  Headers.prototype.forEach = function (callback: any, thisArg: any) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this);
      }
    }
  };

  Headers.prototype.keys = function () {
    var items: any = [];
    this.forEach(function (_value: any, name: any) {
      items.push(name);
    });
    return iteratorFor(items)
  };

  Headers.prototype.values = function () {
    var items: any = [];
    this.forEach(function (value: any) {
      items.push(value);
    });
    return iteratorFor(items)
  };

  Headers.prototype.entries = function () {
    var items: any = [];
    this.forEach(function (value: any, name: any) {
      items.push([name, value]);
    });
    return iteratorFor(items)
  };

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries;
  }

  function consumed(body: any) {
    if (body.bodyUsed) {
      return true;
    }
    body.bodyUsed = true;
    return false;
  }

  function fileReaderReady(reader: any) {
    return new Promise(function (resolve: any, reject: any) {
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = function () {
        reject(reader.error);
      };
    })
  }

  function readBlobAsArrayBuffer(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsArrayBuffer(blob);
    return promise
  }

  function readBlobAsText(blob: any) {
    var reader = new FileReader();
    var promise = fileReaderReady(reader);
    reader.readAsText(blob);
    return promise
  }

  function readArrayBufferAsText(buf: any) {
    var view = new Uint8Array(buf);
    var chars = new Array(view.length);

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i]!);
    }
    return chars.join('')
  }

  function bufferClone(buf: any) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength);
      view.set(new Uint8Array(buf));
      return view.buffer
    }
  }

  function Body() {
    // @ts-ignore
    (this as any).bodyUsed = false;

    // @ts-ignore
    (this as any)._initBody = function (body: any) {
      this._bodyInit = body;
      if (!body) {
        this._bodyText = '';
      } else if (typeof body === 'string') {
        this._bodyText = body;
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body;
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body;
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString();
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer);
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer]);
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body);
      } else {
        this._bodyText = body = Object.prototype.toString.call(body);
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8');
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type);
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8');
        }
      }
    };

    if (support.blob) {
      // @ts-ignore
      (this as any).blob = function () {
        var rejected = consumed(this);
        if (rejected) {
          return Promise.reject(new TypeError('Already read'));
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob);
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]));
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob');
        } else {
          return Promise.resolve(new Blob([this._bodyText]));
        }
      };

      // @ts-ignore
      (this as any).arrayBuffer = function () {
        if (this._bodyArrayBuffer) {
          if (consumed(this)) {
            return Promise.reject(new TypeError('Already read'));
          } else {
            return Promise.resolve(this._bodyArrayBuffer);
          }
        } else {
          return this.blob().then(readBlobAsArrayBuffer);
        }
      };
    }

    // @ts-ignore
    (this as any).text = function () {
      var rejected = consumed(this);
      if (rejected) {
        return Promise.reject(new TypeError('Already read'));
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob);
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer));
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text');
      } else {
        return Promise.resolve(this._bodyText);
      }
    };

    if (support.formData) {
      // @ts-ignore
      (this as any).formData = function () {
        return this.text().then(decode)
      };
    }

    // @ts-ignore
    (this as any).json = function () {
      return this.text().then(JSON.parse)
    };

    // @ts-ignore
    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT'];

  function normalizeMethod(method: any) {
    var upcased = method.toUpperCase();
    return methods.indexOf(upcased) > -1 ? upcased : method
  }

  function Request(input: any, options: any) {
    options = options || {};
    var body = options.body;

    if (input instanceof Request) {
      if ((input as any).bodyUsed) {
        throw new TypeError('Already read')
      }
      // @ts-ignore
      (this as any).url = (input as any).url;
      // @ts-ignore
      this.credentials = (input as any).credentials;
      if (!options.headers) {
        // @ts-ignore
        this.headers = new Headers((input as any).headers);
      }
      // @ts-ignore
      this.method = (input as any).method;
      // @ts-ignore
      this.mode = (input as any).mode;
      // @ts-ignore
      this.signal = (input as any).signal;
      if (!body && (input as any)._bodyInit != null) {
        body = (input as any)._bodyInit;
        (input as any).bodyUsed = true;
      }
    } else {
      // @ts-ignore
      this.url = String(input);
    }

    // @ts-ignore
    this.credentials = options.credentials || this.credentials || 'same-origin';
    // @ts-ignore
    if (options.headers || !this.headers) {
      // @ts-ignore
      this.headers = new Headers(options.headers);
    }
    // @ts-ignore
    this.method = normalizeMethod(options.method || this.method || 'GET');
    // @ts-ignore
    this.mode = options.mode || this.mode || null;
    // @ts-ignore
    this.signal = options.signal || this.signal;
    // @ts-ignore
    this.referrer = null;

    // @ts-ignore
    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    // @ts-ignore
    this._initBody(body);
  }

  Request.prototype.clone = function () {
    // @ts-ignore
    return new Request(this, { body: this._bodyInit })
  };

  function decode(body: any) {
    var form = new FormData();
    body
      .trim()
      .split('&')
      .forEach(function (bytes: any) {
        if (bytes) {
          var split = bytes.split('=');
          var name = split.shift().replace(/\+/g, ' ');
          var value = split.join('=').replace(/\+/g, ' ');
          form.append(decodeURIComponent(name), decodeURIComponent(value));
        }
      });
    return form
  }

  function parseHeaders(rawHeaders: any) {
    // @ts-ignore
    var headers = new Headers();
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ');
    preProcessedHeaders.split(/\r?\n/).forEach(function (line: any) {
      var parts = line.split(':');
      var key = parts.shift().trim();
      if (key) {
        var value = parts.join(':').trim();
        headers.append(key, value);
      }
    });
    return headers
  }

  Body.call(Request.prototype);

  function Response(bodyInit: any, options: any) {
    if (!options) {
      options = {};
    }

    // @ts-ignore
    this.type = 'default';
    // @ts-ignore
    this.status = options.status === undefined ? 200 : options.status;
    // @ts-ignore
    this.ok = this.status >= 200 && this.status < 300;
    // @ts-ignore
    this.statusText = 'statusText' in options ? options.statusText : 'OK';
    // @ts-ignore
    this.headers = new Headers(options.headers);
    // @ts-ignore
    this.url = options.url || '';
    // @ts-ignore
    this._initBody(bodyInit);
  }

  Body.call(Response.prototype);

  Response.prototype.clone = function () {
    // @ts-ignore
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      // @ts-ignore
      headers: new Headers(this.headers),
      url: this.url
    })
  };

  Response.error = function () {
    // @ts-ignore
    var response = new Response(null, { status: 0, statusText: '' });
    response.type = 'error';
    return response
  };

  var redirectStatuses = [301, 302, 303, 307, 308];

  Response.redirect = function (url: any, status: any) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    // @ts-ignore
    return new Response(null, { status: status, headers: { location: url } })
  };

  (self as any).DOMException = (self as any).DOMException;
  try {
    new (self as any).DOMException();
  } catch (err) {
    (self as any).DOMException = function (message: any, name: any) {
      this.message = message;
      this.name = name;
      var error = Error(message);
      this.stack = error.stack;
    };
    (self as any).DOMException.prototype = Object.create(Error.prototype);
    (self as any).DOMException.prototype.constructor = (self as any).DOMException;
  }

  function fetch(input: any, init: any) {
    return new Promise(function (resolve, reject) {
      // @ts-ignore
      var request = new Request(input, init);

      if (request.signal && request.signal.aborted) {
        return reject(new (self as any).DOMException('Aborted', 'AbortError'))
      }

      var xhr = new XMLHttpRequest();

      function abortXhr() {
        xhr.abort();
      }

      xhr.onload = function () {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        };
        (options as any).url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL');
        var body = 'response' in xhr ? xhr.response : (xhr as any).responseText;
        // @ts-ignore
        resolve(new Response(body, options));
      };

      xhr.onerror = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.ontimeout = function () {
        reject(new TypeError('Network request failed'));
      };

      xhr.onabort = function () {
        reject(new (self as any).DOMException('Aborted', 'AbortError'));
      };

      xhr.open(request.method, request.url, true);

      if (request.credentials === 'include') {
        xhr.withCredentials = true;
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false;
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob';
      }

      request.headers.forEach(function (value: any, name: any) {
        xhr.setRequestHeader(name, value);
      });

      if (request.signal) {
        request.signal.addEventListener('abort', abortXhr);

        xhr.onreadystatechange = function () {
          // DONE (success or failure)
          if (xhr.readyState === 4) {
            request.signal.removeEventListener('abort', abortXhr);
          }
        };
      }

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit);
    })
  }

  fetch.polyfill = true;

  if (!self.fetch) {
    (self as any).fetch = fetch;
    (self as any).Headers = Headers;
    (self as any).Request = Request;
    (self as any).Response = Response;
  }
})();

export enum AvoEnv {
  Prod = "prod",
  Dev = "dev",
}

export interface CustomDestination {
  make?(env: AvoEnv, apiKey: string): void;
  logEvent?: (eventName: string, eventProperties: Record<string, any>) => void;
  setUserProperties?: (userId: string, userProperties: Record<string, any>) => void;
  identify?: (userId: string) => void;
  unidentify?: () => void;
  logPage?: (pageName: string, eventProperties: Record<string, any>) => void;
  revenue?: (amount: number, eventProperties: Record<string, any>) => void;
  setGroupProperties?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  addCurrentUserToGroup?: (
    groupType: string,
    groupId: string,
    groupProperties: Record<string, any>,
  ) => void;
  logEventWithGroups?: (
    eventName: string,
    eventProperties: any,
    groupTypesToGroupIds: Record<string, string>,
  ) => void;
}

// @ts-ignore
interface AvoAssertMessage {
  eventName?: string;
  tag?: string;
  propertyId?: string;
  message?: string;
  additionalProperties?: string[],
  shape?: any,
  shapeUserProps?: any,
  actualType?: string
}

let __AVO_ENV__: AvoEnv | null = null;
// @ts-ignore
let __AVO_NOOP__: boolean = false;
// @ts-ignore
let __AVO_LOGGER__: AvoLogger | null = null;
// @ts-ignore
let __STRICT__: boolean | null = null;
// @ts-ignore
let __REPORT_FAILURE_AS__: 'error' | 'warn' | 'log' | null = null;

// @ts-ignore
let __WEB_DEBUGGER__: boolean = true;
export const avoInspectorApiKey = "2GQRkd2H3Rnk4FV16NaK";
// @ts-ignore
interface AvoInspector {}
let __INSPECTOR__: AvoInspector | null = null;


// polyfill Object.assign
// @ts-ignore
declare interface ObjectConstructor {
  assign: any;
}
// @ts-ignore
if (typeof Object.assign !== 'function') {
  // Must be writable: true, enumerable: false, configurable: true
  Object.defineProperty(Object, "assign", {
    value: function assign(target: any, _varArgs: any) { // .length of function is 2
      if (target == null) { // TypeError if undefined or null
        throw new TypeError('Cannot convert undefined or null to object');
      }

      let to = Object(target);

      for (let index = 1; index < arguments.length; index++) {
        let nextSource = arguments[index];

        if (nextSource != null) { // Skip over if undefined or null
          for (let nextKey in nextSource) {
            // Avoid bugs when hasOwnProperty is shadowed
            if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
              to[nextKey] = nextSource[nextKey];
            }
          }
        }
      }
      return to;
    },
    writable: true,
    configurable: true
  });
}

interface AvoLogger {
  logDebug(env: AvoEnv | null, message: string): boolean;
  logWarn(env: AvoEnv | null, message: string): boolean;
  logError(env: AvoEnv | null, error: string): boolean;
}

enum webDebuggerArea {
  BottomRight = "BottomRight",
  BottomLeft = "BottomLeft",
  TopRight = "TopRight",
  TopLeft = "TopLeft"
}

interface bottomRightParameters {
  bottom: number;
  right: number;
}

interface bottomLeftParameters {
  bottom: number;
  left: number;
}

interface topRightParameters {
  top: number;
  right: number;
}

interface topLeftParameters {
  top: number;
  left: number;
}

interface webDebuggerPosition {
  position: webDebuggerArea;
  top?: number;
  right?: number;
  bottom?: number;
  left?: number;
}

interface webDebuggerOptions {
  position?: webDebuggerPosition;
}

interface WebDebuggerPositionSetter {
  BottomRight(p: bottomRightParameters): webDebuggerPosition;
  BottomLeft(p: bottomLeftParameters): webDebuggerPosition;
  TopRight(p: topRightParameters): webDebuggerPosition;
  TopLeft(p: topLeftParameters): webDebuggerPosition;
}

export const WebDebuggerPosition: WebDebuggerPositionSetter = {
  BottomRight: ({ bottom, right }) => ({
    position: webDebuggerArea.BottomRight,
    bottom,
    right,
  }),
  BottomLeft: ({ bottom, left }) => ({
    position: webDebuggerArea.BottomLeft,
    bottom,
    left,
  }),
  TopRight: ({ top, right }) => ({
    position: webDebuggerArea.TopRight,
    top,
    right,
  }),
  TopLeft: ({ top, left }) => ({
    position: webDebuggerArea.TopLeft,
    top,
    left,
  }),
}


let InternalAvoLogger: any = {
  logEventSent: function logEventSent(eventName: string, eventProperties: any, userProperties: any) {
    const message = "Event Sent:" + eventName + "Event Props:" + JSON.stringify(eventProperties) + "User Props:" + JSON.stringify(userProperties);

    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] Event Sent:", eventName, "Event Props:", eventProperties, "User Props:", userProperties);
  },

  log: function log(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logDebug && __AVO_LOGGER__.logDebug(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.log("[avo] " + message);
  },

  warn: function warn(message: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logWarn && __AVO_LOGGER__.logWarn(__AVO_ENV__, message)) {
      return
    }
    typeof console !== 'undefined' && console.warn("[avo] " + message);
  },

  error: function error(message: string, error: string) {
    if (__AVO_LOGGER__ && __AVO_LOGGER__.logError && __AVO_LOGGER__.logError(__AVO_ENV__, message + error)) {
      return
    }
    typeof console !== 'undefined' && console.error("[avo] " + message, error);
  }
};

function convertPropertiesArrayToMap(propertiesArray: [{id: string, name: string, value: string}]): {string: string | null | undefined} {
    let result: {string: string} = {}

    propertiesArray.forEach(value => {
      result[value.name] = value.value
    })

    return result
}

// @ts-ignore
let array_difference: any;
// @ts-ignore
let AvoAssert: any;
array_difference = function array_difference(a1: any[], a2: any[]) {
  let result: any[] = [];
  for (let i = 0; i < a1.length; i++) {
    if (a2.indexOf(a1[i]) === -1) {
      result.push(a1[i]);
    }
  }
  return result;
}

AvoAssert = {
  assertObject: function assertObject(propertyId: string, propName: string, obj: any) {
    if (typeof obj !== 'object') {
      let message = propName +
          ' should be of type object but you provided type ' +
          typeof obj +
          ' with value ' +
          JSON.stringify(obj);
      return [{tag: 'expectedObjectType', propertyId, message, actualType: typeof obj}];
    } else {
      return [];
    }
  },

  assertString: function assertString(propertyId: string, propName: string, str: string) {
    if (typeof str !== 'string') {
      let message = propName +
          ' should be of type string but you provided type ' +
          typeof str +
          ' with value ' +
          JSON.stringify(str);
      return [{tag: 'expectedStringType', propertyId, message, actualType: typeof str}];
    } else {
      return [];
    }
  },

  assertInt: function assertInt(propertyId: string, propName: string, int: number) {
    if (typeof int === 'number' && int !== Math.round(int)) {
      let message = propName +
          ' should be of type int but you provided type float with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: 'float'}];
    } else if (typeof int !== 'number') {
      let message = propName +
          ' should be of type int but you provided type ' +
          typeof int +
          ' with value ' +
          JSON.stringify(int);
      return [{tag: 'expectedIntType', propertyId, message, actualType: typeof int}];
    } else {
      return [];
    }
  },

  assertLong: function assertLong(propertyId: string, propName: string, long: number) {
    if (typeof long === 'number' && long !== Math.round(long)) {
      let message = propName +
          ' should be of type long but you provided type float with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: 'float'}];
    } else if (typeof long !== 'number') {
      let message = propName +
          ' should be of type long but you provided type ' +
          typeof long +
          ' with value ' +
          JSON.stringify(long);
      return [{tag: 'expectedLongType', propertyId, message, actualType: typeof long}];
    } else {
      return [];
    }
  },

  assertFloat: function assertFloat(propertyId: string, propName: string, float: number) {
    if (typeof float !== 'number') {
      let message = propName +
          ' should be of type float but you provided type ' +
          typeof float +
          ' with value ' +
          JSON.stringify(float);
      return [{tag: 'expectedFloatType', propertyId, message, actualType: typeof float}];
    } else {
      return [];
    }
  },

  assertBool: function assertBool(propertyId: string, propName: string, bool: boolean) {
    if (typeof bool !== 'boolean') {
      let message = propName +
          ' should be of type boolean but you provided type ' +
          typeof bool +
          ' with value ' +
          JSON.stringify(bool);
      return [{tag: 'expectedBoolType', propertyId, message, actualType: typeof bool}];
    } else {
      return [];
    }
  },

  assertMax: function assertMax(
    propertyId: string,
    propName: string,
    max: number,
    value: number
  ) {
    if (value > max) {
      let message = propName +
        ' has a maximum value of ' +
        max +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMax', propertyId, message}];
    } else {
      return [];
    }
  },

  assertMin: function assertMin(
    propertyId: string,
    propName: string,
    min: number,
    value: number
  ) {
    if (value < min) {
      let message = propName +
        ' has a minimum value of ' +
        min +
        ' but you provided the value ' +
        JSON.stringify(value);
      return [{tag: 'expectedMin', propertyId, message}];
    } else {
      return [];
    }
  },

  assertList: function assertList(propertyId: string, propName: string, value: any) {
    if (!Array.isArray(value)) {
      let message = propName + ' should be of type list but you provided type ' + typeof value;
      return [{tag: 'expectedList', propertyId, message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },

  assertNoAdditionalUserProperties: function assertNoAdditionalProperties(eventName: string, input: string[], spec: string[]) {
    let additionalKeys = array_difference(input, spec);
    if (additionalKeys.length) {
      let message = "Additional user properties when sending event " + eventName + ": " + JSON.stringify(additionalKeys);
      return [{tag: 'expectedNoAdditionalUserProperties', additionalProperties: additionalKeys, message: message}];
    } else {
      return [];
    }
  },
};

let _avo_invoke: any;
let _avo_invoke_meta: any;
let _avo_sampling_rate = 1.0;
_avo_invoke = function _avo_invoke(env: AvoEnv, eventId: string, hash: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "WeYDVJWJg3q3psERddU3",
          "br": "master",
          "en": env,
          "ev": eventId,
          "ha": hash,
          "sc": "5PhajbVijwhXVKIJtGMT",
          "se": (new Date()).toISOString(),
          "so": "OXY1Uf7nb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}

_avo_invoke_meta = function _avo_invoke_meta(env: AvoEnv, type: string, messages: {tag: string, propertyId: string}[], origin: string) {
  // @ts-ignore
  if (typeof (window as any) === 'undefined') { return; }
  if (_avo_sampling_rate > 0) {
    if (Math.random() < _avo_sampling_rate) {
      // @ts-ignore
      fetch("https://api.avo.app/i", {
        method: "POST",
        headers: {"Content-Type": "application/json"},
        body: JSON.stringify({
          "ac": "WeYDVJWJg3q3psERddU3",
          "br": "master",
          "en": env,
          "ty": type,
          "sc": "5PhajbVijwhXVKIJtGMT",
          "se": (new Date()).toISOString(),
          "so": "OXY1Uf7nb",
          "va": messages.length === 0,
          "me": messages,
          "or": origin
        })
      }).then(function(res: any) { return res.json(); }).then(function(data: any) { _avo_sampling_rate = data.sa; }).catch(function() {});
    }
  }
}


let _avo_debugger_log: any;
let _avo_debugger_events_during_boot: any = [];
let _avo_debugger_ready = false;

if (typeof (window as any) !== 'undefined') {
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    let iframe: any = document.getElementById("avo-debugger");
    if (iframe && event && event.data && event.data.type_ === "avo-debugger-update-style") {
      iframe.style = event.data.style;
    } else if (iframe && event && event.data && event.data.type_ === "avo-debugger-ready") {
      let message = {
        type_: "avo-debugger-boot-events",
        schemaId: "5PhajbVijwhXVKIJtGMT",
        href: window.location.href,
        events: _avo_debugger_events_during_boot
      };
      _avo_debugger_events_during_boot = [];
      _avo_debugger_ready = true;
      iframe.contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  });
}

_avo_debugger_log = function _avo_debugger_log(eventId: string, eventName: string, messages: any[], eventProperties: any[], userProperties: any[], groupProperties: any[]) {
  if (typeof (window as any) === 'undefined') { return; }
  let event = {
    eventId: eventId,
    eventName: eventName,
    messages: messages,
    timestamp: Date.now(),
    eventProperties,
    userProperties,
    groupProperties
  };

  if (_avo_debugger_ready) {
    let message = {type_: "avo-debugger-events", events: [event]};
    (document.getElementById("avo-debugger") as any).contentWindow.postMessage(message, "https://www.avo.app/_debugger")
  } else {
    _avo_debugger_events_during_boot.push(event);
  }
}

function _avo_debugger_send_position(position: webDebuggerPosition) {
  if (typeof window === 'undefined') { return; }
  window.addEventListener("message", function(event) {
    if (event.origin !== "https://www.avo.app") {
      return;
    }
    if (event.data.type_ === "avo-debugger-ready" && position !== null) {
      var message = {type_: "avo-debugger-position", position: position};
      document.getElementById("avo-debugger").contentWindow.postMessage(message, "https://www.avo.app/_debugger")
    }
  })
}


export interface PupilExitQuiz {
  questionResult: QuestionResultValueType
  questionType: string
  hintOffered: boolean
  hintAccessed: boolean
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType
  questionNumber: number
}

export interface TeacherSchoolManualEntryDetails {
  schoolNameText: string
  schoolAddressText: string
}

export interface PupilStarterQuiz {
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType
  questionType: string
  questionResult: QuestionResultValueType
  hintOffered: boolean
  hintAccessed: boolean
  questionNumber: number
}

export interface AccessBlockDetails {
}

export interface ActiveFilters {
}

export const RetryTarget = {
  'SUGGESTIONS': 'suggestions',
  'TRANSFORMATION': 'transformation',
} as const;
export type RetryTargetType = typeof RetryTarget;
export type RetryTargetValueType = RetryTargetType[keyof RetryTargetType];

export const SearchFilterMatchType = {
  'AI': 'ai',
  'DEFAULT': 'default',
  'FUZZY_MATCH': 'fuzzy_match',
} as const;
export type SearchFilterMatchTypeType = typeof SearchFilterMatchType;
export type SearchFilterMatchTypeValueType = SearchFilterMatchTypeType[keyof SearchFilterMatchTypeType];

export const SingleSignOnService = {
  'EMAIL': 'Email',
  'GOOGLE': 'Google',
  'MICROSOFT': 'Microsoft',
} as const;
export type SingleSignOnServiceType = typeof SingleSignOnService;
export type SingleSignOnServiceValueType = SingleSignOnServiceType[keyof SingleSignOnServiceType];

export const FilterModificationType = {
  'ADD': 'add',
  'REMOVE': 'remove',
} as const;
export type FilterModificationTypeType = typeof FilterModificationType;
export type FilterModificationTypeValueType = FilterModificationTypeType[keyof FilterModificationTypeType];

export const ModeratedContentType = {
  'LANGUAGE_AND_DISCRIMINATION': 'language and discrimination',
  'VIOLENCE_AND_CRIME': 'violence and crime',
  'UPSETTING_DISTURBING_SENSITIVE': 'upsetting disturbing sensitive',
  'NUDITY_AND_SEX': 'nudity and sex',
  'PHYSICAL_SAFETY': 'physical safety',
  'TOXIC': 'toxic',
} as const;
export type ModeratedContentTypeType = typeof ModeratedContentType;
export type ModeratedContentTypeValueType = ModeratedContentTypeType[keyof ModeratedContentTypeType];

export const LessonReleaseCohort = {
  '2020_2023': '2020-2023',
  '2023_2026': '2023-2026',
} as const;
export type LessonReleaseCohortType = typeof LessonReleaseCohort;
export type LessonReleaseCohortValueType = LessonReleaseCohortType[keyof LessonReleaseCohortType];

export const EventVersion = {
  '2_0_0': '2.0.0',
} as const;
export type EventVersionType = typeof EventVersion;
export type EventVersionValueType = EventVersionType[keyof EventVersionType];

export const ResourceTypes = {
  'STARTER_QUIZ': 'starter-quiz',
  'EXIT_QUIZ': 'exit-quiz',
  'WORKSHEET': 'worksheet',
  'VIDEO': 'video',
} as const;
export type ResourceTypesType = typeof ResourceTypes;
export type ResourceTypesValueType = ResourceTypesType[keyof ResourceTypesType];

export const VideoLocation = {
  'WEBINAR': 'webinar',
  'MARKETING': 'marketing',
  'LESSON': 'lesson',
  'BLOG': 'blog',
  'PUPIL': 'pupil',
  'MEDIA_CLIPS': 'media clips',
} as const;
export type VideoLocationType = typeof VideoLocation;
export type VideoLocationValueType = VideoLocationType[keyof VideoLocationType];

export const UserAccountVerificationStatus = {
  'AWAITING_VERIFICATION': 'awaiting-verification',
  'DELETED': 'deleted',
  'DISABLED': 'disabled',
  'VERIFIED': 'verified',
} as const;
export type UserAccountVerificationStatusType = typeof UserAccountVerificationStatus;
export type UserAccountVerificationStatusValueType = UserAccountVerificationStatusType[keyof UserAccountVerificationStatusType];

export const ResourceFileType = {
  'SHARE_TO_GOOGLE_DRIVE': 'share to google drive',
  'PDF': 'pdf',
  'DOCX': 'docx',
  'PPTX': 'pptx',
  'ALL': 'all',
} as const;
export type ResourceFileTypeType = typeof ResourceFileType;
export type ResourceFileTypeValueType = ResourceFileTypeType[keyof ResourceFileTypeType];

export const ExamBoard = {
  'AQA': 'AQA',
  'EDEXCEL': 'Edexcel',
  'EDUQAS': 'Eduqas',
  'OCR': 'OCR',
  'WJEC': 'WJEC',
  'EDEXCEL_B': 'Edexcel B',
} as const;
export type ExamBoardType = typeof ExamBoard;
export type ExamBoardValueType = ExamBoardType[keyof ExamBoardType];

export const Context = {
  'HOMEPAGE': 'homepage',
  'SEARCH': 'search',
  'CAMPAIGN': 'campaign',
} as const;
export type ContextType = typeof Context;
export type ContextValueType = ContextType[keyof ContextType];

export const ClientEnvironment = {
  'IFRAME': 'iframe',
  'NATIVE_APP': 'native-app',
  'WEB_BROWSER': 'web-browser',
} as const;
export type ClientEnvironmentType = typeof ClientEnvironment;
export type ClientEnvironmentValueType = ClientEnvironmentType[keyof ClientEnvironmentType];

export const ComponentType = {
  'HAMBURGER_MENU_BUTTON': 'hamburger_menu_button',
  'TEXT_INPUT': 'text_input',
  'REGENERATE_RESPONSE_BUTTON': 'regenerate_response_button',
  'SELECT_OAK_LESSON': 'select_oak_lesson',
  'TYPE_EDIT': 'type_edit',
  'LESSON_FINISH_CHECK': 'lesson_finish_check',
  'CONTINUE_BUTTON': 'continue_button',
  'CONTINUE_TEXT': 'continue_text',
  'GO_TO_SHARE_PAGE_BUTTON': 'go_to_share_page_button',
  'EXAMPLE_LESSON_BUTTON': 'example_lesson_button',
  'HOMEPAGE_PRIMARY_CREATE_A_LESSON_BUTTON': 'homepage_primary_create_a_lesson_button',
  'HOMEPAGE_SECONDARY_CREATE_A_LESSON_BUTTON': 'homepage_secondary_create_a_lesson_button',
  'FOOTER_MENU_LINK': 'footer_menu_link',
  'FILTER_LINK': 'filter_link',
  'KEYSTAGE_KEYPAD_BUTTON': 'keystage_keypad_button',
  'LESSON_CARD': 'lesson_card',
  'LESSON_DOWNLOAD_BUTTON': 'lesson_download_button',
  'PROGRAMME_CARD': 'programme_card',
  'SEARCH_BUTTON': 'search_button',
  'SEARCH_RESULT_ITEM': 'search_result_item',
  'SHARE_BUTTON': 'share_button',
  'SUBJECT_CARD': 'subject_card',
  'UNIT_CARD': 'unit_card',
  'SIGNUP_FORM': 'signup_form',
  'SKIP_BUTTON': 'skip_button',
  'PAGE_VIEW': 'page view',
  'YEAR_KEYPAD_BUTTON': 'year_keypad_button',
  'UNIT_DOWNLOAD_BUTTON': 'unit_download_button',
  'SEARCH_GET_STARTED_BUTTON': 'search_get_started_button',
  'AIMS_AND_PURPOSE': 'aims_and_purpose',
  'CURICULUM_COHERENCE': 'curiculum_coherence',
  'CURRICULUM_DELIVERY': 'curriculum_delivery',
  'CURRICULUM_VISUALISER_BUTTON': 'curriculum_visualiser_button',
  'DOWNLOAD_BUTTON': 'download_button',
  'DOWNLOAD_TAB': 'download_tab',
  'EXPLAINER_TAB': 'explainer_tab',
  'FOLLOWING_UNIT_DESC': 'following_unit_desc',
  'HOMEPAGE_BUTTON': 'homepage_button',
  'HOMEPAGE_TAB': 'homepage_tab',
  'LANDING_PAGE_BUTTON': 'landing_page_button',
  'LEARNING_TIER_BUTTON': 'learning_tier_button',
  'LESSONS_IN_UNIT': 'lessons_in_unit',
  'NATIONAL_CURRICULUM': 'national_curriculum',
  'OAK_CURRICULUM_PRINCIPLES': 'oak_curriculum_principles',
  'OAK_SUBJECT_PRINCIPLES': 'oak_subject_principles',
  'OUR_CURRICULUM_PARTNER': 'our_curriculum_partner',
  'PREVIOUS_UNIT_DESC': 'previous_unit_desc',
  'RECOMMENDATIONS_FROM_SUBJECT_SPECIFIC_REPORTS': 'recommendations_from_subject_specific_reports',
  'SEE_LESSONS_IN_UNIT_BUTTON': 'see_lessons_in_unit_button',
  'SUBJECT_CATEGORY_BUTTON': 'subject_category_button',
  'SUBJECT_SPECIFIC_NEEDS': 'subject_specific_needs',
  'UNIT_INFO_BUTTON': 'unit_info_button',
  'UNIT_SEQUENCE_TAB': 'unit_sequence_tab',
  'VIDEO': 'video',
  'WHY_THIS_WHY_NOW': 'why_this_why_now',
  'YEAR_GROUP_BUTTON': 'year_group_button',
  'ADD_ADDITIONAL_MATERIALS_BUTTON': 'add_additional_materials_button',
  'MODIFY_BUTTON': 'modify_button',
  'EXAM_SUBJECT_BUTTON': 'exam_subject_button',
  'GO_TO_MEDIA_CLIPS_PAGE_BUTTON': 'go_to_media_clips_page_button',
  'MEDIA_CLIPS_PLAYED': 'media_clips_played',
  'LESSON_LISTING_SAVE_BUTTON': 'lesson_listing_save_button',
  'UNIT_LISTING_SAVE_BUTTON': 'unit_listing_save_button',
  'MY_LIBRARY_SAVE_BUTTON': 'my-library-save-button',
  'BACK_A_STEP_BUTTON': 'back_a_step_button',
  'CREATE_ADDITIONAL_MATERIALS_BUTTON': 'create_additional_materials_button',
  'CREATE_TEACHING_MATERIAL_BUTTON': 'create_teaching_material_button',
  'GENERATE_OVERVIEW': 'generate_overview',
  'INCREASE_READING_AGE_BUTTON': 'increase_reading_age_button',
  'LESSON_DETAILS_BUTTON': 'lesson_details_button',
  'LESSON_SUMMARY_BUTTON': 'lesson_summary_button',
  'LOWER_READING_AGE_BUTTON': 'lower_reading_age_button',
  'UNDO_BUTTON': 'undo_button',
  'LESSON_DOWNLOADS': 'lesson_downloads',
  'LESSON_LISTING': 'lesson_listing',
  'LESSON_MEDIA_CLIPS': 'lesson_media_clips',
  'LESSON_OVERVIEW': 'lesson_overview',
  'ALL_FILTERS': 'all_filters',
  'SUGGESTED_FILTER': 'suggested_filter',
  'CREATE_MORE_WITH_AI_BUTTON': 'create_more_with_ai_button',
  'CREATE_MORE_WITH_AI_DROPDOWN': 'create_more_with_ai_dropdown',
  'CHILD_SUBJECT_BUTTON': 'child_subject_button',
  'TOPNAV_BROWSE_BUTTON': 'topnav-browse-button',
  'ABOUT_CURRICULUM': 'about_curriculum',
  'ABOUT_OAK': 'about_oak',
  'ABOUT_US_FOOTER': 'about_us_footer',
  'FREELANCE_ROLES': 'freelance_roles',
  'GET_IN_TOUCH': 'get_in_touch',
  'GET_INVOLVED': 'get_involved',
  'JOIN_RESEARCH_PANEL': 'join_research_panel',
  'MEET_THE_TEAM': 'meet_the_team',
  'OAKS_IMPACT': 'oaks_impact',
  'PERMANENT_ROLES': 'permanent_roles',
  'IMPLEMENTATION_GUIDE_CALLOUT': 'implementation_guide_callout',
  'BREADCRUMB': 'breadcrumb',
  'PROMO_CARD': 'promo_card',
  'TEACH_WITH_OAK_BACK_TO_LESSON': 'teach_with_oak_back_to_lesson',
  'TEACHER_TIP': 'teacher_tip',
  'VIEW_ALL_BUTTON': 'view_all_button',
  'ACCEPT_BUTTON': 'accept_button',
  'GENERATE_NEW_SUGGESTIONS_BUTTON': 'generate_new_suggestions_button',
  'NO_SCAFFOLD_REQUIRED_BUTTON': 'no_scaffold_required_button',
  'REMOVE_ALL_SCAFFOLDS_BUTTON': 'remove_all_scaffolds_button',
  'REMOVE_SCAFFOLD_BUTTON': 'remove_scaffold_button',
  'RESOURCE_ADAPTER_BUTTON': 'resource_adapter_button',
  'RESOURCE_ADAPTER_DIALOG': 'resource_adapter_dialog',
  'RESOURCE_ADAPTER_MENU_ITEM': 'resource_adapter_menu_item',
  'RETRY_BUTTON': 'retry_button',
  'START_AGAIN_BUTTON': 'start_again_button',
  'START_FROM_ORIGINAL_BUTTON': 'start_from_original_button',
  'SUGGESTION_BUTTON': 'suggestion_button',
  'TRY_AGAIN_BUTTON': 'try_again_button',
  'CASE_STUDIES': 'case_studies',
} as const;
export type ComponentTypeType = typeof ComponentType;
export type ComponentTypeValueType = ComponentTypeType[keyof ComponentTypeType];

export const MediaClipsButtonName = {
  'PLAY_ALL': 'play all',
  'SELECT_CLIP': 'select clip',
} as const;
export type MediaClipsButtonNameType = typeof MediaClipsButtonName;
export type MediaClipsButtonNameValueType = MediaClipsButtonNameType[keyof MediaClipsButtonNameType];

export const SchoolOption = {
  'HOMESCHOOL': 'Homeschool',
  'NOT_LISTED': 'Not listed',
  'SELECTED_SCHOOL': 'Selected school',
} as const;
export type SchoolOptionType = typeof SchoolOption;
export type SchoolOptionValueType = SchoolOptionType[keyof SchoolOptionType];

export const AnalyticsUseCase = {
  'PUPIL': 'Pupil',
  'TEACHER': 'Teacher',
} as const;
export type AnalyticsUseCaseType = typeof AnalyticsUseCase;
export type AnalyticsUseCaseValueType = AnalyticsUseCaseType[keyof AnalyticsUseCaseType];

export const QuestionResult = {
  'CORRECT': 'correct',
  'INCORRECT': 'incorrect',
} as const;
export type QuestionResultType = typeof QuestionResult;
export type QuestionResultValueType = QuestionResultType[keyof QuestionResultType];

export const DownloadResourceButtonName = {
  'ALL': 'all',
  'WORKSHEET': 'worksheet',
  'STARTER_QUIZ': 'starter quiz',
  'EXIT_QUIZ': 'exit quiz',
  'SLIDE_DECK': 'slide deck',
  'ADDITIONAL_MATERIAL': 'additional material',
  'LESSON_FILES': 'lesson files',
  'LESSON_GUIDE': 'lesson guide',
} as const;
export type DownloadResourceButtonNameType = typeof DownloadResourceButtonName;
export type DownloadResourceButtonNameValueType = DownloadResourceButtonNameType[keyof DownloadResourceButtonNameType];

export const ResourceType = {
  'SLIDE_DECK': 'slide deck',
  'STARTER_QUIZ_QUESTIONS': 'starter quiz questions',
  'STARTER_QUIZ_ANSWERS': 'starter quiz answers',
  'EXIT_QUIZ_QUESTIONS': 'exit quiz questions',
  'EXIT_QUIZ_ANSWERS': 'exit quiz answers',
  'WORKSHEET_PDF': 'worksheet pdf',
  'WORKSHEET_PPTX': 'worksheet pptx',
  'LESSON_PLAN': 'lesson plan',
  'STARTER_QUIZ': 'starter quiz',
  'EXIT_QUIZ': 'exit quiz',
  'WORKSHEET': 'worksheet',
  'ADDITIONAL_MATERIALS': 'additional materials',
  'CURRICULUM_DOCUMENT': 'curriculum document',
  'CURRICULUM_PLAN': 'curriculum plan',
  'PREVIOUSLY_RELEASED_CURRICULUM_PLAN': 'previously released curriculum plan',
  'LESSON_FILES': 'lesson files',
  'LESSON_GUIDE': 'lesson guide',
  'TEACHING_MATERIAL': 'teaching material',
  'ASSESSMENT': 'assessment',
  'COMMON_QUESTIONS': 'common questions',
  'CURRICULUM_QUALITY': 'curriculum quality',
  'EQUIPMENT_LIST': 'equipment list',
  'WHATS_INCLUDED': 'what\'s included',
} as const;
export type ResourceTypeType = typeof ResourceType;
export type ResourceTypeValueType = ResourceTypeType[keyof ResourceTypeType];

export const TierName = {
  'CORE': 'Core',
  'FOUNDATION': 'Foundation',
  'HIGHER': 'Higher',
} as const;
export type TierNameType = typeof TierName;
export type TierNameValueType = TierNameType[keyof TierNameType];

export const Product = {
  'AI_LESSON_ASSISTANT': 'ai lesson assistant',
  'CURRICULUM_RESOURCES': 'curriculum resources',
  'CURRICULUM_VISUALISER': 'curriculum visualiser',
  'PUPIL_LESSON_ACTIVITIES': 'pupil lesson activities',
  'TEACHER_LESSON_RESOURCES': 'teacher lesson resources',
  'USER_ACCOUNT_MANAGEMENT': 'user account management',
  'MEDIA_CLIPS': 'media clips',
  'TEACHING_MATERIAL': 'teaching material',
  'ABOUT_US': 'about us',
  'GOOGLE_CLASSROOM_ADDON': 'google classroom addon',
  'RESOURCE_ADAPTER': 'resource adapter',
} as const;
export type ProductType = typeof Product;
export type ProductValueType = ProductType[keyof ProductType];

export const JobKind = {
  'SUGGESTIONS_APPLY': 'suggestions.apply',
  'SUGGESTIONS_GENERATE': 'suggestions.generate',
  'TRANSFORMATIONS_DISMISS': 'transformations.dismiss',
  'TRANSFORMATIONS_REMOVE': 'transformations.remove',
  'TRANSFORMATIONS_RETRY': 'transformations.retry',
} as const;
export type JobKindType = typeof JobKind;
export type JobKindValueType = JobKindType[keyof JobKindType];

export const PageName = {
  'SUBJECT_LISTING': 'Subject Listing',
  'UNIT_LISTING': 'Unit Listing',
  'HOMEPAGE': 'Homepage',
  'LESSON_LISTING': 'Lesson Listing',
  'LESSON': 'Lesson',
  'WEBINAR': 'Webinar',
  'BLOG': 'Blog',
  'PLAN_A_LESSON': 'Plan a Lesson',
  'DEVELOP_YOUR_CURRICULUM': 'Develop Your Curriculum',
  'SUPPORT_YOUR_TEAM': 'Support Your Team',
  'SEARCH': 'Search',
  'LESSON_DOWNLOAD': 'Lesson Download',
  'UNIT_DOWNLOAD': 'Unit Download',
  'BLOG_LISTING': 'Blog Listing',
  'WEBINAR_LISTING': 'Webinar Listing',
  'PROGRAMME_LISTING': 'Programme Listing',
  'CONTACT_US': 'Contact Us',
  'ABOUT_US_BOARD': 'About Us: Board',
  'ABOUT_US_WHO_WE_ARE': 'About Us: Who We Are',
  'ABOUT_US_LEADERSHIP': 'About Us: Leadership',
  'ABOUT_US_PARTNERS': 'About Us: Partners',
  'ABOUT_US_WORK_WITH_US': 'About Us: Work With Us',
  'LEGAL': 'Legal',
  'LANDING_PAGE': 'Landing Page',
  'EARLY_RELEASE_UNITS_PAGE': 'Early Release Units Page',
  'CURRICULUM_LANDING_PAGE': 'Curriculum Landing Page',
  'CURRICULUM_OVERVIEW': 'Curriculum Overview',
  'CURRICULUM_UNIT_SEQUENCE': 'Curriculum Unit Sequence',
  'CURRICULUM_DOWNLOADS': 'Curriculum Downloads',
  'LESSON_SHARE': 'Lesson Share',
  'CURRICULUM_PREVIOUS_DOWNLOADS': 'Curriculum Previous Downloads',
  'ONBOARDING_SCHOOL_SELECTION': 'Onboarding: School Selection',
  'ONBOARDING_ROLE_SELECTION': 'Onboarding: Role Selection',
  'ONBOARDING_WORK_IN_SCHOOL': 'Onboarding: Work In School',
  'ONBOARDING_USE_OF_OAK': 'Onboarding: Use Of Oak',
  'LESSON_MEDIA': 'Lesson Media',
  'MY_LIBRARY': 'My library',
  'CAMPAIGN': 'Campaign',
  'ABOUT_US_GET_INVOLVED': 'About Us: Get Involved',
  'ABOUT_US_MEET_THE_TEAM': 'About Us: Meet the team',
  'ABOUT_US_MEET_THE_TEAM_BIO': 'About Us: Meet the team Bio',
  'ABOUT_US_OAKS_CURRICULA': 'About Us: Oak\'s curricula',
  'CLASSROOM_AUTH_SUCCESS': 'Classroom: Auth Success',
  'CLASSROOM_BROWSE_YEARS': 'Classroom: Browse Years',
  'CLASSROOM_LESSONS': 'Classroom: Lessons',
  'CLASSROOM_PROGRAMME_OPTIONS': 'Classroom: Programme Options',
  'CLASSROOM_PUPIL_SIGN_IN': 'Classroom: Pupil Sign In',
  'CLASSROOM_SIGN_IN': 'Classroom: Sign In',
  'CLASSROOM_SUBJECTS': 'Classroom: Subjects',
  'CLASSROOM_UNITS': 'Classroom: Units',
  'ABOUT_US_CASE_STUDY': 'About Us: Case Study',
  'ABOUT_US_OAKS_IMPACT': 'About Us: Oak\'s Impact',
  'TEACH_WITH_OAK': 'Teach With Oak',
  'TEACH_WITH_OAK_DOWNLOAD': 'Teach With Oak: Download',
  'AI_PLUGIN': 'AI Plugin',
  'ABOUT_US_CASE_STUDY_LIBRARY': 'About Us: Case Study Library',
  'ABOUT_US_JOIN_RESEARCH_PANEL': 'About Us: Join Research Panel',
} as const;
export type PageNameType = typeof PageName;
export type PageNameValueType = PageNameType[keyof PageNameType];

export const Platform = {
  'OWA': 'owa',
  'AILA_BETA': 'aila-beta',
  'GOOGLE_CLASSROOM': 'google-classroom',
} as const;
export type PlatformType = typeof Platform;
export type PlatformValueType = PlatformType[keyof PlatformType];

export const NavigationType = {
  'ACROSS': 'across',
  'BROADEN': 'broaden',
  'NARROW': 'narrow',
} as const;
export type NavigationTypeType = typeof NavigationType;
export type NavigationTypeValueType = NavigationTypeType[keyof NavigationTypeType];

export const Format = {
  'DOCX': 'docx',
} as const;
export type FormatType = typeof Format;
export type FormatValueType = FormatType[keyof FormatType];

export const ContentGuidanceWarning = {
  'LANGUAGE_AND_DISCRIMINATION': 'Language and discrimination',
  'NUDITY_AND_SEX': 'Nudity and sex',
  'PHYSICAL_ACTIVITY_AND_EQUIPMENT_REQUIRING_SAFE_USE': 'Physical activity and equipment requiring safe use',
  'UPSETTING_DISTRIBUTING_AND_SENSITIVE': 'Upsetting, distributing and sensitive',
} as const;
export type ContentGuidanceWarningType = typeof ContentGuidanceWarning;
export type ContentGuidanceWarningValueType = ContentGuidanceWarningType[keyof ContentGuidanceWarningType];

export const Phase = {
  'PRIMARY': 'primary',
  'SECONDARY': 'secondary',
} as const;
export type PhaseType = typeof Phase;
export type PhaseValueType = PhaseType[keyof PhaseType];

export const UserRoleType = {
  'ADULT_OTHER': 'Adult (Other)',
  'EDUCATIONAL_NOT_FOR_PROFIT_PROFESSIONAL': 'Educational Not-for-Profit Professional',
  'LEA_MAT_PROFESSIONAL': 'LEA/MAT Professional',
  'NON_TEACHER': 'Non Teacher',
  'OTHER': 'Other',
  'PRIVATE_TUTOR': 'Private Tutor',
  'TEACHER': 'Teacher',
  'TEACHER_TRAINING_PROFESSIONAL': 'Teacher Training Professional',
  'TRAINEE_TEACHER': 'Trainee Teacher',
} as const;
export type UserRoleTypeType = typeof UserRoleType;
export type UserRoleTypeValueType = UserRoleTypeType[keyof UserRoleTypeType];

export const PupilExperienceLessonActivity = {
  'INTRO': 'intro',
  'VIDEO': 'video',
  'STARTER_QUIZ': 'starter-quiz',
  'EXIT_QUIZ': 'exit-quiz',
  'AUDIO': 'audio',
} as const;
export type PupilExperienceLessonActivityType = typeof PupilExperienceLessonActivity;
export type PupilExperienceLessonActivityValueType = PupilExperienceLessonActivityType[keyof PupilExperienceLessonActivityType];

export const FilterType = {
  'SUBJECT_FILTER': 'Subject filter',
  'KEY_STAGE_FILTER': 'Key stage filter',
  'CONTENT_TYPE_FILTER': 'Content type filter',
  'EXAM_BOARD_FILTER': 'Exam board filter',
  'EXAM_BOARD_TIER_FILTER': 'Exam board / tier filter',
  'LEARNING_THEME_FILTER': 'Learning theme filter',
  'TIER_FILTER': 'Tier filter',
  'YEAR_FILTER': 'Year filter',
  'LESSON_COHORT_FILTER': 'Lesson Cohort filter',
  'PATHWAY_FILTER': 'Pathway filter',
  'UNIT_FILTER': 'Unit filter',
  'PHASE_FILTER': 'Phase filter',
} as const;
export type FilterTypeType = typeof FilterType;
export type FilterTypeValueType = FilterTypeType[keyof FilterTypeType];

export const ShareMedium = {
  'EMAIL': 'email',
  'COPY_LINK': 'copy-link',
  'MICROSOFT_TEAMS': 'microsoft-teams',
  'GOOGLE_CLASSROOM': 'google-classroom',
  'PRINTED': 'printed',
} as const;
export type ShareMediumType = typeof ShareMedium;
export type ShareMediumValueType = ShareMediumType[keyof ShareMediumType];

export const CapabilityId = {
  'WORKSHEET_SCAFFOLDING': 'worksheetScaffolding',
} as const;
export type CapabilityIdType = typeof CapabilityId;
export type CapabilityIdValueType = CapabilityIdType[keyof CapabilityIdType];

export const SearchSource = {
  'HOMEPAGE_SEARCH_BOX': 'homepage search box',
  'SEARCH_PAGE_SEARCH_BOX': 'search page search box',
  'HOMEPAGE_SEARCH_SUGGESTION': 'homepage search suggestion',
  'CAMPAIGN_PAGE': 'campaign page',
  'TOP_NAV': 'top nav',
} as const;
export type SearchSourceType = typeof SearchSource;
export type SearchSourceValueType = SearchSourceType[keyof SearchSourceType];

export const RequestAction = {
  'ACCEPT': 'accept',
  'APPLY': 'apply',
  'DISMISS': 'dismiss',
  'DOWNLOAD': 'download',
  'OPEN': 'open',
  'POLL': 'poll',
  'REFRESH': 'refresh',
  'REMOVE': 'remove',
  'RESUME': 'resume',
  'RETRY': 'retry',
  'UNDO': 'undo',
} as const;
export type RequestActionType = typeof RequestAction;
export type RequestActionValueType = RequestActionType[keyof RequestActionType];

export const StartMode = {
  'NEW': 'new',
  'RESUMED': 'resumed',
} as const;
export type StartModeType = typeof StartMode;
export type StartModeValueType = StartModeType[keyof StartModeType];

export const ReviewAction = {
  'ACCEPT': 'accept',
  'RETRY': 'retry',
  'UNDO': 'undo',
} as const;
export type ReviewActionType = typeof ReviewAction;
export type ReviewActionValueType = ReviewActionType[keyof ReviewActionType];

export const TeachingMaterialType = {
  'COMPREHENSION_TASK': 'comprehension task',
  'EXIT_QUIZ': 'exit quiz',
  'GLOSSARY': 'glossary',
  'STARTER_QUIZ': 'starter quiz',
  'VERBAL_EXPLANATIONS': 'verbal explanations',
} as const;
export type TeachingMaterialTypeType = typeof TeachingMaterialType;
export type TeachingMaterialTypeValueType = TeachingMaterialTypeType[keyof TeachingMaterialTypeType];

export const Pathway = {
  'CORE': 'Core',
  'GCSE': 'GCSE',
} as const;
export type PathwayType = typeof Pathway;
export type PathwayValueType = PathwayType[keyof PathwayType];

export const Audience = {
  'PUPIL': 'Pupil',
  'TEACHER': 'Teacher',
} as const;
export type AudienceType = typeof Audience;
export type AudienceValueType = AudienceType[keyof AudienceType];

export const AccessBlockType = {
  'GEO_RESTRICTION': 'Geo-restriction',
} as const;
export type AccessBlockTypeType = typeof AccessBlockType;
export type AccessBlockTypeValueType = AccessBlockTypeType[keyof AccessBlockTypeType];

export const NavigatedFrom = {
  'HEADER': 'header',
  'FOOTER': 'footer',
  'CARD': 'card',
  'MENU': 'menu',
} as const;
export type NavigatedFromType = typeof NavigatedFrom;
export type NavigatedFromValueType = NavigatedFromType[keyof NavigatedFromType];

export const KeyStageTitle = {
  'KEY_STAGE_1': 'Key stage 1',
  'KEY_STAGE_2': 'Key stage 2',
  'KEY_STAGE_3': 'Key stage 3',
  'KEY_STAGE_4': 'Key stage 4',
  'EARLY_YEARS_FOUNDATION_STAGE': 'Early Years Foundation stage',
  'SPECIALIST': 'Specialist',
  'THERAPIES': 'Therapies',
} as const;
export type KeyStageTitleType = typeof KeyStageTitle;
export type KeyStageTitleValueType = KeyStageTitleType[keyof KeyStageTitleType];

export const AccessLevel = {
  'BLOGS_EMBEDDED_LINKS': 'blogs_embedded_links',
  'DOWNLOAD_CONFIRMATION': 'download_confirmation',
  'HOMEPAGE': 'homepage',
  'LESSON': 'lesson',
  'MY_LIBRARY': 'my_library',
  'PROGRAMME': 'programme',
  'SEARCH': 'search',
  'UNIT': 'unit',
  'TEACH_WITH_OAK': 'teach_with_oak',
} as const;
export type AccessLevelType = typeof AccessLevel;
export type AccessLevelValueType = AccessLevelType[keyof AccessLevelType];

export const SupportLevel = {
  'HIGH': 'high',
  'LOW': 'low',
  'MID': 'mid',
} as const;
export type SupportLevelType = typeof SupportLevel;
export type SupportLevelValueType = SupportLevelType[keyof SupportLevelType];

export const LearningTier = {
  'FOUNDATION': 'Foundation',
  'HIGHER': 'Higher',
} as const;
export type LearningTierType = typeof LearningTier;
export type LearningTierValueType = LearningTierType[keyof LearningTierType];

export const SearchResultType = {
  'UNIT': 'unit',
  'LESSON': 'lesson',
  'SUGGESTION': 'suggestion',
} as const;
export type SearchResultTypeType = typeof SearchResultType;
export type SearchResultTypeValueType = SearchResultTypeType[keyof SearchResultTypeType];

export const EngagementIntent = {
  'EXPLORE': 'explore',
  'REFINE': 'refine',
  'USE': 'use',
  'ADVOCATE': 'advocate',
} as const;
export type EngagementIntentType = typeof EngagementIntent;
export type EngagementIntentValueType = EngagementIntentType[keyof EngagementIntentType];

let PostHogEU: any;

export function initAvo(options: {env: AvoEnv;
    webDebugger?: boolean;
    webDebuggerOptions?: webDebuggerOptions;
    strict?: boolean;
    noop?: boolean;
    reportFailureAs?: 'error' | 'warn' | 'log';
    inspector?: AvoInspector;
    avoLogger?: AvoLogger},
    destinationOptions: any,
    PostHogEUDestination: CustomDestination) {
  if (__AVO_ENV__ !== null) {
    return;
  }
  __AVO_ENV__ = options.env;
  if (options.avoLogger !== undefined) {
    __AVO_LOGGER__ = options.avoLogger;
  }
  if (options.noop === true) {
    __AVO_NOOP__ = true;
  }
  if (__AVO_NOOP__ && __AVO_ENV__ == AvoEnv.Prod) {
    InternalAvoLogger.warn("[avo] ****************************************************");
    InternalAvoLogger.warn("[avo] WARNING Avo cannot be initialized in noop mode in production:");
    InternalAvoLogger.warn("[avo] - Overwriting configuration with noop=false.");
    InternalAvoLogger.warn("[avo] - Please reach out if you want to be able to run Avo in production mode with noop=true");
    InternalAvoLogger.warn("[avo] ****************************************************");
    __AVO_NOOP__ = false;
  }
  if (__AVO_NOOP__) {
    InternalAvoLogger.log("[avo] ****************************************************");
    InternalAvoLogger.log("[avo] Avo is now initialized in noop mode. This means:");
    InternalAvoLogger.log("[avo] - No events will be sent");
    InternalAvoLogger.log("[avo] - No network requests are made");
    InternalAvoLogger.log("[avo] ****************************************************");
  }
  if (options.strict !== undefined) {
    __STRICT__ = options.strict !== false;
  }
  if (options.reportFailureAs !== undefined) {
    __REPORT_FAILURE_AS__ = options.reportFailureAs;
  }
  __WEB_DEBUGGER__ = !__AVO_NOOP__ && ((typeof window !== 'undefined' && (window as any).location.search.indexOf("avo_debug=1") > -1) || (options.webDebugger !== false && __AVO_ENV__ !== AvoEnv.Prod));
  if (!__AVO_NOOP__ && options.inspector !== undefined) {
    __INSPECTOR__ = options.inspector;
  } else if (__AVO_ENV__ !== 'prod') {
    InternalAvoLogger.warn("[avo] Avo Inspector not provided in initAvo() call");
  }
  
  destinationOptions = destinationOptions || {};
  
  if (__WEB_DEBUGGER__ && !__AVO_NOOP__) {
    if (options.webDebuggerOptions?.position) {
      _avo_debugger_send_position(options.webDebuggerOptions.position)
    }

(function() {
  if (typeof (window as any) === 'undefined') { return; }
  let init = function() {
    let iframe: any = document.createElement("iframe");
    document.body.appendChild(iframe);
    iframe.id = "avo-debugger";
    iframe.src = "https://www.avo.app/_debugger";
    iframe.style = "display: none;";
  };

  if (document.body) {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
    
  }
  if (!__AVO_NOOP__) {
    if (__AVO_ENV__ === AvoEnv.Prod) {
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
    }
    
    PostHogEU = PostHogEUDestination;
    if (__AVO_ENV__ === 'prod') {
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    } else if (__AVO_ENV__ === 'dev') {
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    } else {
      console[__REPORT_FAILURE_AS__ || 'error']("[avo] No staging key is set for PostHogEU. Head to destination settings in Avo to set a staging key.");
      PostHogEU && PostHogEU.make && PostHogEU.make(__AVO_ENV__, null);
    }
    if (__AVO_ENV__ === AvoEnv.Dev) {
      // debug console in Avo
      _avo_invoke_meta(__AVO_ENV__, 'init', [], 'init');
    }
  }
}

function assertPupilExitQuizOptional(pupilExitQuiz: PupilExitQuiz[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (pupilExitQuiz !== undefined && pupilExitQuiz !== null) {
    messages = messages.concat(AvoAssert.assertList("BvJKWCkFc", "Pupil Exit Quiz", pupilExitQuiz));
    pupilExitQuiz.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("BvJKWCkFc", "item at index " + index + " in Pupil Exit Quiz", value));
    });
  }
  return messages;
}

function assertTeacherSchoolManualEntryDetailsOptional(teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (teacherSchoolManualEntryDetails !== undefined && teacherSchoolManualEntryDetails !== null) {
    messages = messages.concat(AvoAssert.assertObject("FqpH5gAYj", _label ? "Teacher School Manual Entry Details" + ': ' + _label : "Teacher School Manual Entry Details", teacherSchoolManualEntryDetails));
  }
  return messages;
}

function assertPupilStarterQuizOptional(pupilStarterQuiz: PupilStarterQuiz[] | null | undefined,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  if (pupilStarterQuiz !== undefined && pupilStarterQuiz !== null) {
    messages = messages.concat(AvoAssert.assertList("GUtiqMHeN", "Pupil Starter Quiz", pupilStarterQuiz));
    pupilStarterQuiz.forEach(function (value, index) {
      messages = messages.concat(AvoAssert.assertObject("GUtiqMHeN", "item at index " + index + " in Pupil Starter Quiz", value));
    });
  }
  return messages;
}

function assertTotalDownloadableResources(totalDownloadableResources: number,
    _label?: string) {
  let messages: AvoAssertMessage[] = [];
  messages = messages.concat(AvoAssert.assertInt("v5S8At-_4BZ3vGl149_SP", _label ? "Total Downloadable Resources" + ': ' + _label : "Total Downloadable Resources", totalDownloadableResources));
  messages = messages.concat(AvoAssert.assertMin("v5S8At-_4BZ3vGl149_SP", _label ? "Total Downloadable Resources" + ": " + _label : "Total Downloadable Resources", 0, totalDownloadableResources));
  return messages;
}

export function setAvoLogger(avoLogger: AvoLogger | null) {
  __AVO_LOGGER__ = avoLogger;
}

/**
 * Newsletter Sign Up Completed: A visitor submits the form to subscribe to the newsletter
 * 
 * When to trigger this event:
 * 1. User has completed the newsletter fields and pressed the Sign Up button
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sLqKBjU-Wt/trigger/_MC_apwfp
 * 2. Clicking Sign-in with Google button after checking the receive sign ups box.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sLqKBjU-Wt/trigger/tZTijzcL6sdSe6YVaWUUJ
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sLqKBjU-Wt}
 */
export function newsletterSignUpCompleted() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sLqKBjU-Wt", "085737f624ca5a6e8b1fe99fb1015c3fcef260da5335b1f6d4da68fd8b821f74", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Newsletter Sign Up Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sLqKBjU-Wt", "Newsletter Sign Up Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Newsletter Sign Up Completed", eventProperties, "sLqKBjU-Wt", "085737f624ca5a6e8b1fe99fb1015c3fcef260da5335b1f6d4da68fd8b821f74");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Newsletter Sign Up Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomSelectedProperties {
  navigatedFrom: NavigatedFromValueType;
}
/**
 * Classroom Selected: Classroom app is selected from the Launch Homepage (card or header or menu or footer)
 * 
 * When to trigger this event:
 * 1. Classroom app selected from homepage card
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/esgLdNSBsj/trigger/d46nqqMBY
 * 2. Classroom app selected from menu
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/esgLdNSBsj/trigger/M_vqoTLFQ
 * 
 * @param properties the properties associated with this event
 * @param properties.navigatedFrom: The location of the link used to navigate to the current page
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/esgLdNSBsj}
 */
export function classroomSelected(properties: ClassroomSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "p48bLbzXJ-", name: "Navigated From", value: properties.navigatedFrom});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "esgLdNSBsj", "8ff195436fbfc616e539a0c724a8fb07de6e6e8de5ffb3561669c43b9923d029", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("esgLdNSBsj", "Classroom Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Selected", eventProperties, "esgLdNSBsj", "8ff195436fbfc616e539a0c724a8fb07de6e6e8de5ffb3561669c43b9923d029");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoStartedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
  cloudinaryUrl: string | null | undefined;
  muxAssetId: string | null | undefined;
  journeyId: string | null | undefined;
}
/**
 * Video Started: A video is played for the first time after a user lands on a page
 * 
 * @param properties the properties associated with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.cloudinaryUrl: Url for the asset in cloudinary
 * @param properties.muxAssetId: Unique identifier of the asset in mux
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/G0I28K0B2f}
 */
export function videoStarted(properties: VideoStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  properties.cloudinaryUrl !== undefined && properties.cloudinaryUrl !== null ?
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: properties.cloudinaryUrl}) :
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: null});
  properties.muxAssetId !== undefined && properties.muxAssetId !== null ?
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: properties.muxAssetId}) :
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "G0I28K0B2f", "90ddc3de772467fec62d5ed1469e321f783675582247e51dc8a323583c8f0655", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("G0I28K0B2f", "Video Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Started", eventProperties, "G0I28K0B2f", "90ddc3de772467fec62d5ed1469e321f783675582247e51dc8a323583c8f0655");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPausedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
  cloudinaryUrl: string | null | undefined;
  muxAssetId: string | null | undefined;
  journeyId: string | null | undefined;
}
/**
 * Video Paused: A video is paused before it it finished
 * 
 * @param properties the properties associated with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.cloudinaryUrl: Url for the asset in cloudinary
 * @param properties.muxAssetId: Unique identifier of the asset in mux
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/z91WauKeVB}
 */
export function videoPaused(properties: VideoPausedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  properties.cloudinaryUrl !== undefined && properties.cloudinaryUrl !== null ?
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: properties.cloudinaryUrl}) :
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: null});
  properties.muxAssetId !== undefined && properties.muxAssetId !== null ?
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: properties.muxAssetId}) :
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "z91WauKeVB", "2d95b08a94e2d1d8c4a276e80fc248da918e1b42e7cf10c035ca24f197c75312", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Paused", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("z91WauKeVB", "Video Paused", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Paused", eventProperties, "z91WauKeVB", "2d95b08a94e2d1d8c4a276e80fc248da918e1b42e7cf10c035ca24f197c75312");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Paused", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoPlayedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  releaseGroup: string | null | undefined;
  phase: PhaseValueType | null | undefined;
  cloudinaryUrl: string | null | undefined;
  muxAssetId: string | null | undefined;
  journeyId: string | null | undefined;
}
/**
 * Video Played: A video is played again after being paused
 * 
 * @param properties the properties associated with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.cloudinaryUrl: Url for the asset in cloudinary
 * @param properties.muxAssetId: Unique identifier of the asset in mux
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/r4DFADUHFh}
 */
export function videoPlayed(properties: VideoPlayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  properties.cloudinaryUrl !== undefined && properties.cloudinaryUrl !== null ?
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: properties.cloudinaryUrl}) :
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: null});
  properties.muxAssetId !== undefined && properties.muxAssetId !== null ?
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: properties.muxAssetId}) :
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "r4DFADUHFh", "d6ed1d4b89a250b808851d86eb30ec29513a5d0601be2a983afa061299fd789a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Played", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("r4DFADUHFh", "Video Played", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Played", eventProperties, "r4DFADUHFh", "d6ed1d4b89a250b808851d86eb30ec29513a5d0601be2a983afa061299fd789a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Played", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface VideoFinishedProperties {
  durationSeconds: number | null | undefined;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  phase: PhaseValueType | null | undefined;
  releaseGroup: string | null | undefined;
  cloudinaryUrl: string | null | undefined;
  muxAssetId: string | null | undefined;
  journeyId: string | null | undefined;
}
/**
 * Video Finished: The end of a video is reached
 * 
 * @param properties the properties associated with this event
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.cloudinaryUrl: Url for the asset in cloudinary
 * @param properties.muxAssetId: Unique identifier of the asset in mux
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/NP9klWkaki}
 */
export function videoFinished(properties: VideoFinishedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.durationSeconds !== undefined && properties.durationSeconds !== null ?
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds}) :
    eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: null});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  properties.releaseGroup !== undefined && properties.releaseGroup !== null ?
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup}) :
    eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: null});
  properties.cloudinaryUrl !== undefined && properties.cloudinaryUrl !== null ?
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: properties.cloudinaryUrl}) :
    eventPropertiesArray.push({id: "IFEzo8NmuRBZcbTOf3fSr", name: "Cloudinary Url", value: null});
  properties.muxAssetId !== undefined && properties.muxAssetId !== null ?
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: properties.muxAssetId}) :
    eventPropertiesArray.push({id: "epT5BpeF8uu2yJdFNZMly", name: "Mux Asset Id", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NP9klWkaki", "aae4ade7639f1fac08b7fab111db6284224bca3290a1f37507074fc7c91c2e7c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Video Finished", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NP9klWkaki", "Video Finished", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Video Finished", eventProperties, "NP9klWkaki", "aae4ade7639f1fac08b7fab111db6284224bca3290a1f37507074fc7c91c2e7c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Video Finished", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonResourcesDownloadedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  schoolUrn: string;
  schoolName: string;
  schoolOption: SchoolOptionValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  resourceType: ResourceTypeValueType[];
  emailSupplied: boolean;
  onwardContent: string[];
  totalDownloadableResources: number;
  journeyId: string | null | undefined;
}
/**
 * Lesson Resources Downloaded: A user downloaded one or more resources for a lesson
 * 
 * When to trigger this event:
 * 1. The download .zip button is clicked on the lesson download page and submission passes validation checks
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/k9ZQJai7ws/trigger/sAqordxVG
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.resourceType: The lesson resources a teacher selected for download.
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.onwardContent: A list of slugs representing content (e.g. lessons) that are placed to allow a user journey to 'continue' onward.
 * @param properties.totalDownloadableResources: The total number of resources that are available to be downloaded
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/k9ZQJai7ws}
 */
export function lessonResourcesDownloaded(properties: LessonResourcesDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "H_kc7WuVNP", name: "Resource Type", value: properties.resourceType});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "5IrIuSjxs", name: "Onward Content", value: properties.onwardContent});
  eventPropertiesArray.push({id: "v5S8At-_4BZ3vGl149_SP", name: "Total Downloadable Resources", value: properties.totalDownloadableResources});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTotalDownloadableResources(properties.totalDownloadableResources));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "k9ZQJai7ws", "43f8c89124b5c5cf6019533ca2dbf4371c29c7d61b66573a7a557f8adad250fd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Resources Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("k9ZQJai7ws", "Lesson Resources Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Lesson Resources Downloaded': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Resources Downloaded", eventProperties, "k9ZQJai7ws", "43f8c89124b5c5cf6019533ca2dbf4371c29c7d61b66573a7a557f8adad250fd");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Resources Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitAccessedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  unitName: string;
  unitSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  journeyId: string | null | undefined;
  navigationType: NavigationTypeValueType | null | undefined;
  accessLevel: AccessLevelValueType | null | undefined;
}
/**
 * Unit Accessed: A teacher chooses the unit they want to view.
 * 
 * When to trigger this event:
 * 1. A unit card is selected from the unit listing page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Me4ouIgPxh/trigger/t8lbfIsGe
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Me4ouIgPxh}
 */
export function unitAccessed(properties: UnitAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  properties.navigationType !== undefined && properties.navigationType !== null ?
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType}) :
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: null});
  properties.accessLevel !== undefined && properties.accessLevel !== null ?
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel}) :
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Me4ouIgPxh", "4138fa540338435d881df547e051e9f60922d53486a7aacc002dfc20b0a3b3ed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Me4ouIgPxh", "Unit Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Accessed", eventProperties, "Me4ouIgPxh", "4138fa540338435d881df547e051e9f60922d53486a7aacc002dfc20b0a3b3ed");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface WebinarPageViewedProperties {
  webinarTitle: string;
  webinarCategory: string;
  videoAvailable: boolean;
}
/**
 * Webinar Page Viewed: A user loads a webinar page
 * 
 * @param properties the properties associated with this event
 * @param properties.webinarTitle: Title of the webinar
 * @param properties.webinarCategory: Category of the webinar
 * @param properties.videoAvailable: Watchable video is available on page (eg. not 'upcoming' or 'processing' status
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/-9FHudlATb}
 */
export function webinarPageViewed(properties: WebinarPageViewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "EEuyiIwAD", name: "Webinar Title", value: properties.webinarTitle});
  eventPropertiesArray.push({id: "MbEsLei6Z", name: "Webinar Category", value: properties.webinarCategory});
  eventPropertiesArray.push({id: "StT0U3M69", name: "Video Available", value: properties.videoAvailable});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "-9FHudlATb", "ebf8f74a217a39aefe9153d249e65dfd00927a93e0811de345e3edf20dc2ed39", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Webinar Page Viewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("-9FHudlATb", "Webinar Page Viewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Webinar Page Viewed", eventProperties, "-9FHudlATb", "ebf8f74a217a39aefe9153d249e65dfd00927a93e0811de345e3edf20dc2ed39");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Webinar Page Viewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface PageviewProperties {
  linkUrl: string;
  analyticsUseCase: AnalyticsUseCaseValueType | null | undefined;
  pageName: PageNameValueType;
}
/**
 * $pageview: A user views the page (DO NOT change the name of this event, as it is a special name in Posthog)
 * 
 * @param properties the properties associated with this event
 * @param properties.linkUrl: The href of a link
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pageName: The main pages of a user journey eg. subject listing, unit listing, etc
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/iYVEEwNT0q}
 */
export function pageview(properties: PageviewProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  properties.analyticsUseCase !== undefined && properties.analyticsUseCase !== null ?
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase}) :
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: null});
  eventPropertiesArray.push({id: "LgWcfE0FOm", name: "Page Name", value: properties.pageName});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "iYVEEwNT0q", "8edce25b26dd5e01b1c0e608c07b165508b7969b444ee1095b9f0c0c00316067", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("$pageview", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("iYVEEwNT0q", "$pageview", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("$pageview", eventProperties, "iYVEEwNT0q", "8edce25b26dd5e01b1c0e608c07b165508b7969b444ee1095b9f0c0c00316067");
    }
    // destination PostHogEU
    PostHogEU.logEvent("$pageview", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonResourceDownloadStartedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  downloadResourceButtonName: DownloadResourceButtonNameValueType;
  journeyId: string | null | undefined;
}
/**
 * Lesson Resource Download Started: A download button is clicked on the lesson overview page
 * 
 * When to trigger this event:
 * 1. Download all resources button is clicked on the lesson overview page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/0n50tfMg2N/trigger/w2ACuk2F3
 * 2. An individual resource download button on an expandable container is clicked (eg. slide deck, starter quiz, worksheet, etc)
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/0n50tfMg2N/trigger/5PBz6j66G
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.downloadResourceButtonName: The name of the button to download the resource (all, or individual resources)
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/0n50tfMg2N}
 */
export function lessonResourceDownloadStarted(properties: LessonResourceDownloadStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "GeeELBAAq", name: "Download Resource Button Name", value: properties.downloadResourceButtonName});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "0n50tfMg2N", "635d51408bb35c6fefe5b62742f3e381d2c8b121dd1e826d2c56bc65c0e1812b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Resource Download Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("0n50tfMg2N", "Lesson Resource Download Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Resource Download Started", eventProperties, "0n50tfMg2N", "635d51408bb35c6fefe5b62742f3e381d2c8b121dd1e826d2c56bc65c0e1812b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Resource Download Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchTerm: string;
  searchResultCount: number;
  searchResultsLoadTime: number;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Accessed: A user enters a search term (eg. lesson or unit topic, keyword), submits a search, and results are rendered
 * 
 * When to trigger this event:
 * 1. A user initiates a search from the homepage by 
entering the search term and clicking "Go"
entering the search term and pressing ENTER on the keyboard
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_dSzYI2PB/trigger/GRZ05_zLD
 * 2. A user initiates a search from the search page (eg. they refine their search term or try looking for something else) by entering the search term and 
clicking "Go", or 
pressing ENTER 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_dSzYI2PB/trigger/SG8O6HFoP
 * 3. A search is initiated from the homepage by clicking on one of the search suggestion option beneath the search box
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_dSzYI2PB/trigger/5gULgsDoY
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchTerm: The term entered by the user for the search.
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultsLoadTime: Amount of time taken to fetch and load the search results
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_dSzYI2PB}
 */
export function searchAccessed(properties: SearchAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "uKpVoe2qJ", name: "Search Results Load Time", value: properties.searchResultsLoadTime});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "I_dSzYI2PB", "e6127201da94460843fb95ef97db38abeb8ff6af27676a575ec917dfb96c647e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("I_dSzYI2PB", "Search Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Accessed", eventProperties, "I_dSzYI2PB", "e6127201da94460843fb95ef97db38abeb8ff6af27676a575ec917dfb96c647e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchResultOpenedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchRank: number;
  searchFilterOptionSelected: string[];
  searchResultCount: number;
  searchResultType: SearchResultTypeValueType;
  context: ContextValueType;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Result Opened: User clicks on a search result from the listing
 * 
 * When to trigger this event:
 * 1. A search result card (could be unit or lesson) is clicked
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_TD-gtSgIj/trigger/ZezXTZ0ri
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchRank: The position of the clicked search result
 * @param properties.searchFilterOptionSelected: The specific search filter option that has been selected (eg. 'ks2,ks3') 
 * NB. ensure filters are sent in a consistent order
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultType: The type of result returned (eg. unit or lesson)
 * @param properties.context: Relates to the application or view from which a action was performed
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_TD-gtSgIj}
 */
export function searchResultOpened(properties: SearchResultOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Gvu_40yW7", name: "Search Rank", value: properties.searchRank});
  eventPropertiesArray.push({id: "psOVldb0Z", name: "Search Filter Option Selected", value: properties.searchFilterOptionSelected});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "weaA0iE9I", name: "Search Result Type", value: properties.searchResultType});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_TD-gtSgIj", "488465d32db60f73a6f99976f5b2c1ae3879b5a6bd681b55805fe21bb622d185", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Result Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_TD-gtSgIj", "Search Result Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Result Opened", eventProperties, "_TD-gtSgIj", "488465d32db60f73a6f99976f5b2c1ae3879b5a6bd681b55805fe21bb622d185");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Result Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchJourneyInitiatedProperties {
  searchSource: SearchSourceValueType;
  context: ContextValueType;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Journey Initiated: The search box is selected
 * 
 * When to trigger this event:
 * 1. A user types in the search bar on the homepage (first letter is typed).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/rYxJBK8Kpm/trigger/aeEheVqLW
 * 2. A user types in the search bar on the search page (first letter is typed)
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/rYxJBK8Kpm/trigger/5OM1jFoWf
 * 
 * @param properties the properties associated with this event
 * @param properties.searchSource: The location of the search box/entry point. 
 * eg. homepage search box, search page search box, hamburger menu search box (future)
 * @param properties.context: Relates to the application or view from which a action was performed
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/rYxJBK8Kpm}
 */
export function searchJourneyInitiated(properties: SearchJourneyInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "cAhJwc7aw", name: "Search Source", value: properties.searchSource});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rYxJBK8Kpm", "89aa79af3ebf456f444493d98da3f817db05072f952e5c83fb89112b67912de3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Journey Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rYxJBK8Kpm", "Search Journey Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Journey Initiated", eventProperties, "rYxJBK8Kpm", "89aa79af3ebf456f444493d98da3f817db05072f952e5c83fb89112b67912de3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Journey Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserAccessedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Curriculum Visualiser Accessed: A user opening the curriculum visualiser tool for use having select a subject and phase.
 * 
 * When to trigger this event:
 * 1. A user has clicked view after successfully completing the "Subject" and "School phase" fields.
Component Type: 'homepage_button'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_ImUDkApb7/trigger/R19ayisHj
 * 2. Illustration of same component with would trigger this event but this time from the curriculum visualiser itself where this event could also be triggered
component: curriculum_visualiser_button
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_ImUDkApb7/trigger/LFOFUdkpr
 * 3. The lot picker is also accessible from the curriculum landing page
component type: 'landing_page_button'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_ImUDkApb7/trigger/vCEJO0o_GAdCNaTlSlkoP
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/_ImUDkApb7}
 */
export function curriculumVisualiserAccessed(properties: CurriculumVisualiserAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "_ImUDkApb7", "1accc9a44d0cf82498b0661d4a2378e1a48323b12b8fce44dd27030f912cfafb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("_ImUDkApb7", "Curriculum Visualiser Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Accessed", eventProperties, "_ImUDkApb7", "1accc9a44d0cf82498b0661d4a2378e1a48323b12b8fce44dd27030f912cfafb");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonSharedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  schoolUrn: string;
  schoolName: string;
  schoolOption: SchoolOptionValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareMedium: ShareMediumValueType;
  resourceTypes: ResourceTypesValueType[];
  emailSupplied: boolean;
  audience: AudienceValueType;
  yearGroupHidden: boolean;
}
/**
 * Lesson Shared: The event of a teacher sharing a selection of resources relating to a lesson with pupils or elsewhere.
 * 
 * When to trigger this event:
 * 1. One of the share options is selected
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/RnJu4EY4bA/trigger/lvtGVFDJo
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareMedium: The medium through which a link to a resource is shared
 * @param properties.resourceTypes: The type of pupil facing activity(yes) selected (e.g. when a lesson is shared with pupils)
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.audience: Corresponds to the a target audience (usually in relation to a share event)
 * @param properties.yearGroupHidden: Whether the teacher decided to hide the year group for the shared lesson
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/RnJu4EY4bA}
 */
export function lessonShared(properties: LessonSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "aMDyFQBYq", name: "Share Medium", value: properties.shareMedium});
  eventPropertiesArray.push({id: "4Vptzwuw7", name: "Resource Types", value: properties.resourceTypes});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "n6WxfUPK1", name: "Audience", value: properties.audience});
  eventPropertiesArray.push({id: "ZniW2VdEtwOh6qLzQPtZ0", name: "Year Group Hidden", value: properties.yearGroupHidden});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "RnJu4EY4bA", "e2cca9f745842fe28f17e06a1a41500ba3eaa971c9596af72ccc42e394f206f1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("RnJu4EY4bA", "Lesson Shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Shared", eventProperties, "RnJu4EY4bA", "e2cca9f745842fe28f17e06a1a41500ba3eaa971c9596af72ccc42e394f206f1");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonShareStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  journeyId: string | null | undefined;
}
/**
 * Lesson Share Started: A user beings the process of sharing a lesson with their pupils. This event shows they are interested in sharing something but happens prior to a user generating the required link that would suggest the sharing has taken place.
 * 
 * When to trigger this event:
 * 1. Share activities with pupils button clicked at top of the page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/PS8tcnGrN2/trigger/Lsaaeanis
 * 2. Share activities with pupils button clicked at the resource level

NB. There is no sharing of slide decks at this time
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/PS8tcnGrN2/trigger/QMYuEgDaG
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/PS8tcnGrN2}
 */
export function lessonShareStarted(properties: LessonShareStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PS8tcnGrN2", "ffcfa1d1f46864cc9f11f83fc88f58464691ade277ae6e4ce7ceb7a0b490399c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Share Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PS8tcnGrN2", "Lesson Share Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Share Started", eventProperties, "PS8tcnGrN2", "ffcfa1d1f46864cc9f11f83fc88f58464691ade277ae6e4ce7ceb7a0b490399c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Share Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  searchResultCount: number;
  activeFilters: ActiveFilters;
  searchTerm: string;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Refined: Results are returned following a change to search filters
 * 
 * When to trigger this event:
 * 1. Results are returned by the search and a count of results is known
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/XpQ27vPNH4/trigger/PcgndFCLH2PP2U6ErGXCe
 * 2. (AI) A user selects from the list of suggested filters
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/XpQ27vPNH4/trigger/3uRc57QBJnE3_9gJlojNZ
 * 3. User selects filter from the ‘All filters’ list
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/XpQ27vPNH4/trigger/jJhXn8kQGmPcNHrAl_DbV
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.searchTerm: The term entered by the user for the search.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/XpQ27vPNH4}
 */
export function searchRefined(properties: SearchRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XpQ27vPNH4", "b75bf8c6632d5ce3b0b94b497bcf300e0a101fc9389ff526da426dcc2cc9faca", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XpQ27vPNH4", "Search Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Refined", eventProperties, "XpQ27vPNH4", "b75bf8c6632d5ce3b0b94b497bcf300e0a101fc9389ff526da426dcc2cc9faca");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchResultExpandedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  unitName: string;
  unitSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  context: ContextValueType;
  searchRank: number;
  searchFilterOptionSelected: string[];
  searchResultCount: number;
  searchResultType: SearchResultTypeValueType;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Result Expanded: The User expands a search result to display optionality around Exam Board or difficulty
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.context: Relates to the application or view from which a action was performed
 * @param properties.searchRank: The position of the clicked search result
 * @param properties.searchFilterOptionSelected: The specific search filter option that has been selected (eg. 'ks2,ks3') 
 * NB. ensure filters are sent in a consistent order
 * @param properties.searchResultCount: total number of search results returned
 * @param properties.searchResultType: The type of result returned (eg. unit or lesson)
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/eP2lOQQj8C}
 */
export function searchResultExpanded(properties: SearchResultExpandedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "9BNUma5en", name: "Context", value: properties.context});
  eventPropertiesArray.push({id: "Gvu_40yW7", name: "Search Rank", value: properties.searchRank});
  eventPropertiesArray.push({id: "psOVldb0Z", name: "Search Filter Option Selected", value: properties.searchFilterOptionSelected});
  eventPropertiesArray.push({id: "ssKpAufWU", name: "Search Result Count", value: properties.searchResultCount});
  eventPropertiesArray.push({id: "weaA0iE9I", name: "Search Result Type", value: properties.searchResultType});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eP2lOQQj8C", "a23f5db1e76c7a424dae58555aeb835600fff0e34c1202bd702b9111f3102d4d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Result Expanded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eP2lOQQj8C", "Search Result Expanded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Result Expanded", eventProperties, "eP2lOQQj8C", "a23f5db1e76c7a424dae58555aeb835600fff0e34c1202bd702b9111f3102d4d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Result Expanded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonCompletedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Lesson Completed: When a pupil completes all the activities in a lesson during the pupil experience.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Hy-6QNrYKU}
 */
export function lessonCompleted(properties: LessonCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Hy-6QNrYKU", "019de0f5699f3213d1ca557bef32d78b97e276664fa38848082dcc6b606cf892", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Hy-6QNrYKU", "Lesson Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Completed", eventProperties, "Hy-6QNrYKU", "019de0f5699f3213d1ca557bef32d78b97e276664fa38848082dcc6b606cf892");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson 
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz}
 */
export function lessonActivityCompleted(properties: LessonActivityCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz", "53cae43d1f2b413390fc4014012928599428b742eb5eb56854440ffa9bfc0729", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz", "53cae43d1f2b413390fc4014012928599428b742eb5eb56854440ffa9bfc0729");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz.w-tN4OqGk}
 */
export function lessonActivityCompletedIntroduction(properties: LessonActivityCompletedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.w-tN4OqGk", "28b2ad1e03d59b836727418ddcb060b26f5e76cef6711072fd545bb851a204b0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.w-tN4OqGk", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.w-tN4OqGk", "28b2ad1e03d59b836727418ddcb060b26f5e76cef6711072fd545bb851a204b0");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz.VPlVqR6yv}
 */
export function lessonActivityCompletedStarterQuiz(properties: LessonActivityCompletedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.VPlVqR6yv", "1affc4998d7e56321dbfe3257cf8f50d1d0aee8b6ad6e7336cc310142f33af03", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.VPlVqR6yv", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.VPlVqR6yv", "1affc4998d7e56321dbfe3257cf8f50d1d0aee8b6ad6e7336cc310142f33af03");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilVideoDurationSeconds: number;
  isMuted: boolean;
  signedOpened: boolean;
  videoTitle: string;
  numberOfVideos: number;
  pupilVideoTimeElapsedSeconds: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
  isCaptioned: boolean;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.transcriptOpened: if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz.66NwEPbGj}
 */
export function lessonActivityCompletedLessonVideo(properties: LessonActivityCompletedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.66NwEPbGj", "704e6dfa82f5e78492ffb89d706273fc3ce07899d95bf855b906318df6bc0dd3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.66NwEPbGj", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.66NwEPbGj", "704e6dfa82f5e78492ffb89d706273fc3ce07899d95bf855b906318df6bc0dd3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz.pE7MH59gY}
 */
export function lessonActivityCompletedExitQuiz(properties: LessonActivityCompletedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.pE7MH59gY", "2be74e1258934d24136baad31ce03c650c37db1edc0c4cfa6962b0ad74deb4d0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.pE7MH59gY", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.pE7MH59gY", "2be74e1258934d24136baad31ce03c650c37db1edc0c4cfa6962b0ad74deb4d0");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityCompletedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilAudioPlayed: boolean;
  isMuted: boolean;
  signedOpened: boolean;
  pupilAudioTimeElapsedSeconds: string;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  audioTitle: string;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Completed: Event sent when a pupil completes a lesson activity/ completes an exercise or task in a lesson, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.pupilAudioTimeElapsedSeconds: The amount of time the pupil has spent listening to the audio in seconds
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.audioTitle: Title of Audio
 * @param properties.transcriptOpened: if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/sBllxa-nuz.vftftUlwJ}
 */
export function lessonActivityCompletedLessonAudio(properties: LessonActivityCompletedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "CZvLiY0yy", name: "Pupil Audio Time Elapsed (Seconds)", value: properties.pupilAudioTimeElapsedSeconds});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "sBllxa-nuz.vftftUlwJ", "85fd6637fac260d86ef87b5799dca05ccac1a554f9e7500368a14642d62f7b91", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("sBllxa-nuz.vftftUlwJ", "Lesson Activity Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Completed", eventProperties, "sBllxa-nuz.vftftUlwJ", "85fd6637fac260d86ef87b5799dca05ccac1a554f9e7500368a14642d62f7b91");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonStartedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  yearGroupName: string;
  yearGroupSlug: string;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Lesson Started: A student starts a new lesson, or a teacher views a lesson as a student.
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/9zz1OCsT2}
 */
export function lessonStarted(properties: LessonStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "9zz1OCsT2", "c6103800eea4148aae7105c9434c5bb591962e4bf1d9329fba1764f7d5f15ec6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("9zz1OCsT2", "Lesson Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Started", eventProperties, "9zz1OCsT2", "c6103800eea4148aae7105c9434c5bb591962e4bf1d9329fba1764f7d5f15ec6");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl}
 */
export function lessonActivityStarted(properties: LessonActivityStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl", "954bffa7e308968fadb7383edf200dfc90b184fb4da0b8d49fe11ba3c8705e34", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl", "954bffa7e308968fadb7383edf200dfc90b184fb4da0b8d49fe11ba3c8705e34");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl.sQj7v3rhg}
 */
export function lessonActivityStartedIntroduction(properties: LessonActivityStartedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.sQj7v3rhg", "3a309689fd09a8d2261ac2cee48c1c3e1408bdfda2e12adcd99c3167254727c6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.sQj7v3rhg", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.sQj7v3rhg", "3a309689fd09a8d2261ac2cee48c1c3e1408bdfda2e12adcd99c3167254727c6");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  hintAvailable: boolean;
  pupilQuizGrade: number;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.hintAvailable: if a hint is provided for quiz question
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl.jXPPatapH}
 */
export function lessonActivityStartedStarterQuiz(properties: LessonActivityStartedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "0dn7bZTfJ", name: "Hint Available", value: properties.hintAvailable});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.jXPPatapH", "cc6e8cde8f83e21f8e366972cea6298bac17f3a1ce26b4631d4c93be1b94f47f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.jXPPatapH", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.jXPPatapH", "cc6e8cde8f83e21f8e366972cea6298bac17f3a1ce26b4631d4c93be1b94f47f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  pupilVideoDurationSeconds: number;
  signedAvailable: boolean;
  videoTitle: string;
  numberOfVideos: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.signedAvailable: Indicates whether a sign language version of the content is available
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl.--Q2qdv1R}
 */
export function lessonActivityStartedLessonVideo(properties: LessonActivityStartedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "JgWtPxquw", name: "Signed Available ", value: properties.signedAvailable});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.--Q2qdv1R", "4a1bcfaead112211c4d54260a6f23072e0b8edde260fe323b7abdc0dd2533f82", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.--Q2qdv1R", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.--Q2qdv1R", "4a1bcfaead112211c4d54260a6f23072e0b8edde260fe323b7abdc0dd2533f82");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  releaseGroup: string;
  hintAvailable: boolean;
  pupilQuizGrade: number;
  pupilQuizNumQuestions: number;
  phase: PhaseValueType;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.hintAvailable: if a hint is provided for quiz question
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl.bwLDlBvXo}
 */
export function lessonActivityStartedExitQuiz(properties: LessonActivityStartedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "0dn7bZTfJ", name: "Hint Available", value: properties.hintAvailable});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.bwLDlBvXo", "e78b0e59916974273b2a5ae1aac0524d490efc9bd13bc25bc1a8cc47455ad38b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.bwLDlBvXo", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.bwLDlBvXo", "e78b0e59916974273b2a5ae1aac0524d490efc9bd13bc25bc1a8cc47455ad38b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityStartedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  pupilAudioPlayed: boolean;
  signedAvailable: boolean;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  audioTitle: string;
}
/**
 * Lesson Activity Started: Event sent when a pupil selects and clicks an lesson activity to start for the first time, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.signedAvailable: Indicates whether a sign language version of the content is available
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.audioTitle: Title of Audio
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/8LfOc60dl.UadcF0krG}
 */
export function lessonActivityStartedLessonAudio(properties: LessonActivityStartedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "JgWtPxquw", name: "Signed Available ", value: properties.signedAvailable});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "8LfOc60dl.UadcF0krG", "045f0bb5f73e366559839fceba184ffff4bf0d1b698c9b8ad9c8930df8350c2e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("8LfOc60dl.UadcF0krG", "Lesson Activity Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Started", eventProperties, "8LfOc60dl.UadcF0krG", "045f0bb5f73e366559839fceba184ffff4bf0d1b698c9b8ad9c8930df8350c2e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumResourcesDownloadedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  emailSupplied: boolean;
  resourceType: ResourceTypeValueType[];
  schoolOption: SchoolOptionValueType;
  schoolUrn: string;
  schoolName: string;
  subjectTitle: string;
  phase: PhaseValueType;
  journeyId: string | null | undefined;
}
/**
 * Curriculum Resources Downloaded: Curriculum Resources Downloaded: A user downloaded one or more resources for a curriculum - this can either be a curriculum plan or previously released curriculum content. 
 * 
 * When to trigger this event:
 * 1. User clicks on the 'download' button on the 'Downloads' tab to download a curriculum plan, resource type = 'curriculum_plan'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/L7-HOgqfOB/trigger/jUQsfF-ITbWp_67NmYgz3
 * 2. User clicks on the 'Download PDF' button on the 'Previously Released Curricula' page - Resource Type = 'previously_released_curricula'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/L7-HOgqfOB/trigger/8nxd5KGbX7Ulg8ZhUyiRB
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.emailSupplied: A user has signed up for updates on the downloads page
 * @param properties.resourceType: The lesson resources a teacher selected for download.
 * @param properties.schoolOption: The option the user has selected as their school (selected school, homeschool or not listed)
 * @param properties.schoolUrn: School URN linked to GIAS attributes, should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.schoolName: Name of the school chosen from the school picker
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/L7-HOgqfOB}
 */
export function curriculumResourcesDownloaded(properties: CurriculumResourcesDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "3wxlGffcE", name: "Email Supplied", value: properties.emailSupplied});
  eventPropertiesArray.push({id: "H_kc7WuVNP", name: "Resource Type", value: properties.resourceType});
  eventPropertiesArray.push({id: "CrzKvLBC3", name: "School Option", value: properties.schoolOption});
  eventPropertiesArray.push({id: "G1iO4wRoL5", name: "School URN", value: properties.schoolUrn});
  eventPropertiesArray.push({id: "54PPZ-gkS", name: "School Name", value: properties.schoolName});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "L7-HOgqfOB", "1b1c827bdc2e05d94f1f94a44dbc3ff7e7c276f82712454e51339090b50c4bf7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Resources Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("L7-HOgqfOB", "Curriculum Resources Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Resources Downloaded", eventProperties, "L7-HOgqfOB", "1b1c827bdc2e05d94f1f94a44dbc3ff7e7c276f82712454e51339090b50c4bf7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Resources Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4}
 */
export function lessonActivityAbandoned(properties: LessonActivityAbandonedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4", "d8ce51620835e8970086fac11c1d755994deeb229922699eaa52f15590e1be58", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4", "d8ce51620835e8970086fac11c1d755994deeb229922699eaa52f15590e1be58");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedStarterQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A quiz at the beginning of the lesson to understand their prior knowledge and prepare students for new content.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4.RRbQMT3mC}
 */
export function lessonActivityAbandonedStarterQuiz(properties: LessonActivityAbandonedStarterQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.RRbQMT3mC", "c89b8c9aa267ee1245c017b0d56aa205feeb9e9e5343d1774f3d82aa28dc651e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.RRbQMT3mC", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.RRbQMT3mC", "c89b8c9aa267ee1245c017b0d56aa205feeb9e9e5343d1774f3d82aa28dc651e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedIntroductionProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: An overview of the lesson and what the pupils expect to learn
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4.lfCw2Vowr}
 */
export function lessonActivityAbandonedIntroduction(properties: LessonActivityAbandonedIntroductionProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.lfCw2Vowr", "947f46766a43f50fdeaabbd1592d5eee368bc45637b47a7c70f62139733b14fe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.lfCw2Vowr", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.lfCw2Vowr", "947f46766a43f50fdeaabbd1592d5eee368bc45637b47a7c70f62139733b14fe");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedLessonVideoProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilVideoDurationSeconds: number;
  isMuted: boolean;
  signedOpened: boolean;
  videoTitle: string;
  numberOfVideos: number;
  pupilVideoTimeElapsedSeconds: number;
  videoSlug: string[];
  pupilVideoPlayed: boolean;
  videoPlaybackId: string[];
  isCaptioned: boolean;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A video that provides a visual and auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.videoTitle: Title of video
 * @param properties.numberOfVideos: The total count of videos available in a lesson
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.videoSlug: Human-readable unique ID of the selected video.
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.transcriptOpened: if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4.F-FcsZGOv}
 */
export function lessonActivityAbandonedLessonVideo(properties: LessonActivityAbandonedLessonVideoProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "VDriy9qDh", name: "Number of Videos", value: properties.numberOfVideos});
  eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds});
  eventPropertiesArray.push({id: "gPpoyntqZe", name: "Video Slug", value: properties.videoSlug});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.F-FcsZGOv", "e599bbc934c586ba25248285959244fa7eaeb4e71d13c4d4c2e019fdb49d07a7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.F-FcsZGOv", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.F-FcsZGOv", "e599bbc934c586ba25248285959244fa7eaeb4e71d13c4d4c2e019fdb49d07a7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedExitQuizProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilQuizGrade: number;
  hintQuestion: string;
  hintQuestionResult: string;
  hintUsed: string;
  pupilQuizNumQuestions: number;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A quiz at the end of the lesson to assess students' understanding of the material covered.
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilQuizGrade: The score a student received on a quiz
 * @param properties.hintQuestion: The Question the hint was used on
 * @param properties.hintQuestionResult: Whether the pupil got the question right after using the hint
 * @param properties.hintUsed: Shows whether the pupil used the available hint
 * @param properties.pupilQuizNumQuestions: The total number of questions in the quiz
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4.67Vn1Fv8t}
 */
export function lessonActivityAbandonedExitQuiz(properties: LessonActivityAbandonedExitQuizProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "12xmn1uQF", name: "Pupil Quiz Grade", value: properties.pupilQuizGrade});
  eventPropertiesArray.push({id: "7fVIgC0En", name: "Hint Question", value: properties.hintQuestion});
  eventPropertiesArray.push({id: "N42awt8Kz", name: "Hint Question Result", value: properties.hintQuestionResult});
  eventPropertiesArray.push({id: "mk7IFzd0V", name: "Hint Used", value: properties.hintUsed});
  eventPropertiesArray.push({id: "y28SwSKr9", name: "Pupil Quiz Num Questions", value: properties.pupilQuizNumQuestions});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.67Vn1Fv8t", "fe12ab9d2ac45bba53f60d973e509baad7018641e451304b9fc826663ffe0567", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.67Vn1Fv8t", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.67Vn1Fv8t", "fe12ab9d2ac45bba53f60d973e509baad7018641e451304b9fc826663ffe0567");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityAbandonedLessonAudioProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  activityTimeSpent: number;
  pupilAudioPlayed: boolean;
  isMuted: boolean;
  signedOpened: boolean;
  pupilAudioTimeElapsedSeconds: string;
  numberOfAudios: string;
  audioPlaybackId: string;
  pupilAudioDurationSeconds: number;
  isCaptioned: boolean;
  audioTitle: string;
  transcriptOpened: boolean;
}
/**
 * Lesson Activity Abandoned: Event sent when a pupil has started a lesson activity without completing it, variant description: A audio recording that provides a auditory explanation of the lesson's topic
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.pupilAudioPlayed: True if the play button has been pressed at all during the activity
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.signedOpened: Indicates whether the sign language version of the content has been accessed/viewed
 * @param properties.pupilAudioTimeElapsedSeconds: The amount of time the pupil has spent listening to the audio in seconds
 * @param properties.numberOfAudios: The total count of audios available in a lesson
 * @param properties.audioPlaybackId: Playback Id of a audio
 * @param properties.pupilAudioDurationSeconds: The total length of the audio in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.audioTitle: Title of Audio
 * @param properties.transcriptOpened: if the transcript of the video was accessed/viewed
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lucA3x3s4.6YVHZaiT6}
 */
export function lessonActivityAbandonedLessonAudio(properties: LessonActivityAbandonedLessonAudioProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "3dlfxTW-Q", name: "Pupil Audio Played", value: properties.pupilAudioPlayed});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  eventPropertiesArray.push({id: "BDemZtV2_", name: "Signed Opened", value: properties.signedOpened});
  eventPropertiesArray.push({id: "CZvLiY0yy", name: "Pupil Audio Time Elapsed (Seconds)", value: properties.pupilAudioTimeElapsedSeconds});
  eventPropertiesArray.push({id: "OZLuaJfBN", name: "Number of Audios", value: properties.numberOfAudios});
  eventPropertiesArray.push({id: "OeqPEmbLD", name: "Audio Playback Id", value: properties.audioPlaybackId});
  eventPropertiesArray.push({id: "vxfE3Mvtk", name: "Pupil Audio Duration (Seconds)", value: properties.pupilAudioDurationSeconds});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "xYLviot7x", name: "Audio Title", value: properties.audioTitle});
  eventPropertiesArray.push({id: "z6I3v88k_", name: "Transcript Opened", value: properties.transcriptOpened});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lucA3x3s4.6YVHZaiT6", "4d691f9ed0f0825d47dd26eb180e0aa1a90b71fef3cf002433acba16d2836700", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lucA3x3s4.6YVHZaiT6", "Lesson Activity Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Abandoned", eventProperties, "lucA3x3s4.6YVHZaiT6", "4d691f9ed0f0825d47dd26eb180e0aa1a90b71fef3cf002433acba16d2836700");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAssistantAccessedProperties {
  isLoggedIn: boolean;
  componentType: ComponentTypeValueType;
  product: ProductValueType;
}
/**
 * Lesson Assistant Accessed: A user accesses the AI Lesson Assistant by clicking on the ‘Create a lesson’ button.
 * 
 * When to trigger this event:
 * 1. The user selects the Lesson Planner from the footer menu on the labs homepage
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/xsOZT-77ro/trigger/DLeioZeJ8
 * 2. User clicks on the 'Get started' button from the search results
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/xsOZT-77ro/trigger/LCMU0NPnivcZrJQ58uvzN
 * 
 * @param properties the properties associated with this event
 * @param properties.isLoggedIn: Flags whether the user logged in or not before accessing the Oak object
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/xsOZT-77ro}
 */
export function lessonAssistantAccessed(properties: LessonAssistantAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "p56ECmuX6", name: "Is Logged In", value: properties.isLoggedIn});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "xsOZT-77ro", "9883de706dfdaff012eb0260eedd44c9bffeaf277f94ce4f0411667099248e44", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Assistant Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("xsOZT-77ro", "Lesson Assistant Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Assistant Accessed", eventProperties, "xsOZT-77ro", "9883de706dfdaff012eb0260eedd44c9bffeaf277f94ce4f0411667099248e44");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Assistant Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  journeyId: string | null | undefined;
  navigationType: NavigationTypeValueType | null | undefined;
  accessLevel: AccessLevelValueType | null | undefined;
}
/**
 * Lesson Accessed: Replaces the previous "Lesson Selected" event. Describes a user visiting a lesson in either the Teacher or Pupil Experience, typically at the end of a search or browse journey.
 * 
 * When to trigger this event:
 * 1. Lesson Page is loaded in the Pupil Experience
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/u21IHcK8_t/trigger/8mS2FLJSv
 * 2. Lesson Page is loaded in the Teacher Experience
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/u21IHcK8_t/trigger/MU1FQL9Lp
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/u21IHcK8_t}
 */
export function lessonAccessed(properties: LessonAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  properties.navigationType !== undefined && properties.navigationType !== null ?
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType}) :
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: null});
  properties.accessLevel !== undefined && properties.accessLevel !== null ?
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel}) :
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "u21IHcK8_t", "6f304f1b4b495b4e73cb58f33a34055f1ee93abd5f05fee3b99beee63d124d4a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("u21IHcK8_t", "Lesson Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Accessed", eventProperties, "u21IHcK8_t", "6f304f1b4b495b4e73cb58f33a34055f1ee93abd5f05fee3b99beee63d124d4a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAccessedPupilJourneyProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  journeyId: string | null | undefined;
  navigationType: NavigationTypeValueType | null | undefined;
  accessLevel: AccessLevelValueType | null | undefined;
}
/**
 * Lesson Accessed: Replaces the previous "Lesson Selected" event. Describes a user visiting a lesson in either the Teacher or Pupil Experience, typically at the end of a search or browse journey., event variant
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/u21IHcK8_t.ohEZ3G-E4C1P-RIAsc4D_}
 */
export function lessonAccessedPupilJourney(properties: LessonAccessedPupilJourneyProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  properties.navigationType !== undefined && properties.navigationType !== null ?
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType}) :
    eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: null});
  properties.accessLevel !== undefined && properties.accessLevel !== null ?
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel}) :
    eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "u21IHcK8_t.ohEZ3G-E4C1P-RIAsc4D_", "8bfe59f21e613e6010aecd7c9378e498252f643bd861ed2cefde552cf51f9c8a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("u21IHcK8_t.ohEZ3G-E4C1P-RIAsc4D_", "Lesson Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Accessed", eventProperties, "u21IHcK8_t.ohEZ3G-E4C1P-RIAsc4D_", "8bfe59f21e613e6010aecd7c9378e498252f643bd861ed2cefde552cf51f9c8a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Browse Refined: A step on the Browse Journey is completed "refining" the selection of units/lessons the user is interested in seeing.
 * 
 * When to trigger this event:
 * 1. An example from the Teacher Experience. Clicking on a Key Stage or a Subject would be an example of a refinement
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q/trigger/JfZk0CQKk
 * 2. An example from the Pupil Experience. Selecting a subject would class as a refinement
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q/trigger/4yqBipPtJ
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q}
 */
export function browseRefined(properties: BrowseRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qqX_ISnl2q", "029a9dca4fbb953669ad48199da200ecff505acf09d08f83d9b8a51e7f71f600", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qqX_ISnl2q", "Browse Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Refined", eventProperties, "qqX_ISnl2q", "029a9dca4fbb953669ad48199da200ecff505acf09d08f83d9b8a51e7f71f600");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseRefinedAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Browse Refined: A step on the Browse Journey is completed "refining" the selection of units/lessons the user is interested in seeing.
 * variant description: A special type of refinement that is the "first" step on a browse journey.
 * 
 * When to trigger this event:
 * 1. In the current iteration of the pupil experience the Accessed event will always be a year-group selection
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q.oU4o61r0g/trigger/yqG1kLnrT
 * 2. In the teacher experience the first browse event will always be through a key stage
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q.oU4o61r0g/trigger/jjG0aRtDl
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qqX_ISnl2q.oU4o61r0g}
 */
export function browseRefinedAccessed(properties: BrowseRefinedAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qqX_ISnl2q.oU4o61r0g", "cd6feadf86750d5dc639aa2182b51e62c03dfd3a5bb9f3251c7d76a60ddfc198", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qqX_ISnl2q.oU4o61r0g", "Browse Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Refined", eventProperties, "qqX_ISnl2q.oU4o61r0g", "cd6feadf86750d5dc639aa2182b51e62c03dfd3a5bb9f3251c7d76a60ddfc198");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityDownloadedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Downloaded: Event sent when a pupil has downloaded a lesson activity having clicked the download icon
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/reCapRsfgU/trigger/7ch5HthPl
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/reCapRsfgU}
 */
export function lessonActivityDownloaded(properties: LessonActivityDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "reCapRsfgU", "c20bb3f729f312a0901a2da8ff252e6f93363d839d0492871f209389b25e170e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("reCapRsfgU", "Lesson Activity Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Downloaded", eventProperties, "reCapRsfgU", "c20bb3f729f312a0901a2da8ff252e6f93363d839d0492871f209389b25e170e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonActivityDownloadedWorksheetProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  phase: PhaseValueType;
  releaseGroup: string;
}
/**
 * Lesson Activity Downloaded: Event sent when a pupil has downloaded a lesson activity having clicked the download icon, event variant
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/reCapRsfgU.1gaZkUNtF}
 */
export function lessonActivityDownloadedWorksheet(properties: LessonActivityDownloadedWorksheetProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "reCapRsfgU.1gaZkUNtF", "5a06f34b68319e1b12793947b4f6df5fa51675b8aea78e83b3e829bbb039f03b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Activity Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("reCapRsfgU.1gaZkUNtF", "Lesson Activity Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Activity Downloaded", eventProperties, "reCapRsfgU.1gaZkUNtF", "5a06f34b68319e1b12793947b4f6df5fa51675b8aea78e83b3e829bbb039f03b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Activity Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentGuidanceAcceptedProperties {
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  phase: PhaseValueType;
  supervisionLevel: string;
  contentGuidanceWarning: ContentGuidanceWarningValueType;
  ageRestriction: string;
}
/**
 * Content Guidance Accepted: Event sent when a pupil clicks to accept content guidance, indicating a choice to follow guidance and continues the lesson activity as a result 
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.supervisionLevel: The degree of adult oversight needed during a lesson
 * @param properties.contentGuidanceWarning: The category of the specific content guidance
 * @param properties.ageRestriction: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1u1gDPFXp3}
 */
export function contentGuidanceAccepted(properties: ContentGuidanceAcceptedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "AbSwsn_Lc", name: "Supervision Level", value: properties.supervisionLevel});
  eventPropertiesArray.push({id: "S-dilt6HW", name: "Content Guidance Warning", value: properties.contentGuidanceWarning});
  eventPropertiesArray.push({id: "CF6Y0mOU-_HgShZbz32dP", name: "Age Restriction", value: properties.ageRestriction});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1u1gDPFXp3", "31a4a2fa96f941daaf7ab9e47977cafbc9d56ac23e643f5d59f5f1610555c2a4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Guidance Accepted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1u1gDPFXp3", "Content Guidance Accepted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Guidance Accepted", eventProperties, "1u1gDPFXp3", "31a4a2fa96f941daaf7ab9e47977cafbc9d56ac23e643f5d59f5f1610555c2a4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Guidance Accepted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentGuidanceDeclinedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  supervisionLevel: string;
  phase: PhaseValueType;
  contentGuidanceWarning: ContentGuidanceWarningValueType;
  ageRestriction: string;
}
/**
 * Content Guidance Declined: Event sent when a pupil clicks to decline content guidance, indicating a choice to not follow guidance and discontinues the lesson activity as a result 
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.supervisionLevel: The degree of adult oversight needed during a lesson
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.contentGuidanceWarning: The category of the specific content guidance
 * @param properties.ageRestriction: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/2spbwH8iKS}
 */
export function contentGuidanceDeclined(properties: ContentGuidanceDeclinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "AbSwsn_Lc", name: "Supervision Level", value: properties.supervisionLevel});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "S-dilt6HW", name: "Content Guidance Warning", value: properties.contentGuidanceWarning});
  eventPropertiesArray.push({id: "CF6Y0mOU-_HgShZbz32dP", name: "Age Restriction", value: properties.ageRestriction});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "2spbwH8iKS", "76d79f920b9cff14890f17df246d7908c04eb6f06c15f728dd021a36cefc4203", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Guidance Declined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("2spbwH8iKS", "Content Guidance Declined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Guidance Declined", eventProperties, "2spbwH8iKS", "76d79f920b9cff14890f17df246d7908c04eb6f06c15f728dd021a36cefc4203");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Guidance Declined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ActivityResultsSharedProperties {
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  yearGroupName: string;
  yearGroupSlug: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  phase: PhaseValueType;
  shareMedium: ShareMediumValueType;
  pupilExitQuizGrade: number | null | undefined;
  pupilStarterQuizGrade: number | null | undefined;
  pupilExitQuizNumQuestions: number | null | undefined;
  pupilStarterQuizNumQuesions: number | null | undefined;
  pupilExitQuiz: PupilExitQuiz[] | null | undefined;
  pupilStarterQuiz: PupilStarterQuiz[] | null | undefined;
}
/**
 * Activity Results Shared: Event sent when results of an lesson activity are shared by the pupil which results in visibility for the activity's results by a teacher
 * 
 * @param properties the properties associated with this event
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.shareMedium: The medium through which a link to a resource is shared
 * @param properties.pupilExitQuizGrade: Exit quiz results
 * @param properties.pupilStarterQuizGrade: Starter quiz grade
 * @param properties.pupilExitQuizNumQuestions: Number of questions in the exit quiz
 * @param properties.pupilStarterQuizNumQuesions: Number of questions in the starter quiz
 * @param properties.pupilExitQuiz: no description
 * @param properties.pupilStarterQuiz: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/IEzudJUnh0}
 */
export function activityResultsShared(properties: ActivityResultsSharedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "aMDyFQBYq", name: "Share Medium", value: properties.shareMedium});
  properties.pupilExitQuizGrade !== undefined && properties.pupilExitQuizGrade !== null ?
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: properties.pupilExitQuizGrade}) :
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: null});
  properties.pupilStarterQuizGrade !== undefined && properties.pupilStarterQuizGrade !== null ?
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: properties.pupilStarterQuizGrade}) :
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: null});
  properties.pupilExitQuizNumQuestions !== undefined && properties.pupilExitQuizNumQuestions !== null ?
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: properties.pupilExitQuizNumQuestions}) :
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: null});
  properties.pupilStarterQuizNumQuesions !== undefined && properties.pupilStarterQuizNumQuesions !== null ?
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: properties.pupilStarterQuizNumQuesions}) :
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: null});
  properties.pupilExitQuiz !== undefined && properties.pupilExitQuiz !== null ?
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: properties.pupilExitQuiz.map(function(value) { return {
        "Question Result": value.questionResult,
        "Question Type": value.questionType,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: null});
  properties.pupilStarterQuiz !== undefined && properties.pupilStarterQuiz !== null ?
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: properties.pupilStarterQuiz.map(function(value) { return {
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Type": value.questionType,
        "Question Result": value.questionResult,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPupilExitQuizOptional(properties.pupilExitQuiz));
    messages = messages.concat(assertPupilStarterQuizOptional(properties.pupilStarterQuiz));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "IEzudJUnh0", "a06065ccd28ce504b2f0f44144ea4f5de985fe456351d5d047f802596657308f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Activity Results Shared", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("IEzudJUnh0", "Activity Results Shared", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Activity Results Shared': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Activity Results Shared", eventProperties, "IEzudJUnh0", "a06065ccd28ce504b2f0f44144ea4f5de985fe456351d5d047f802596657308f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Activity Results Shared", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonSummaryReviewedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  pupilWorksheetAvailable: boolean;
  pupilWorksheetDownloaded: boolean;
  pupilExitQuizGrade: number | null | undefined;
  pupilStarterQuizGrade: number | null | undefined;
  pupilExitQuizNumQuestions: number | null | undefined;
  pupilStarterQuizNumQuesions: number | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  phase: PhaseValueType;
  pupilVideoPlayed: boolean;
  pupilVideoDurationSeconds: number | null | undefined;
  pupilVideoTimeElapsedSeconds: number | null | undefined;
  pupilExitQuiz: PupilExitQuiz[] | null | undefined;
  pupilStarterQuiz: PupilStarterQuiz[] | null | undefined;
}
/**
 * Lesson Summary Reviewed: Event sent when a pupil clicks to review the lesson summary after completing a lesson
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.pupilWorksheetAvailable: if a worksheet is provided as a activity for the lesson
 * @param properties.pupilWorksheetDownloaded: Indicates whether the pupil has downloaded the worksheet
 * @param properties.pupilExitQuizGrade: Exit quiz results
 * @param properties.pupilStarterQuizGrade: Starter quiz grade
 * @param properties.pupilExitQuizNumQuestions: Number of questions in the exit quiz
 * @param properties.pupilStarterQuizNumQuesions: Number of questions in the starter quiz
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.pupilVideoPlayed: True if the play button has been pressed at all during the session
 * @param properties.pupilVideoDurationSeconds: The total length of the video in seconds
 * @param properties.pupilVideoTimeElapsedSeconds: The amount of time the pupil has spent watching the video in seconds
 * @param properties.pupilExitQuiz: no description
 * @param properties.pupilStarterQuiz: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/HO-MSD-SiA}
 */
export function lessonSummaryReviewed(properties: LessonSummaryReviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "rNM1I8vY_", name: "Pupil Worksheet Available", value: properties.pupilWorksheetAvailable});
  eventPropertiesArray.push({id: "AbY2tLMm3", name: "Pupil Worksheet Downloaded", value: properties.pupilWorksheetDownloaded});
  properties.pupilExitQuizGrade !== undefined && properties.pupilExitQuizGrade !== null ?
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: properties.pupilExitQuizGrade}) :
    eventPropertiesArray.push({id: "kKResr6NX", name: "Pupil Exit Quiz Grade", value: null});
  properties.pupilStarterQuizGrade !== undefined && properties.pupilStarterQuizGrade !== null ?
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: properties.pupilStarterQuizGrade}) :
    eventPropertiesArray.push({id: "Ic-9YBoqQ", name: "Pupil Starter Quiz Grade", value: null});
  properties.pupilExitQuizNumQuestions !== undefined && properties.pupilExitQuizNumQuestions !== null ?
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: properties.pupilExitQuizNumQuestions}) :
    eventPropertiesArray.push({id: "DmB2Yp30-", name: "Pupil Exit Quiz Num Questions", value: null});
  properties.pupilStarterQuizNumQuesions !== undefined && properties.pupilStarterQuizNumQuesions !== null ?
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: properties.pupilStarterQuizNumQuesions}) :
    eventPropertiesArray.push({id: "xgYuO9ij1", name: "Pupil Starter Quiz Num Quesions", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "hmpQPI6sI", name: "Pupil Video Played", value: properties.pupilVideoPlayed});
  properties.pupilVideoDurationSeconds !== undefined && properties.pupilVideoDurationSeconds !== null ?
    eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: properties.pupilVideoDurationSeconds}) :
    eventPropertiesArray.push({id: "4Ei7ce0ZP", name: "Pupil Video Duration (Seconds)", value: null});
  properties.pupilVideoTimeElapsedSeconds !== undefined && properties.pupilVideoTimeElapsedSeconds !== null ?
    eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: properties.pupilVideoTimeElapsedSeconds}) :
    eventPropertiesArray.push({id: "cOQ8T6zw3", name: "Pupil Video Time Elapsed (Seconds)", value: null});
  properties.pupilExitQuiz !== undefined && properties.pupilExitQuiz !== null ?
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: properties.pupilExitQuiz.map(function(value) { return {
        "Question Result": value.questionResult,
        "Question Type": value.questionType,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "BvJKWCkFc", name: "Pupil Exit Quiz", value: null});
  properties.pupilStarterQuiz !== undefined && properties.pupilStarterQuiz !== null ?
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: properties.pupilStarterQuiz.map(function(value) { return {
        "Pupil Experience Lesson Activity": value.pupilExperienceLessonActivity,
        "Question Type": value.questionType,
        "Question Result": value.questionResult,
        "Hint Offered": value.hintOffered,
        "Hint Accessed": value.hintAccessed,
        "Question Number": value.questionNumber,
      }
    })}) :
    eventPropertiesArray.push({id: "GUtiqMHeN", name: "Pupil Starter Quiz", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertPupilExitQuizOptional(properties.pupilExitQuiz));
    messages = messages.concat(assertPupilStarterQuizOptional(properties.pupilStarterQuiz));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HO-MSD-SiA", "731c8c94b0ff21a982ab120d1e28ae02c0c0be4c10727f51bd7ad24d1a9f75cd", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Summary Reviewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HO-MSD-SiA", "Lesson Summary Reviewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'Lesson Summary Reviewed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Summary Reviewed", eventProperties, "HO-MSD-SiA", "731c8c94b0ff21a982ab120d1e28ae02c0c0be4c10727f51bd7ad24d1a9f75cd");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Summary Reviewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserSignMinusUpCompletedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType | null | undefined;
  userId_: string;
  singleSignOnService: SingleSignOnServiceValueType;
}
/**
 * User Sign-Up Completed: A user creates a clerk account using SSO / email. At this point they are considerd to be "signed-up" and will go into the "onboarding" journey.
 * Platform: [owa, aila-beta]
 * Product: user account management
 * Engagement Intent: explore
 * Component Type: [see property description]
 * Event Version: 2.0.0
 * Analytics Use Case: N/A
 * 
 * When to trigger this event:
 * 1. A user uses SSO or email/password combination to create an account in Clerk.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/fOlHJypRwg/trigger/aV1XekNBLU
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.singleSignOnService: The Single Sign-On (SSO) Service used at a given stage of sign-up / sign-on.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/fOlHJypRwg}
 */
export function userSignUpCompleted(properties: UserSignMinusUpCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  properties.analyticsUseCase !== undefined && properties.analyticsUseCase !== null ?
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase}) :
    eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: null});
  eventPropertiesArray.push({id: "03PfePESj", name: "Single Sign-on Service", value: properties.singleSignOnService});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "fOlHJypRwg", "4dda9ebf5b05a34746dca54ed76dfc2198849e0c6d0f44d41982056bb3757a13", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-Up Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("fOlHJypRwg", "User Sign-Up Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-Up Completed", eventProperties, "fOlHJypRwg", "4dda9ebf5b05a34746dca54ed76dfc2198849e0c6d0f44d41982056bb3757a13");
    }
    // destination PostHogEU
    PostHogEU.identify(properties.userId_);
    PostHogEU.logEvent("User Sign-Up Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingCompletedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  userId_: string;
  signUpDate: string;
  userRoleType: UserRoleTypeValueType | null | undefined;
  teacherSchoolUrn: string | null | undefined;
  userDefinedRole: string | null | undefined;
  userDetailsLastModifiedDate: string;
  userAccountVerificationStatus: UserAccountVerificationStatusValueType;
  teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined;
}
/**
 * User Onboarding Completed: The user completes the sign-up process for an account.
 * Platform: [owa, aila-beta]
 * Product: user account management
 * Engagement Intent: explore
 * Component Type: [see property description]
 * Event Version: 2.0.0
 * Analytics Use Case: N/A
 * 
 * When to trigger this event:
 * 1. A teacher user completes the final stage of the onboarding journey (either continue or skip) and onboarding is complete.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1Wfnj8Bspf/trigger/rwg0-pla4a
 * 2. A non-teacher user completes the final stage of the onboarding journey and can be thought of as having completed the onboarding journey
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1Wfnj8Bspf/trigger/mA2lAiF3la
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.signUpDate: The date a user signed-up for an account in YYYY-MM-DD format., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userRoleType: The type of role the signed-in user holds. As defined when they sign-up or edit their details. This is used to differentiate between those with Teacher and Other types of Roles.
 * @param properties.teacherSchoolUrn: The Unique Reference Number (URN) of the school which a signed in user (or a user who has downloaded lesson resources) has provided. For English and Welsh Schools this is a 6 digit number, for Scottish Schools this is a 7 digit number (Seed number) and for NI Schools it is a 3 digit number followed by a four digit number., should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.userDefinedRole: Used in cases where the User Role Type is set to 'Other'. Free text which best describes a user's role
 * @param properties.userDetailsLastModifiedDate: The date on which a user last modified their details., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userAccountVerificationStatus: The status of the user account
 * @param properties.teacherSchoolManualEntryDetails: A small object containing the manually entered details of a users school when it is not available in the school picker.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1Wfnj8Bspf}
 */
export function userOnboardingCompleted(properties: UserOnboardingCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: properties.signUpDate});
  properties.userRoleType !== undefined && properties.userRoleType !== null ?
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: properties.userRoleType}) :
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: null});
  properties.teacherSchoolUrn !== undefined && properties.teacherSchoolUrn !== null ?
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: properties.teacherSchoolUrn}) :
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: null});
  properties.userDefinedRole !== undefined && properties.userDefinedRole !== null ?
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: properties.userDefinedRole}) :
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: null});
  userPropertiesArray.push({id: "Tnbcjv4vnh", name: "User Details Last Modified Date", value: properties.userDetailsLastModifiedDate});
  userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: properties.userAccountVerificationStatus});
  properties.teacherSchoolManualEntryDetails !== undefined && properties.teacherSchoolManualEntryDetails !== null ?
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: {
      "School Name Text": properties.teacherSchoolManualEntryDetails.schoolNameText,
      "School Address Text": properties.teacherSchoolManualEntryDetails.schoolAddressText,
    }}) :
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTeacherSchoolManualEntryDetailsOptional(properties.teacherSchoolManualEntryDetails));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1Wfnj8Bspf", "b5b08d9647aa9cdd66f12b9f622167dfa1477263782826f225bdbf89b3d4e891", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Onboarding Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1Wfnj8Bspf", "User Onboarding Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'User Onboarding Completed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Onboarding Completed", eventProperties, "1Wfnj8Bspf", "b5b08d9647aa9cdd66f12b9f622167dfa1477263782826f225bdbf89b3d4e891");
    }
    // destination PostHogEU
    PostHogEU.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
    PostHogEU.logEvent("User Onboarding Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserSignMinusInProperties {
  userId_: string;
}
/**
 * User Sign-In: A user signs in to a pre-existing account
 * 
 * @param properties the properties associated with this event
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/KiDGLM5Isg}
 */
export function userSignIn(properties: UserSignMinusInProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "KiDGLM5Isg", "8aa23f39ed39354945297f5ada68807d8d0b2a4d47ed9980b245d330b068eec0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-In", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("KiDGLM5Isg", "User Sign-In", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-In", eventProperties, "KiDGLM5Isg", "8aa23f39ed39354945297f5ada68807d8d0b2a4d47ed9980b245d330b068eec0");
    }
    // destination PostHogEU
    PostHogEU.identify(properties.userId_);
    PostHogEU.logEvent("User Sign-In", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * User Sign-Out: A user signs-out of their account
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/j0lSWreaah}
 */
export function userSignOut() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "j0lSWreaah", "42616b156d70c13c23335f03d22bbc19c51f0ebb8a8b802d7e1a4792fee8d533", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Sign-Out", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("j0lSWreaah", "User Sign-Out", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("User Sign-Out", eventProperties, "j0lSWreaah", "42616b156d70c13c23335f03d22bbc19c51f0ebb8a8b802d7e1a4792fee8d533");
    }
    // destination PostHogEU
    PostHogEU.logEvent("User Sign-Out", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonAbandonedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
  phase: PhaseValueType;
}
/**
 * Lesson Abandoned: Event sent when lesson is abandoned before completion
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qv9EeULbT}
 */
export function lessonAbandoned(properties: LessonAbandonedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qv9EeULbT", "4b7d84e30e685d1160ad9ffd77a7d769c352d791452742de808c1e604dd32537", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Abandoned", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qv9EeULbT", "Lesson Abandoned", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Abandoned", eventProperties, "qv9EeULbT", "4b7d84e30e685d1160ad9ffd77a7d769c352d791452742de808c1e604dd32537");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Abandoned", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface BrowseAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Browse Accessed: The browse experience has been accessed
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/MFzroCdj0}
 */
export function browseAccessed(properties: BrowseAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "MFzroCdj0", "6a49aa22fcc3f7d6c98361793702eef04ff516f6a9cf5f6ef107d0a8f414fb8d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Browse Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("MFzroCdj0", "Browse Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Browse Accessed", eventProperties, "MFzroCdj0", "6a49aa22fcc3f7d6c98361793702eef04ff516f6a9cf5f6ef107d0a8f414fb8d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Browse Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface QuestionAttemptSubmittedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  courseId: string | null | undefined;
  itemId: string | null | undefined;
  attachmentId: string | null | undefined;
  submissionId: string | null | undefined;
  classroomAssignmentId: string | null | undefined;
  teacherLoginHint: string | null | undefined;
  pupilLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  pupilExperienceLessonActivity: PupilExperienceLessonActivityValueType;
  phase: PhaseValueType;
  releaseGroup: string;
  questionResult: QuestionResultValueType;
  questionType: string;
  activityTimeSpent: number;
  hintOffered: boolean;
  hintAccessed: boolean;
  questionNumber: number;
}
/**
 * Question Attempt Submitted: Event sent everytime a quiz question is attempted
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.attachmentId: Google Classroom Attachment ID
 * @param properties.submissionId: Google Classroom Pupil Submission Id
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * @param properties.teacherLoginHint: Google Classroom Teacher Login Hint
 * @param properties.pupilLoginHint: Google Classroom Pupil Login Hint
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.pupilExperienceLessonActivity: All Oak pupil lessons have a set of sections which can be interacted with. This property tracks which section a particular action (e.g. starting, completing, abandoning) a particular event relates to.
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.questionResult: whether or not the question was answered correctly
 * @param properties.questionType: no description
 * @param properties.activityTimeSpent: time spent on activity in seconds
 * @param properties.hintOffered: no description
 * @param properties.hintAccessed: no description
 * @param properties.questionNumber: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/oxHJDrfL0el}
 */
export function questionAttemptSubmitted(properties: QuestionAttemptSubmittedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.attachmentId !== undefined && properties.attachmentId !== null ?
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: properties.attachmentId}) :
    eventPropertiesArray.push({id: "swlx4QcvoIk-ljB5gS8qF", name: "Attachment Id", value: null});
  properties.submissionId !== undefined && properties.submissionId !== null ?
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: properties.submissionId}) :
    eventPropertiesArray.push({id: "rzaH7Opf5kbjaT3mUuP_v", name: "Submission Id", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  properties.teacherLoginHint !== undefined && properties.teacherLoginHint !== null ?
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: properties.teacherLoginHint}) :
    eventPropertiesArray.push({id: "JnDwcpiwitJ7k-tJ-LbNh", name: "Teacher Login Hint", value: null});
  properties.pupilLoginHint !== undefined && properties.pupilLoginHint !== null ?
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: properties.pupilLoginHint}) :
    eventPropertiesArray.push({id: "e1RKlQxiyzPf_uYY0wYuq", name: "Pupil Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Vv6ZE-oYpa", name: "Pupil Experience Lesson Activity", value: properties.pupilExperienceLessonActivity});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  eventPropertiesArray.push({id: "FNZnup8Lj", name: "Question Result", value: properties.questionResult});
  eventPropertiesArray.push({id: "fO393FGJA", name: "Question Type", value: properties.questionType});
  eventPropertiesArray.push({id: "F-TPy5pKs", name: "Activity Time Spent", value: properties.activityTimeSpent});
  eventPropertiesArray.push({id: "2Hdg058Fn", name: "Hint Offered", value: properties.hintOffered});
  eventPropertiesArray.push({id: "1nV6NwNSF", name: "Hint Accessed", value: properties.hintAccessed});
  eventPropertiesArray.push({id: "Ya3cRG6Q-", name: "Question Number", value: properties.questionNumber});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oxHJDrfL0el", "a0661c304be55fe2c5a8ef2346062b2b77e39c1b7e83913668a4f0f967b57326", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Question Attempt Submitted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oxHJDrfL0el", "Question Attempt Submitted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Question Attempt Submitted", eventProperties, "oxHJDrfL0el", "a0661c304be55fe2c5a8ef2346062b2b77e39c1b7e83913668a4f0f967b57326");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Question Attempt Submitted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareInitiatedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  sourcePageSlug: string | null | undefined;
}
/**
 * Teacher Share Initiated: On initial access of a page with a share with teacher button
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/4zw48vJqLbd}
 */
export function teacherShareInitiated(properties: TeacherShareInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4zw48vJqLbd", "2b435f1ede8363b1c9505026ea45caa434a021c00a6c30a4736edd967a3167c0", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4zw48vJqLbd", "Teacher Share Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Initiated", eventProperties, "4zw48vJqLbd", "2b435f1ede8363b1c9505026ea45caa434a021c00a6c30a4736edd967a3167c0");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareActivatedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  sourcePageSlug: string | null | undefined;
  shareId: string;
  linkUrl: string;
  noteLengthChars: number | null | undefined;
}
/**
 * Teacher Share Activated: When a share is activated by pressing a button
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.shareId: unique id associated with a share event
 * @param properties.linkUrl: The href of a link
 * @param properties.noteLengthChars: The character length of a teacher note
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/ttpIP3aUQX2}
 */
export function teacherShareActivated(properties: TeacherShareActivatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  properties.noteLengthChars !== undefined && properties.noteLengthChars !== null ?
    eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: properties.noteLengthChars}) :
    eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ttpIP3aUQX2", "c81ba4b9b3bc357c638c72a21b5013385e263b450fe3cf47c83d6addb724d08c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Activated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ttpIP3aUQX2", "Teacher Share Activated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Activated", eventProperties, "ttpIP3aUQX2", "c81ba4b9b3bc357c638c72a21b5013385e263b450fe3cf47c83d6addb724d08c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Activated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherShareConvertedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  linkUrl: string;
}
/**
 * Teacher Share Converted: The first time another user accesses a share url
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.linkUrl: The href of a link
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/ANLiC7JLe7-}
 */
export function teacherShareConverted(properties: TeacherShareConvertedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ANLiC7JLe7-", "ef8498517ea795f3619ac9cc9838c973841700261558076946e09c06f347971a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Share Converted", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ANLiC7JLe7-", "Teacher Share Converted", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Share Converted", eventProperties, "ANLiC7JLe7-", "ef8498517ea795f3619ac9cc9838c973841700261558076946e09c06f347971a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Share Converted", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitDownloadedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  journeyId: string | null | undefined;
  accessLevel: AccessLevelValueType;
}
/**
 * Unit Downloaded: A user clicks the unit download button on a lesson listing page when signed in
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/72bRke5-7b0}
 */
export function unitDownloaded(properties: UnitDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "72bRke5-7b0", "da3903239c4ec072bbb796b52a100873980b74fa349483f6d1cd1ad54ef31bbb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("72bRke5-7b0", "Unit Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Downloaded", eventProperties, "72bRke5-7b0", "da3903239c4ec072bbb796b52a100873980b74fa349483f6d1cd1ad54ef31bbb");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherNoteDialogueOpenedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string | null | undefined;
  sourcePageSlug: string | null | undefined;
  linkUrl: string | null | undefined;
}
/**
 * Teacher Note Dialogue Opened: Sent every time the add / edit teacher note dialogue is opened on the lesson overview page
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.linkUrl: The href of a link
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/ZfGgVMk2GGv2hxZQMZDBl}
 */
export function teacherNoteDialogueOpened(properties: TeacherNoteDialogueOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.shareId !== undefined && properties.shareId !== null ?
    eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId}) :
    eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: null});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  properties.linkUrl !== undefined && properties.linkUrl !== null ?
    eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl}) :
    eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ZfGgVMk2GGv2hxZQMZDBl", "de8a6a0d8845e922a0a081a9314c737775022b12b8b71fe70e9b99e7997854e3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Note Dialogue Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ZfGgVMk2GGv2hxZQMZDBl", "Teacher Note Dialogue Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Note Dialogue Opened", eventProperties, "ZfGgVMk2GGv2hxZQMZDBl", "de8a6a0d8845e922a0a081a9314c737775022b12b8b71fe70e9b99e7997854e3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Note Dialogue Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeacherNoteSavedProperties {
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  shareId: string;
  sourcePageSlug: string | null | undefined;
  linkUrl: string;
  noteLengthChars: number;
}
/**
 * Teacher Note Saved: No description
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.shareId: unique id associated with a share event
 * @param properties.sourcePageSlug: The slug portion of the url used to identify the page (on Oak's Website) from which an event was triggered. (e.g.  'teachers/curriculum/english-primary/units')
 * @param properties.linkUrl: The href of a link
 * @param properties.noteLengthChars: The character length of a teacher note
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/rY3jUdERBSrdNUQPY_2h-}
 */
export function teacherNoteSaved(properties: TeacherNoteSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ASdeLYeIiF", name: "Share Id", value: properties.shareId});
  properties.sourcePageSlug !== undefined && properties.sourcePageSlug !== null ?
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: properties.sourcePageSlug}) :
    eventPropertiesArray.push({id: "MU9o8TQ-6s", name: "Source Page Slug", value: null});
  eventPropertiesArray.push({id: "cJ1c_F_Qih", name: "Link URL", value: properties.linkUrl});
  eventPropertiesArray.push({id: "O3iW9GlOX3vMEXtryknax", name: "Note Length Chars", value: properties.noteLengthChars});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "rY3jUdERBSrdNUQPY_2h-", "ac49b7707578d1dbb11e3afcf8160f8a22c93de9c6fddb65822ad840829af66b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teacher Note Saved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("rY3jUdERBSrdNUQPY_2h-", "Teacher Note Saved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teacher Note Saved", eventProperties, "rY3jUdERBSrdNUQPY_2h-", "ac49b7707578d1dbb11e3afcf8160f8a22c93de9c6fddb65822ad840829af66b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teacher Note Saved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserExitedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  yearGroupName: string;
  yearGroupSlug: string;
}
/**
 * Curriculum Visualiser Exited: A user moves onto another product on the site and therefore leaves the Curriculum Visualiser. This is currently done by moving onto a Unit listing page from a unit Modal by clicking on ‘See lessons in unit’.
 * 
 * When to trigger this event:
 * 1. User clicks on 'See lessons in unit'
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/zsO3YXYKon/trigger/DevPKYouf
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/zsO3YXYKon}
 */
export function curriculumVisualiserExited(properties: CurriculumVisualiserExitedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "zsO3YXYKon", "3b444ddf92071084ca8525414c5034903766933eb071e045f244ad69017be42b", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Exited", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("zsO3YXYKon", "Curriculum Visualiser Exited", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Exited", eventProperties, "zsO3YXYKon", "3b444ddf92071084ca8525414c5034903766933eb071e045f244ad69017be42b");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Exited", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumVisualiserTabAccessedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
}
/**
 * Curriculum Visualiser Tab Accessed: The user clicks on one of the tabs displayed within the Curriculum Visualiser e.g. 'Unit Sequence', 'Explainer' or 'Download'
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lyC0uySKzt/trigger/PcASRZWOw1ku51PJZc9CB
 * 2. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lyC0uySKzt/trigger/D1VxROFKdnXDVTvFaw9Gs
 * 3. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lyC0uySKzt/trigger/fgn-xU4Zxy0ZQxt_KOcnH
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/lyC0uySKzt}
 */
export function curriculumVisualiserTabAccessed(properties: CurriculumVisualiserTabAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "lyC0uySKzt", "0226c9dc90b52dc3d6bfeb2a93906f78759bb69264482d0425a86cad3faa013a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Visualiser Tab Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("lyC0uySKzt", "Curriculum Visualiser Tab Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Visualiser Tab Accessed", eventProperties, "lyC0uySKzt", "0226c9dc90b52dc3d6bfeb2a93906f78759bb69264482d0425a86cad3faa013a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Visualiser Tab Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitOverviewExploredProperties {
  subjectTitle: string;
  subjectSlug: string;
  threadTitle: string;
  threadSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  unitName: string;
  unitSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Unit Overview Explored: The user interacts with a unit overview by clicking on one of the buttons on the pop out.
 * 
 * When to trigger this event:
 * 1. User clicks on one of the accordians within the unit overview pop out
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/i6-nnHEIYs/trigger/1eRpH5Gxy
 * 2. Depending on the unit, the accordian tab names will vary
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/i6-nnHEIYs/trigger/Iy1Mdcswp_HFz7gu3Vkv8
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.threadTitle: The title (in plain English including spaces) of a thread corresponding to a sequence of lessons across units
 * @param properties.threadSlug: The human readable identifier (n-kebab-case) for a sequence of lessons
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/i6-nnHEIYs}
 */
export function unitOverviewExplored(properties: UnitOverviewExploredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "5vqHiL5Sh", name: "Thread Title", value: properties.threadTitle});
  eventPropertiesArray.push({id: "E1mlACg_OT", name: "Thread Slug", value: properties.threadSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "i6-nnHEIYs", "30cb36e3547f39161a8b1e2414c27c23d036f102bbff58c89213447aab272e3f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Overview Explored", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("i6-nnHEIYs", "Unit Overview Explored", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Overview Explored", eventProperties, "i6-nnHEIYs", "30cb36e3547f39161a8b1e2414c27c23d036f102bbff58c89213447aab272e3f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Overview Explored", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProductHomepageAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Product Homepage Accessed: A user selects one of Oak's products from the tabs available on the homepage e.g. Lesson Teaching Resources, Curriculum Plans, AI Experiments, Pupils
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/a85DGvpxPtzycSgl20lbY
 * 2. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/dWx1KqJ9Z1YDgC5lDOY94
 * 3. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/MMsrYL3JK596X0m5vVdWP
 * 4. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Lftzxt-mHyPsAzsv5H2Vi/trigger/Crn6BaMk17vcqoYOgaFs1
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Lftzxt-mHyPsAzsv5H2Vi}
 */
export function productHomepageAccessed(properties: ProductHomepageAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Lftzxt-mHyPsAzsv5H2Vi", "052300cc2b8ddd4155b867a5b1cc3a0218cb96d18ed3af644509a0ee73c8cb93", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Product Homepage Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Lftzxt-mHyPsAzsv5H2Vi", "Product Homepage Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Product Homepage Accessed", eventProperties, "Lftzxt-mHyPsAzsv5H2Vi", "052300cc2b8ddd4155b867a5b1cc3a0218cb96d18ed3af644509a0ee73c8cb93");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Product Homepage Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumLandingPageAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Curriculum Landing Page Accessed: The user clicks on the 'Our curriculum planning approach' button on the Curriculum Plans tab of the Oak homepage.
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Sv8oxJgYPLCidSo_wxLpN/trigger/6A2Ow5TjrtpMpDLy_gR_n
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Sv8oxJgYPLCidSo_wxLpN}
 */
export function curriculumLandingPageAccessed(properties: CurriculumLandingPageAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Sv8oxJgYPLCidSo_wxLpN", "3d0fe7c2773c5f0cb28748568448a9550da0d429e3c0070b9fe3a3cda0b9beee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Landing Page Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Sv8oxJgYPLCidSo_wxLpN", "Curriculum Landing Page Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Landing Page Accessed", eventProperties, "Sv8oxJgYPLCidSo_wxLpN", "3d0fe7c2773c5f0cb28748568448a9550da0d429e3c0070b9fe3a3cda0b9beee");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Landing Page Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumExplainerExploredProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
  journeyId: string | null | undefined;
}
/**
 * Curriculum Explainer Explored: User navigates to any of the areas of the contents page within the Explainer tab of the Curriculum Visualiser
 * 
 * When to trigger this event:
 * 1. User navigates to any of the contents on the left
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/FP1B-pCMEjGG0k3hk6oXU/trigger/YgOtQr6ps2icWqT4X3JT7
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/FP1B-pCMEjGG0k3hk6oXU}
 */
export function curriculumExplainerExplored(properties: CurriculumExplainerExploredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FP1B-pCMEjGG0k3hk6oXU", "c7986aea54f1364f6357820dd590db890dfab4686fb0e36d2ee89b5de777c7ee", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Explainer Explored", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FP1B-pCMEjGG0k3hk6oXU", "Curriculum Explainer Explored", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Explainer Explored", eventProperties, "FP1B-pCMEjGG0k3hk6oXU", "c7986aea54f1364f6357820dd590db890dfab4686fb0e36d2ee89b5de777c7ee");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Explainer Explored", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumResourcesDownloadRefinedProperties {
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  childSubjectSlug: string;
  childSubjectName: string;
  learningTier: LearningTierValueType;
  journeyId: string | null | undefined;
}
/**
 * Curriculum Resources Download Refined: For certain subjects/phasees, the user narrows down which subject/phase they wish to download curriculum resources for.
 * 
 * When to trigger this event:
 * 1. User selects a subject and learning tier to download curriculum resources for
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/cTKf4kbAHd211SR05Bbq8/trigger/j79s4AM_FvlH_6oP87NBj
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.childSubjectSlug: Slug of Child Subject associated with the event
 * @param properties.childSubjectName: Name of the Child Subject Associated with the event
 * @param properties.learningTier: Learning tier that was selected
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/cTKf4kbAHd211SR05Bbq8}
 */
export function curriculumResourcesDownloadRefined(properties: CurriculumResourcesDownloadRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "S4dKDojap", name: "Child Subject Slug", value: properties.childSubjectSlug});
  eventPropertiesArray.push({id: "5QAyZtsHD", name: "Child Subject Name", value: properties.childSubjectName});
  eventPropertiesArray.push({id: "uWHOnx61K", name: "Learning Tier", value: properties.learningTier});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "cTKf4kbAHd211SR05Bbq8", "a0ad07c1830a4705d75031c83c8bac6425b8d4352ade9e32af706dcdac8c446d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Resources Download Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("cTKf4kbAHd211SR05Bbq8", "Curriculum Resources Download Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Resources Download Refined", eventProperties, "cTKf4kbAHd211SR05Bbq8", "a0ad07c1830a4705d75031c83c8bac6425b8d4352ade9e32af706dcdac8c446d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Resources Download Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SearchFilterModifiedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  filterModificationType: FilterModificationTypeValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  searchTerm: string;
  searchFilterMatchType: SearchFilterMatchTypeValueType;
  navigationType: NavigationTypeValueType;
  accessLevel: AccessLevelValueType;
}
/**
 * Search Filter Modified: A search filter is added or removed using the filter buttons 
 * 
 * When to trigger this event:
 * 1. A search filter button is selected.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/JbWzId2dPo6mN6Y3aHwMr/trigger/Cx9_xD-MYDD1Tt00diuFC
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.filterModificationType: Describes whether a filter is being added to search ('add') or removed ('remove')
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.searchTerm: The term entered by the user for the search.
 * @param properties.searchFilterMatchType: Whether the filters applied are applied via Fuzzy Match or AI.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/JbWzId2dPo6mN6Y3aHwMr}
 */
export function searchFilterModified(properties: SearchFilterModifiedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "0M2Ix3r8aivly0Q1sFyLs", name: "Filter Modification Type", value: properties.filterModificationType});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "hHufJiP_N", name: "Search Term", value: properties.searchTerm});
  eventPropertiesArray.push({id: "-nKy8whA8hSlYVy8JvRjJ", name: "Search Filter Match Type", value: properties.searchFilterMatchType});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "JbWzId2dPo6mN6Y3aHwMr", "4acbacad6d93a286e25bc212c6d24b1afababc30bb1c1d52c12b9827f37b4fb1", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Search Filter Modified", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("JbWzId2dPo6mN6Y3aHwMr", "Search Filter Modified", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Search Filter Modified", eventProperties, "JbWzId2dPo6mN6Y3aHwMr", "4acbacad6d93a286e25bc212c6d24b1afababc30bb1c1d52c12b9827f37b4fb1");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Search Filter Modified", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface LessonMediaClipsStartedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  learningCycle: string | null | undefined;
  releaseGroup: string;
  phase: PhaseValueType | null | undefined;
  mediaClipsButtonName: MediaClipsButtonNameValueType;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  journeyId: string | null | undefined;
}
/**
 * Lesson Media Clips Started: A media clips button is pressed on the lesson overview page
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.learningCycle: media clips are grouped by learning cycles within a lesson
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.mediaClipsButtonName: The button the user selected to start media clips
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/YbxoviiZ7zqvdvU_8FRv9}
 */
export function lessonMediaClipsStarted(properties: LessonMediaClipsStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.learningCycle !== undefined && properties.learningCycle !== null ?
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: properties.learningCycle}) :
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: null});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  eventPropertiesArray.push({id: "BHWrIWv1_j8CL9nGB_oHk", name: "Media Clips Button Name", value: properties.mediaClipsButtonName});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "YbxoviiZ7zqvdvU_8FRv9", "12ebcdfb72537022d31b41be85cf199244842f04c0273ccb388e5eb814ec6365", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Lesson Media Clips Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("YbxoviiZ7zqvdvU_8FRv9", "Lesson Media Clips Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Lesson Media Clips Started", eventProperties, "YbxoviiZ7zqvdvU_8FRv9", "12ebcdfb72537022d31b41be85cf199244842f04c0273ccb388e5eb814ec6365");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Lesson Media Clips Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface MediaClipsPlaylistPlayedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  durationSeconds: number;
  isCaptioned: boolean;
  videoPlaybackId: string[];
  videoTitle: string;
  timeElapsedSeconds: number;
  isMuted: boolean;
  videoLocation: VideoLocationValueType | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  subjectTitle: string | null | undefined;
  subjectSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
  yearGroupName: string | null | undefined;
  yearGroupSlug: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  mediaClipsCount: number;
  mediaClipIndex: number;
  learningCycle: string | null | undefined;
  releaseGroup: string;
  phase: PhaseValueType | null | undefined;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  journeyId: string | null | undefined;
}
/**
 * Media Clips Playlist Played: A user plays one of the media clips video or audios
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.durationSeconds: Video length in seconds
 * @param properties.isCaptioned: Indicates whether captions were enabled when the event was triggered
 * @param properties.videoPlaybackId: Playback Id of a mux video
 * @param properties.videoTitle: Title of video
 * @param properties.timeElapsedSeconds: Progress made through a video in seconds
 * @param properties.isMuted: Indicates whether video was muted when the event was triggered
 * @param properties.videoLocation: Where is the video on the site (eg. webinar, marketing, lesson, blog, etc)
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.mediaClipsCount: The number of media clips in a learning cycle group
 * @param properties.mediaClipIndex: The index of the media clip within a group of clips grouped by learning cycle
 * @param properties.learningCycle: media clips are grouped by learning cycles within a lesson
 * @param properties.releaseGroup: Categorisation used to identify and distinguish different batches or versions of content based on when they became available on Oak's Platform (e.g legacy, cohort)
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/VvOi9lNYmXNrmqXMSkT-X}
 */
export function mediaClipsPlaylistPlayed(properties: MediaClipsPlaylistPlayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "NqtddGscIh", name: "Duration (Seconds)", value: properties.durationSeconds});
  eventPropertiesArray.push({id: "xHdFKUwmsd", name: "Is Captioned", value: properties.isCaptioned});
  eventPropertiesArray.push({id: "ueSG_AEgt", name: "Video Playback Id", value: properties.videoPlaybackId});
  eventPropertiesArray.push({id: "S98ZxfGtRh", name: "Video Title", value: properties.videoTitle});
  eventPropertiesArray.push({id: "3a0mowzVyL", name: "Time Elapsed (Seconds)", value: properties.timeElapsedSeconds});
  eventPropertiesArray.push({id: "8AC7R8LYpO", name: "Is Muted", value: properties.isMuted});
  properties.videoLocation !== undefined && properties.videoLocation !== null ?
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: properties.videoLocation}) :
    eventPropertiesArray.push({id: "62ypa-_ys", name: "Video Location", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.subjectTitle !== undefined && properties.subjectTitle !== null ?
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle}) :
    eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: null});
  properties.subjectSlug !== undefined && properties.subjectSlug !== null ?
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug}) :
    eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  properties.yearGroupName !== undefined && properties.yearGroupName !== null ?
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName}) :
    eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: null});
  properties.yearGroupSlug !== undefined && properties.yearGroupSlug !== null ?
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug}) :
    eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  eventPropertiesArray.push({id: "TgO2h8F6IqCxcyo-lpYvs", name: "Media Clips Count", value: properties.mediaClipsCount});
  eventPropertiesArray.push({id: "ZygH-hGIazCYTEblKBWcB", name: "Media Clip Index", value: properties.mediaClipIndex});
  properties.learningCycle !== undefined && properties.learningCycle !== null ?
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: properties.learningCycle}) :
    eventPropertiesArray.push({id: "1VlnBdNXVpsZ1kfInJRHO", name: "Learning Cycle ", value: null});
  eventPropertiesArray.push({id: "CUxL56KQZ", name: "Release Group", value: properties.releaseGroup});
  properties.phase !== undefined && properties.phase !== null ?
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase}) :
    eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: null});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "VvOi9lNYmXNrmqXMSkT-X", "a5bc0db6089a526ffcf64cfea6cd177e931b35f62ec725d1b2ed63d355d6b94f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Media Clips Playlist Played", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("VvOi9lNYmXNrmqXMSkT-X", "Media Clips Playlist Played", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Media Clips Playlist Played", eventProperties, "VvOi9lNYmXNrmqXMSkT-X", "a5bc0db6089a526ffcf64cfea6cd177e931b35f62ec725d1b2ed63d355d6b94f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Media Clips Playlist Played", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentSavedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  contentType: string;
  contentItemSlug: string;
}
/**
 * Content Saved: A user initiated an action to save content (eg. a unit) to their library
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.contentType: no description
 * @param properties.contentItemSlug: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/SA9Od8Lltuc37iY7IHGP4}
 */
export function contentSaved(properties: ContentSavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "uHgsqow6CcsK85HcAIT2e", name: "Content Type", value: properties.contentType});
  eventPropertiesArray.push({id: "UPAbTsstCdNHv2HJZ20fj", name: "Content Item Slug", value: properties.contentItemSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "SA9Od8Lltuc37iY7IHGP4", "a8c29232a30681b2b9a79ed75fec305247b815ddf4f10465482b96641ce4379c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Saved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("SA9Od8Lltuc37iY7IHGP4", "Content Saved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Saved", eventProperties, "SA9Od8Lltuc37iY7IHGP4", "a8c29232a30681b2b9a79ed75fec305247b815ddf4f10465482b96641ce4379c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Saved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentUnsavedProperties {
  subjectTitle: string;
  subjectSlug: string;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  contentType: string;
  contentItemSlug: string;
}
/**
 * Content Unsaved: A user initiated an action to unsave content (eg. a unit) from their library
 * 
 * @param properties the properties associated with this event
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.contentType: no description
 * @param properties.contentItemSlug: no description
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/ma0dTvBAlMIMPsHIHNKW4}
 */
export function contentUnsaved(properties: ContentUnsavedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "uHgsqow6CcsK85HcAIT2e", name: "Content Type", value: properties.contentType});
  eventPropertiesArray.push({id: "UPAbTsstCdNHv2HJZ20fj", name: "Content Item Slug", value: properties.contentItemSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "ma0dTvBAlMIMPsHIHNKW4", "02a51f333d1fe976f44e2aa2fe996645c0a5a39a6fce1fa11535109465e284ae", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Unsaved", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("ma0dTvBAlMIMPsHIHNKW4", "Content Unsaved", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Unsaved", eventProperties, "ma0dTvBAlMIMPsHIHNKW4", "02a51f333d1fe976f44e2aa2fe996645c0a5a39a6fce1fa11535109465e284ae");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Unsaved", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CreateTeachingMaterialsInitiatedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  isLoggedIn: boolean;
  journeyId: string | null | undefined;
}
/**
 * Create Teaching Materials Initiated: The user initiates the creation of Teaching Materials.
 * 
 * When to trigger this event:
 * 1. User clicks on the 'Create additional materials' button
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_3ZXJv2dxdML9tN8VHYb/trigger/7HC7dZHAPT8KBGGnQOp6C
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.isLoggedIn: Flags whether the user logged in or not before accessing the Oak object
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/I_3ZXJv2dxdML9tN8VHYb}
 */
export function createTeachingMaterialsInitiated(properties: CreateTeachingMaterialsInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "p56ECmuX6", name: "Is Logged In", value: properties.isLoggedIn});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "I_3ZXJv2dxdML9tN8VHYb", "9764494b94dd7a208dc98bf09b565984c64f68f764336589300376fc39ead7c9", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Create Teaching Materials Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("I_3ZXJv2dxdML9tN8VHYb", "Create Teaching Materials Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Create Teaching Materials Initiated", eventProperties, "I_3ZXJv2dxdML9tN8VHYb", "9764494b94dd7a208dc98bf09b565984c64f68f764336589300376fc39ead7c9");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Create Teaching Materials Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeachingMaterialsSelectedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  interactionId: string;
  teachingMaterialType: TeachingMaterialTypeValueType;
  journeyId: string | null | undefined;
}
/**
 * Teaching Materials Selected: The user selects which type of additional material they wish to create.
 * 
 * When to trigger this event:
 * 1. The user selects from the radial options which type of additional material to create, and clicks on 'Next, lesson details'.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/53a2df64-53be-4f28-9b3e-2918d78d9477/trigger/G4MY_H0MONSXFiAi_PstL
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.interactionId: Currently applies to interactions with the Additional Material creation flow. Groups together elements of an interaction to form one journey.
 * @param properties.teachingMaterialType: Type of Additional Material user has selected to generate.
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/53a2df64-53be-4f28-9b3e-2918d78d9477}
 */
export function teachingMaterialsSelected(properties: TeachingMaterialsSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "Z-m3BRBS_MyzwLoFY6MAi", name: "Interaction ID", value: properties.interactionId});
  eventPropertiesArray.push({id: "gB0s5mJz83dHx9yISWrQH", name: "Teaching Material Type", value: properties.teachingMaterialType});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "53a2df64-53be-4f28-9b3e-2918d78d9477", "f2eae032f42ae59ed39a6b7acc619e15f8837eccdbef4d27dfc81fe82b7e2bb5", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teaching Materials Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("53a2df64-53be-4f28-9b3e-2918d78d9477", "Teaching Materials Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teaching Materials Selected", eventProperties, "53a2df64-53be-4f28-9b3e-2918d78d9477", "f2eae032f42ae59ed39a6b7acc619e15f8837eccdbef4d27dfc81fe82b7e2bb5");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teaching Materials Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeachingMaterialsRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  teachingMaterialType: TeachingMaterialTypeValueType;
  interactionId: string;
  lessonPlanTitle: string;
  moderatedContentType: ModeratedContentTypeValueType[] | null | undefined;
}
/**
 * Teaching Materials Refined: A user in some way alters the content that Aila has provided them with, or shows intention of continuing with the generation of Teaching materials. 
 * 
 * When to trigger this event:
 * 1. The user selects a year group, subject and lesson title for the additional materials, then clicks on ‘Create lesson summary’ 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/DZzW7MOE1d7mmFy-3KXnq/trigger/FDM2fVMrZ51mmmXDlsAQw
 * 2. The user clicks on the ‘Create glossary’ button to carry on with the additional resources creation. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/DZzW7MOE1d7mmFy-3KXnq/trigger/ELWI6ZF7mpGVF0X_ch4jk
 * 3. The user selects one of the Modify options on the Glossary page
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/DZzW7MOE1d7mmFy-3KXnq/trigger/e3YmT5oE5dvmk9LTbQrqU
 * 4. The user clicks on ‘Back a step’
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/DZzW7MOE1d7mmFy-3KXnq/trigger/0Lqu48jyX2732YmT_-dTc
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.teachingMaterialType: Type of Additional Material user has selected to generate.
 * @param properties.interactionId: Currently applies to interactions with the Additional Material creation flow. Groups together elements of an interaction to form one journey.
 * @param properties.lessonPlanTitle: Title of the lesson plan
 * @param properties.moderatedContentType: The flag displayed to the user if the content they are looking at is sensitive/blocked
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/DZzW7MOE1d7mmFy-3KXnq}
 */
export function teachingMaterialsRefined(properties: TeachingMaterialsRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "gB0s5mJz83dHx9yISWrQH", name: "Teaching Material Type", value: properties.teachingMaterialType});
  eventPropertiesArray.push({id: "Z-m3BRBS_MyzwLoFY6MAi", name: "Interaction ID", value: properties.interactionId});
  eventPropertiesArray.push({id: "t0gm_zGXX", name: "Lesson Plan Title", value: properties.lessonPlanTitle});
  properties.moderatedContentType !== undefined && properties.moderatedContentType !== null ?
    eventPropertiesArray.push({id: "0NVQREqVg", name: "Moderated Content Type", value: properties.moderatedContentType}) :
    eventPropertiesArray.push({id: "0NVQREqVg", name: "Moderated Content Type", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "DZzW7MOE1d7mmFy-3KXnq", "36f46eaae195d61a485d8c0b3600e6d849a169b7f46640ae4deda9bcd106906d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teaching Materials Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("DZzW7MOE1d7mmFy-3KXnq", "Teaching Materials Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teaching Materials Refined", eventProperties, "DZzW7MOE1d7mmFy-3KXnq", "36f46eaae195d61a485d8c0b3600e6d849a169b7f46640ae4deda9bcd106906d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teaching Materials Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeachingMaterialDownloadedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  teachingMaterialType: TeachingMaterialTypeValueType;
  interactionId: string;
  lessonPlanTitle: string;
  resourceType: ResourceTypeValueType[];
  resourceFileType: ResourceFileTypeValueType;
  moderatedContentType: ModeratedContentTypeValueType[] | null | undefined;
}
/**
 * Teaching Material Downloaded: The user reaches the end of the Additional Material generation journey and downloads the generated content. 
 * 
 * When to trigger this event:
 * 1. User clicks on 'Download (.zip)'.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/6E7DzaaR8xj-jTMeAu7TS/trigger/pTcRgM36sUy0DWCa6X1kp
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.teachingMaterialType: Type of Additional Material user has selected to generate.
 * @param properties.interactionId: Currently applies to interactions with the Additional Material creation flow. Groups together elements of an interaction to form one journey.
 * @param properties.lessonPlanTitle: Title of the lesson plan
 * @param properties.resourceType: The lesson resources a teacher selected for download.
 * @param properties.resourceFileType: The file type of the resource related to the event
 * @param properties.moderatedContentType: The flag displayed to the user if the content they are looking at is sensitive/blocked
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/6E7DzaaR8xj-jTMeAu7TS}
 */
export function teachingMaterialDownloaded(properties: TeachingMaterialDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "gB0s5mJz83dHx9yISWrQH", name: "Teaching Material Type", value: properties.teachingMaterialType});
  eventPropertiesArray.push({id: "Z-m3BRBS_MyzwLoFY6MAi", name: "Interaction ID", value: properties.interactionId});
  eventPropertiesArray.push({id: "t0gm_zGXX", name: "Lesson Plan Title", value: properties.lessonPlanTitle});
  eventPropertiesArray.push({id: "H_kc7WuVNP", name: "Resource Type", value: properties.resourceType});
  eventPropertiesArray.push({id: "6_1GeCgXu", name: "Resource File Type", value: properties.resourceFileType});
  properties.moderatedContentType !== undefined && properties.moderatedContentType !== null ?
    eventPropertiesArray.push({id: "0NVQREqVg", name: "Moderated Content Type", value: properties.moderatedContentType}) :
    eventPropertiesArray.push({id: "0NVQREqVg", name: "Moderated Content Type", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6E7DzaaR8xj-jTMeAu7TS", "b8493f913d0b64089caf7cacf46137ad668a174c811a233ab7fa9f3a85f47549", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teaching Material Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6E7DzaaR8xj-jTMeAu7TS", "Teaching Material Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teaching Material Downloaded", eventProperties, "6E7DzaaR8xj-jTMeAu7TS", "b8493f913d0b64089caf7cacf46137ad668a174c811a233ab7fa9f3a85f47549");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teaching Material Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ContentBlockNotificationDisplayedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType | null | undefined;
  lessonReleaseDate: string | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  contentType: string;
  accessBlockType: AccessBlockTypeValueType;
  accessBlockDetails: AccessBlockDetails;
}
/**
 * Content Block Notification Displayed: A user is notified that they are unable access content.
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.contentType: no description
 * @param properties.accessBlockType: The reason why an item of content was blocked from being accessed.
 * @param properties.accessBlockDetails: An object providing details about the block reason (e.g. the country of the user at the time geo-restricted content was blocked)
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/E_1QtSmDaMHlZzmoL1bSm}
 */
export function contentBlockNotificationDisplayed(properties: ContentBlockNotificationDisplayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  properties.lessonReleaseCohort !== undefined && properties.lessonReleaseCohort !== null ?
    eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort}) :
    eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: null});
  properties.lessonReleaseDate !== undefined && properties.lessonReleaseDate !== null ?
    eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate}) :
    eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  eventPropertiesArray.push({id: "uHgsqow6CcsK85HcAIT2e", name: "Content Type", value: properties.contentType});
  eventPropertiesArray.push({id: "oZiPlZae3yZyjfLUtEWsE", name: "Access Block Type", value: properties.accessBlockType});
  eventPropertiesArray.push({id: "RYdUCWA1KTORo_ZHLrBYK", name: "Access Block Details", value: properties.accessBlockDetails});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "E_1QtSmDaMHlZzmoL1bSm", "8c3d5239ef0af54065814f03b51f107b72ae82fa887793a107ba3aa561048c38", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Content Block Notification Displayed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("E_1QtSmDaMHlZzmoL1bSm", "Content Block Notification Displayed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Content Block Notification Displayed", eventProperties, "E_1QtSmDaMHlZzmoL1bSm", "8c3d5239ef0af54065814f03b51f107b72ae82fa887793a107ba3aa561048c38");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Content Block Notification Displayed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UserOnboardingProgressedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  userId_: string;
  signUpDate: string | null | undefined;
  userRoleType: UserRoleTypeValueType | null | undefined;
  teacherSchoolUrn: string | null | undefined;
  userDefinedRole: string | null | undefined;
  userDetailsLastModifiedDate: string;
  userAccountVerificationStatus: UserAccountVerificationStatusValueType | null | undefined;
  teacherSchoolManualEntryDetails: TeacherSchoolManualEntryDetails | null | undefined;
}
/**
 * User Onboarding Progressed: The user progresses the onboarding process by completing one of theintermediate steps between completing sign-up (creating a Clerk account) and completing onboarding.
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.userId_: The value used to identify the user. Make sure it's a unique sequence of characters used to identify the user.
 * @param properties.signUpDate: The date a user signed-up for an account in YYYY-MM-DD format., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userRoleType: The type of role the signed-in user holds. As defined when they sign-up or edit their details. This is used to differentiate between those with Teacher and Other types of Roles.
 * @param properties.teacherSchoolUrn: The Unique Reference Number (URN) of the school which a signed in user (or a user who has downloaded lesson resources) has provided. For English and Welsh Schools this is a 6 digit number, for Scottish Schools this is a 7 digit number (Seed number) and for NI Schools it is a 3 digit number followed by a four digit number., should match regex: ^\d{3}\-?\d{3,4}$
 * @param properties.userDefinedRole: Used in cases where the User Role Type is set to 'Other'. Free text which best describes a user's role
 * @param properties.userDetailsLastModifiedDate: The date on which a user last modified their details., should match regex: \d{4}-\d{2}-\d{2}
 * @param properties.userAccountVerificationStatus: The status of the user account
 * @param properties.teacherSchoolManualEntryDetails: A small object containing the manually entered details of a users school when it is not available in the school picker.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/WFQ_xNUmm}
 */
export function userOnboardingProgressed(properties: UserOnboardingProgressedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  properties.signUpDate !== undefined && properties.signUpDate !== null ?
    userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: properties.signUpDate}) :
    userPropertiesArray.push({id: "gG_w27SKHB", name: "Sign-Up Date", value: null});
  properties.userRoleType !== undefined && properties.userRoleType !== null ?
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: properties.userRoleType}) :
    userPropertiesArray.push({id: "UzbEhqXqIC", name: "User Role Type", value: null});
  properties.teacherSchoolUrn !== undefined && properties.teacherSchoolUrn !== null ?
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: properties.teacherSchoolUrn}) :
    userPropertiesArray.push({id: "BgFeT6JsIV", name: "Teacher School URN", value: null});
  properties.userDefinedRole !== undefined && properties.userDefinedRole !== null ?
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: properties.userDefinedRole}) :
    userPropertiesArray.push({id: "jveNRqbgzO", name: "User Defined Role", value: null});
  userPropertiesArray.push({id: "Tnbcjv4vnh", name: "User Details Last Modified Date", value: properties.userDetailsLastModifiedDate});
  properties.userAccountVerificationStatus !== undefined && properties.userAccountVerificationStatus !== null ?
    userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: properties.userAccountVerificationStatus}) :
    userPropertiesArray.push({id: "6LTMhPtr6", name: "User Account Verification Status", value: null});
  properties.teacherSchoolManualEntryDetails !== undefined && properties.teacherSchoolManualEntryDetails !== null ?
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: {
      "School Name Text": properties.teacherSchoolManualEntryDetails.schoolNameText,
      "School Address Text": properties.teacherSchoolManualEntryDetails.schoolAddressText,
    }}) :
    userPropertiesArray.push({id: "FqpH5gAYj", name: "Teacher School Manual Entry Details", value: null});
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    messages = messages.concat(assertTeacherSchoolManualEntryDetailsOptional(properties.teacherSchoolManualEntryDetails));
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "WFQ_xNUmm", "09f8f7a9e3a32c10b6bfa3d8c69a8b7da702c8c0e740c64a8a1e7418953c440c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("User Onboarding Progressed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("WFQ_xNUmm", "User Onboarding Progressed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
    // @ts-ignore
    if (__AVO_ENV__ !== AvoEnv.Prod && (__STRICT__ === null || __STRICT__)) {
      // throw exception if messages is not empty
      if (messages.length !== 0) {
        throw new Error("Error sending event 'User Onboarding Progressed': " + messages[0]!.message)
      }
    } else {
      messages.forEach(function(m) {
        console[__REPORT_FAILURE_AS__ || 'error']("[avo] " + m.message);
      });
    }
  }
  if (!__AVO_NOOP__) {
    // destination PostHogEU
    PostHogEU.setUserProperties(properties.userId_, (Object as any).assign({}, userProperties));
  } else {
    // do nothing
  }
}

export interface AboutUsAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * About Us Accessed: User lands on About Us page after clicking on one of the About Us links in the footer - either 'About us', 'Oak's curricula', 'Get involved', or 'Meet the team'. Or, they click on the 'About Oak' button from homepage. 
 * 
 * When to trigger this event:
 * 1. User clicks on the About Oak button from the homepage
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/oSWvaTUE8hKucXrR3I4V4/trigger/GC1EHCHa7Lm7iUZfbZh7q
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/oSWvaTUE8hKucXrR3I4V4}
 */
export function aboutUsAccessed(properties: AboutUsAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oSWvaTUE8hKucXrR3I4V4", "bc41dabff2d92ba5f3f083bc9b06828881ff69e17bbad3a8c3e1ab29747c6c4c", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("About Us Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oSWvaTUE8hKucXrR3I4V4", "About Us Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("About Us Accessed", eventProperties, "oSWvaTUE8hKucXrR3I4V4", "bc41dabff2d92ba5f3f083bc9b06828881ff69e17bbad3a8c3e1ab29747c6c4c");
    }
    // destination PostHogEU
    PostHogEU.logEvent("About Us Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AboutUsExploredProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * About Us Explored: User navigates around About Us pages using 'Explore more about Oak' navigation buttons
 * 
 * When to trigger this event:
 * 1. User selects any of the four options in this section
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/GTkyUItOAwx_e4-aU1pXH/trigger/jCTVX9nXJdT7DwN9dxeKS
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/GTkyUItOAwx_e4-aU1pXH}
 */
export function aboutUsExplored(properties: AboutUsExploredProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "GTkyUItOAwx_e4-aU1pXH", "3dc9b1039a17619f0ae3335348c33e26213ce6da8512bc89fae2d9286e001692", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("About Us Explored", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("GTkyUItOAwx_e4-aU1pXH", "About Us Explored", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("About Us Explored", eventProperties, "GTkyUItOAwx_e4-aU1pXH", "3dc9b1039a17619f0ae3335348c33e26213ce6da8512bc89fae2d9286e001692");
    }
    // destination PostHogEU
    PostHogEU.logEvent("About Us Explored", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AboutUsContactInitiatedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * About Us Contact Initiated: User opts to collaborate or work with Oak. 
 * 
 * When to trigger this event:
 * 1. User clicks on 'join the research panel' (component type = 'join_research_panel')
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1kAeBL_oSYtSUA_xJrLFz/trigger/CZqCjnoNG1tfXzDfGMQZf
 * 2. User clicks 'get in touch' (component_type = 'get_in_touch')
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1kAeBL_oSYtSUA_xJrLFz/trigger/0mHzNpxH8P4Eh0nu7LGYK
 * 3. User clicks on 'permanent roles' or 'freelance roles' (component type = 'permanent_roles'/'freelance roles')
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1kAeBL_oSYtSUA_xJrLFz/trigger/f_oDDB8k7c9p_8ZRnnlsO
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/1kAeBL_oSYtSUA_xJrLFz}
 */
export function aboutUsContactInitiated(properties: AboutUsContactInitiatedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "1kAeBL_oSYtSUA_xJrLFz", "58c79d2d6cf7e54cab87fc420189a72ac1b7f7214fdab0832c17081f3fe1baed", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("About Us Contact Initiated", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("1kAeBL_oSYtSUA_xJrLFz", "About Us Contact Initiated", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("About Us Contact Initiated", eventProperties, "1kAeBL_oSYtSUA_xJrLFz", "58c79d2d6cf7e54cab87fc420189a72ac1b7f7214fdab0832c17081f3fe1baed");
    }
    // destination PostHogEU
    PostHogEU.logEvent("About Us Contact Initiated", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomSignInCompletedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  googleLoginHint: string | null | undefined;
  subscribeToNewsletter: boolean | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Classroom Sign in Completed: A user completes the google auth process to access the Google Classroom Add-On
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.googleLoginHint: no description
 * @param properties.subscribeToNewsletter: Newsletter subscribe button selected
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/b7534ea2-1ff5-4707-9395-b93dd01d8944}
 */
export function classroomSignInCompleted(properties: ClassroomSignInCompletedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.subscribeToNewsletter !== undefined && properties.subscribeToNewsletter !== null ?
    eventPropertiesArray.push({id: "Sza_J1MUhDDXo4a1tdel-", name: "Subscribe to Newsletter", value: properties.subscribeToNewsletter}) :
    eventPropertiesArray.push({id: "Sza_J1MUhDDXo4a1tdel-", name: "Subscribe to Newsletter", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "b7534ea2-1ff5-4707-9395-b93dd01d8944", "fe02af02306d39f295d185a184f65926ee6cc913d877191adf3112fdd83cd9dc", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Sign in Completed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("b7534ea2-1ff5-4707-9395-b93dd01d8944", "Classroom Sign in Completed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Sign in Completed", eventProperties, "b7534ea2-1ff5-4707-9395-b93dd01d8944", "fe02af02306d39f295d185a184f65926ee6cc913d877191adf3112fdd83cd9dc");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Sign in Completed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomSignInStartedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType;
}
/**
 * Classroom Sign in Started: Teacher clicks "Sign in with Google"
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/NH1qVkE2GB5IFRN2i5QyY/trigger/V7rxuuU3dpqHVeWA4i-Hi
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/NH1qVkE2GB5IFRN2i5QyY}
 */
export function classroomSignInStarted(properties: ClassroomSignInStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "NH1qVkE2GB5IFRN2i5QyY", "a9ebab1b26a9d3a7bfaf1e88d57db8ecdbdc4917a4f2eca2f5142286577f21b4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Sign in Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("NH1qVkE2GB5IFRN2i5QyY", "Classroom Sign in Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Sign in Started", eventProperties, "NH1qVkE2GB5IFRN2i5QyY", "a9ebab1b26a9d3a7bfaf1e88d57db8ecdbdc4917a4f2eca2f5142286577f21b4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Sign in Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomLessonSelectedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  tierName: TierNameValueType;
  examBoard: ExamBoardValueType;
  pathway: PathwayValueType;
  yearGroupName: string;
  yearGroupSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  googleLoginHint: string;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Classroom Lesson Selected: Check a lesson radio checkbox on the classroom lesson page
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/7ed5d88c-5b8d-4af2-87a2-2d7611079795/trigger/H3G3BWqetpDQYy_zDAqDo
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/7ed5d88c-5b8d-4af2-87a2-2d7611079795}
 */
export function classroomLessonSelected(properties: ClassroomLessonSelectedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName});
  eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard});
  eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "7ed5d88c-5b8d-4af2-87a2-2d7611079795", "ee821b28954c40d988de444b028e04dc6da3bb7ce559c12b6ccc70641914ead7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Lesson Selected", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("7ed5d88c-5b8d-4af2-87a2-2d7611079795", "Classroom Lesson Selected", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Lesson Selected", eventProperties, "7ed5d88c-5b8d-4af2-87a2-2d7611079795", "ee821b28954c40d988de444b028e04dc6da3bb7ce559c12b6ccc70641914ead7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Lesson Selected", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomLessonPreviewedProperties {
  lessonName: string;
  lessonSlug: string;
  lessonReleaseCohort: LessonReleaseCohortValueType;
  lessonReleaseDate: string;
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  yearGroupName: string;
  yearGroupSlug: string;
  tierName: TierNameValueType;
  examBoard: ExamBoardValueType;
  pathway: PathwayValueType;
  googleLoginHint: string;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Classroom Lesson Previewed: Teacher clicks preview link (opens pupil lesson in new tab)
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/yyH7tlz5DF7yCPBTS7ukR/trigger/NFnARcInP5Uvh60kuCZ_Z
 * 
 * @param properties the properties associated with this event
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.yearGroupName: Name of the current year group.
 * @param properties.yearGroupSlug: Human-readable unique ID of the current year group.
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/yyH7tlz5DF7yCPBTS7ukR}
 */
export function classroomLessonPreviewed(properties: ClassroomLessonPreviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug});
  eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort});
  eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "mIpfmyUTSY", name: "Year Group Name", value: properties.yearGroupName});
  eventPropertiesArray.push({id: "ySTg1Sz9in", name: "Year Group Slug", value: properties.yearGroupSlug});
  eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName});
  eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard});
  eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway});
  eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "yyH7tlz5DF7yCPBTS7ukR", "379378b89fdfb1778f9ce4dc725967b27362c83791d295dc2075fa3413d54348", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Lesson Previewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("yyH7tlz5DF7yCPBTS7ukR", "Classroom Lesson Previewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Lesson Previewed", eventProperties, "yyH7tlz5DF7yCPBTS7ukR", "379378b89fdfb1778f9ce4dc725967b27362c83791d295dc2075fa3413d54348");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Lesson Previewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomLessonsAttachedProperties {
  googleLoginHint: string;
  itemId: string | null | undefined;
  courseId: string | null | undefined;
  lessonName: string;
  unitName: string;
  gradeSyncEnabled: boolean;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
  classroomAssignmentId: string | null | undefined;
}
/**
 * Classroom Lessons Attached: Click "Attach lessons to assignment" 
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/t7nhIQuz1fXoUi0xheAxT/trigger/SWV04E6prIUjsxP0dVXEh
 * 
 * @param properties the properties associated with this event
 * @param properties.googleLoginHint: no description
 * @param properties.itemId: Item ID for Google Classroom shared attachement
 * @param properties.courseId: Course Id for google classroom asset
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.unitName: Title of the current unit.
 * @param properties.gradeSyncEnabled: Teacher has enabled grade sync
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * @param properties.classroomAssignmentId: Google Classroom join key consisting of courseId:itemId
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/t7nhIQuz1fXoUi0xheAxT}
 */
export function classroomLessonsAttached(properties: ClassroomLessonsAttachedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint});
  properties.itemId !== undefined && properties.itemId !== null ?
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: properties.itemId}) :
    eventPropertiesArray.push({id: "F8tpTmqbTxEqlOXo1c79C", name: "Item Id", value: null});
  properties.courseId !== undefined && properties.courseId !== null ?
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: properties.courseId}) :
    eventPropertiesArray.push({id: "t8RHgWfL1Ft3at-LRzgNb", name: "Course Id", value: null});
  eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName});
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "dCdz44N1Wv-fpslSFWP2R", name: "Grade Sync Enabled", value: properties.gradeSyncEnabled});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  properties.classroomAssignmentId !== undefined && properties.classroomAssignmentId !== null ?
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: properties.classroomAssignmentId}) :
    eventPropertiesArray.push({id: "EneREMaayMMSe6UHp0lfi", name: "Classroom Assignment Id", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "t7nhIQuz1fXoUi0xheAxT", "c3f42bb692dfd0eaea7c458631ca7bc936f299a3caa0621504bcabef1db9599a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Lessons Attached", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("t7nhIQuz1fXoUi0xheAxT", "Classroom Lessons Attached", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Lessons Attached", eventProperties, "t7nhIQuz1fXoUi0xheAxT", "c3f42bb692dfd0eaea7c458631ca7bc936f299a3caa0621504bcabef1db9599a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Lessons Attached", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ClassroomAddOnOpenedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Classroom Add on Opened: Event fires when google classroom add on is opened 
 * 
 * When to trigger this event:
 * 1. 
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/f6c5fadc-2289-4875-a4a5-062de83dc9c1/trigger/MBJLU55HRcRhUoHwRSu8p
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/f6c5fadc-2289-4875-a4a5-062de83dc9c1}
 */
export function classroomAddOnOpened(properties: ClassroomAddOnOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "f6c5fadc-2289-4875-a4a5-062de83dc9c1", "6249ab50b7c28d1da48e1a130bf0cd8c7bc9e75026ff5580b5e4fbc44688f67f", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Classroom Add on Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("f6c5fadc-2289-4875-a4a5-062de83dc9c1", "Classroom Add on Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Classroom Add on Opened", eventProperties, "f6c5fadc-2289-4875-a4a5-062de83dc9c1", "6249ab50b7c28d1da48e1a130bf0cd8c7bc9e75026ff5580b5e4fbc44688f67f");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Classroom Add on Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProgrammeRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  journeyId: string | null | undefined;
  accessLevel: AccessLevelValueType;
  navigationType: NavigationTypeValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Programme Refined: A step on the Browse Journey is completed "refining" the programme selection that the user is interested in seeing.
 * Replaces Browse Refined
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/c4mJzrmGf_5D5QuDPODpn}
 */
export function programmeRefined(properties: ProgrammeRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "c4mJzrmGf_5D5QuDPODpn", "ebef08950f2985d83717e06a6304c1466e400a543c4112c550af98f4ed88e8ef", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Programme Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("c4mJzrmGf_5D5QuDPODpn", "Programme Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Programme Refined", eventProperties, "c4mJzrmGf_5D5QuDPODpn", "ebef08950f2985d83717e06a6304c1466e400a543c4112c550af98f4ed88e8ef");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Programme Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitRefinedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  journeyId: string | null | undefined;
  accessLevel: AccessLevelValueType;
  navigationType: NavigationTypeValueType;
  filterType: FilterTypeValueType;
  filterValue: string;
  activeFilters: ActiveFilters;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Unit Refined: A step on the Browse Journey is completed "refining" the unit selection that the user is interested in seeing.
 * Replaces Browse Refined
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/oY_aSUaUvf18ywGxI-X6z}
 */
export function unitRefined(properties: UnitRefinedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType});
  eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "oY_aSUaUvf18ywGxI-X6z", "b76a2d825d0700238af3b3856815542e33a5dad5a5ad9124c7e0cfe60d4d0434", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Refined", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("oY_aSUaUvf18ywGxI-X6z", "Unit Refined", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Refined", eventProperties, "oY_aSUaUvf18ywGxI-X6z", "b76a2d825d0700238af3b3856815542e33a5dad5a5ad9124c7e0cfe60d4d0434");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Refined", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ProgrammeAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  journeyId: string | null | undefined;
  accessLevel: AccessLevelValueType;
  navigationType: NavigationTypeValueType;
  filterType: FilterTypeValueType | null | undefined;
  filterValue: string | null | undefined;
  activeFilters: ActiveFilters;
  googleLoginHint: string | null | undefined;
  clientEnvironment: ClientEnvironmentValueType | null | undefined;
}
/**
 * Programme Accessed: The first step of the browse journey.
 * Replaces Browse Refined Accessed and Curriculum Visualiser Accessed
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * @param properties.navigationType: How a user is navigating our content, zooming in, out, or across.
 * Indicates the direction of movement and what it represents.
 * @param properties.filterType: Describes the dimension the filter is designed to control such as subject, key stage, or resource type
 * @param properties.filterValue: The value added to the filter (e.g. 'English' or 'AQA'). In the case where multiple filters are chosen simultaneously (e.g. Exam board and Tier) then both values should be sent separated by ', ' (e.g. 'AQA, Higher')
 * @param properties.activeFilters: The filters that are active at the time of the refinement event. Small json object in the form
 * ```json
 * {
 *   'key_stage': [...key_stage_titles],
 *   'exam_board': […exam_board_titles],
 *   'subjects': […subject_titles],
 *   'content_types': […content_type] // should be one of ['units', 'lessons'] for now
 * }
 * ```
 * Only include keys/values for active filters.
 * @param properties.googleLoginHint: no description
 * @param properties.clientEnvironment: Denotes the environment the client is running
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/n3ZOBTu172etcRz3zYUVl}
 */
export function programmeAccessed(properties: ProgrammeAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  eventPropertiesArray.push({id: "MSzgvcM11YCYl-3H4YNVa", name: "Navigation Type", value: properties.navigationType});
  properties.filterType !== undefined && properties.filterType !== null ?
    eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: properties.filterType}) :
    eventPropertiesArray.push({id: "XPABjlx_F", name: "Filter Type", value: null});
  properties.filterValue !== undefined && properties.filterValue !== null ?
    eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: properties.filterValue}) :
    eventPropertiesArray.push({id: "v3Ne3qUXs", name: "Filter Value", value: null});
  eventPropertiesArray.push({id: "TsVyKpbQ6", name: "Active Filters", value: properties.activeFilters});
  properties.googleLoginHint !== undefined && properties.googleLoginHint !== null ?
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: properties.googleLoginHint}) :
    eventPropertiesArray.push({id: "86AjgGPsfPrUhMUY_Hkkl", name: "Google Login Hint", value: null});
  properties.clientEnvironment !== undefined && properties.clientEnvironment !== null ?
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: properties.clientEnvironment}) :
    eventPropertiesArray.push({id: "9RoNY4Sg_zpaBzxCl3sTB", name: "Client Environment", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "n3ZOBTu172etcRz3zYUVl", "5d365771387698090343ec55a0d5102e6ee7fb67c344cdd46a37040ab2240130", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Programme Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("n3ZOBTu172etcRz3zYUVl", "Programme Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Programme Accessed", eventProperties, "n3ZOBTu172etcRz3zYUVl", "5d365771387698090343ec55a0d5102e6ee7fb67c344cdd46a37040ab2240130");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Programme Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface UnitDownloadStartedProperties {
  unitName: string;
  unitSlug: string;
  subjectTitle: string;
  subjectSlug: string;
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  keyStageTitle: KeyStageTitleValueType;
  keyStageSlug: string;
  journeyId: string | null | undefined;
  accessLevel: AccessLevelValueType;
}
/**
 * Unit Download Started: A user clicks the unit download button on a lesson listing page when signed out
 * 
 * @param properties the properties associated with this event
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * @param properties.journeyId: A unique ID for a user's journey in a specific programme triggered by a direct or accessed event. Journey end is triggered by a programme slug disappearing or changing.
 * @param properties.accessLevel: Indicates where the user is going from when navigating content, whether zooming in, out, or across.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/HYZZOlRO94Gxvz8uxfkLe}
 */
export function unitDownloadStarted(properties: UnitDownloadStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName});
  eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle});
  eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug});
  properties.journeyId !== undefined && properties.journeyId !== null ?
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: properties.journeyId}) :
    eventPropertiesArray.push({id: "J9ORuaNS9rZOq5UE9Q91k", name: "Journey Id", value: null});
  eventPropertiesArray.push({id: "qf_a_ttCPfRkzKQyLStvY", name: "Access Level", value: properties.accessLevel});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "HYZZOlRO94Gxvz8uxfkLe", "41d5df0b6160b8c5834cd64ba977ec6aa2c5bbc9d69a27b0990435fbf986180a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Unit Download Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("HYZZOlRO94Gxvz8uxfkLe", "Unit Download Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Unit Download Started", eventProperties, "HYZZOlRO94Gxvz8uxfkLe", "41d5df0b6160b8c5834cd64ba977ec6aa2c5bbc9d69a27b0990435fbf986180a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Unit Download Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ScrolledToProperties {
  key: string;
}
/**
 * Scrolled To: User scrolls to a given position on the page, identified by the key.
 * 
 * @param properties the properties associated with this event
 * @param properties.key: The identifier of the scroll position
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/6sIUwYy1D_6UwtP2zAqCc}
 */
export function scrolledTo(properties: ScrolledToProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "F_YG6ioZKxxtm_rvFs3tq", name: "Key", value: properties.key});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "6sIUwYy1D_6UwtP2zAqCc", "e61f5d893401b172f038f53c2a3d36bd396c01396b538538248c13db32627b91", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Scrolled To", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("6sIUwYy1D_6UwtP2zAqCc", "Scrolled To", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Scrolled To", eventProperties, "6sIUwYy1D_6UwtP2zAqCc", "e61f5d893401b172f038f53c2a3d36bd396c01396b538538248c13db32627b91");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Scrolled To", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

/**
 * Exit Intended: User's mouse moves out of the viewport
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/nyqGzMKPEl11t7qMaKKCT}
 */
export function exitIntended() {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "nyqGzMKPEl11t7qMaKKCT", "629c96de9a7eb89684e7d6da59bdb40184c60fc2e945e3b3aa5cd89ef4dc79e7", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Exit Intended", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("nyqGzMKPEl11t7qMaKKCT", "Exit Intended", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Exit Intended", eventProperties, "nyqGzMKPEl11t7qMaKKCT", "629c96de9a7eb89684e7d6da59bdb40184c60fc2e945e3b3aa5cd89ef4dc79e7");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Exit Intended", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface CurriculumResourcesAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  phase: PhaseValueType;
  subjectTitle: string;
  subjectSlug: string;
}
/**
 * Curriculum Resources Accessed: Curriculum resources download page accessed (including curriculum plan and implementation toolkit).
 * 
 * When to trigger this event:
 * 1. Clicking the implementation toolkit callout banner
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/e95d312e-ad29-49c7-8527-f0fc0730a796/trigger/gWqE1Ze1RWLfVZlQB8y1K
 * 2. Clicking the downloads tab for a given subject and phase
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/e95d312e-ad29-49c7-8527-f0fc0730a796/trigger/iYBfsLi81WyhaXb5vE5fz
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.phase: School phase related to key stage and age of audience
 * @param properties.subjectTitle: Title of the current subject.
 * @param properties.subjectSlug: Human-readable unique ID of the current subject.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/e95d312e-ad29-49c7-8527-f0fc0730a796}
 */
export function curriculumResourcesAccessed(properties: CurriculumResourcesAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "SsbNnb9vD", name: "Phase", value: properties.phase});
  eventPropertiesArray.push({id: "-MoOjO43sV", name: "Subject Title", value: properties.subjectTitle});
  eventPropertiesArray.push({id: "8GyPDAapC-", name: "Subject Slug", value: properties.subjectSlug});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "e95d312e-ad29-49c7-8527-f0fc0730a796", "2676cee159ddf762345712041318f96dab602a44d552a5fe8f6125b7160995a4", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Curriculum Resources Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("e95d312e-ad29-49c7-8527-f0fc0730a796", "Curriculum Resources Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Curriculum Resources Accessed", eventProperties, "e95d312e-ad29-49c7-8527-f0fc0730a796", "2676cee159ddf762345712041318f96dab602a44d552a5fe8f6125b7160995a4");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Curriculum Resources Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeachWithOakAccessedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  lessonName: string | null | undefined;
  lessonSlug: string | null | undefined;
  lessonReleaseCohort: LessonReleaseCohortValueType | null | undefined;
  lessonReleaseDate: string | null | undefined;
  tierName: TierNameValueType | null | undefined;
  examBoard: ExamBoardValueType | null | undefined;
  pathway: PathwayValueType | null | undefined;
  unitName: string | null | undefined;
  unitSlug: string | null | undefined;
  keyStageTitle: KeyStageTitleValueType | null | undefined;
  keyStageSlug: string | null | undefined;
}
/**
 * Teach With Oak Accessed: User clicks a link to go to Teach with Oak
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.lessonName: Name of the current lesson.
 * @param properties.lessonSlug: Human-readable unique ID of the current lesson.
 * @param properties.lessonReleaseCohort: Determines which cycle of lesson creation
 * @param properties.lessonReleaseDate: The date in which the lesson was published
 * @param properties.tierName: Name of the learning tier
 * @param properties.examBoard: The name of the exam board for a given unit, lesson etc…
 * @param properties.pathway: Optionality around type of study (i.e. whether working towards a particular certificate or not).
 * @param properties.unitName: Title of the current unit.
 * @param properties.unitSlug: Human-readable unique ID of the current unit.
 * @param properties.keyStageTitle: Title of the current key stage.
 * @param properties.keyStageSlug: Human-readable unique ID of the current key stage.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/XuRO7-a_-Ts6ULZsnzGbG}
 */
export function teachWithOakAccessed(properties: TeachWithOakAccessedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  properties.lessonName !== undefined && properties.lessonName !== null ?
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: properties.lessonName}) :
    eventPropertiesArray.push({id: "vbCKXJ6xRQ", name: "Lesson Name", value: null});
  properties.lessonSlug !== undefined && properties.lessonSlug !== null ?
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: properties.lessonSlug}) :
    eventPropertiesArray.push({id: "1FiHL77eSX", name: "Lesson Slug", value: null});
  properties.lessonReleaseCohort !== undefined && properties.lessonReleaseCohort !== null ?
    eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: properties.lessonReleaseCohort}) :
    eventPropertiesArray.push({id: "1MWGICtAX6RYKgkHCdzQe", name: "Lesson Release Cohort", value: null});
  properties.lessonReleaseDate !== undefined && properties.lessonReleaseDate !== null ?
    eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: properties.lessonReleaseDate}) :
    eventPropertiesArray.push({id: "RLjiajchvo1_cecbBI4ol", name: "Lesson Release Date", value: null});
  properties.tierName !== undefined && properties.tierName !== null ?
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: properties.tierName}) :
    eventPropertiesArray.push({id: "IFuPjLaNs", name: "Tier Name", value: null});
  properties.examBoard !== undefined && properties.examBoard !== null ?
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: properties.examBoard}) :
    eventPropertiesArray.push({id: "7Emhfe0Q2", name: "Exam Board", value: null});
  properties.pathway !== undefined && properties.pathway !== null ?
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: properties.pathway}) :
    eventPropertiesArray.push({id: "hjCgkqBH8U", name: "Pathway", value: null});
  properties.unitName !== undefined && properties.unitName !== null ?
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: properties.unitName}) :
    eventPropertiesArray.push({id: "YfsvSpyEEd", name: "Unit Name", value: null});
  properties.unitSlug !== undefined && properties.unitSlug !== null ?
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: properties.unitSlug}) :
    eventPropertiesArray.push({id: "r4GW5No741", name: "Unit Slug", value: null});
  properties.keyStageTitle !== undefined && properties.keyStageTitle !== null ?
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: properties.keyStageTitle}) :
    eventPropertiesArray.push({id: "qeEZpYqVhK", name: "Key Stage Title", value: null});
  properties.keyStageSlug !== undefined && properties.keyStageSlug !== null ?
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: properties.keyStageSlug}) :
    eventPropertiesArray.push({id: "XMx9WMqh0H", name: "Key Stage Slug", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "XuRO7-a_-Ts6ULZsnzGbG", "b45f459a707ad239d3a1098f06795e22f60c53da54515861f4d937855098ea50", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teach With Oak Accessed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("XuRO7-a_-Ts6ULZsnzGbG", "Teach With Oak Accessed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teach With Oak Accessed", eventProperties, "XuRO7-a_-Ts6ULZsnzGbG", "b45f459a707ad239d3a1098f06795e22f60c53da54515861f4d937855098ea50");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teach With Oak Accessed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TeachWithOakDownloadedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
}
/**
 * Teach With Oak Downloaded: A user downloads one or more Teach with Oak resources
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/hMRyptl68CyvWjhBaMvXi}
 */
export function teachWithOakDownloaded(properties: TeachWithOakDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "hMRyptl68CyvWjhBaMvXi", "4cff2f318ea097186acc40ec3830db1a030e9391a0205f910c6260a2d20e889e", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Teach With Oak Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("hMRyptl68CyvWjhBaMvXi", "Teach With Oak Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Teach With Oak Downloaded", eventProperties, "hMRyptl68CyvWjhBaMvXi", "4cff2f318ea097186acc40ec3830db1a030e9391a0205f910c6260a2d20e889e");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Teach With Oak Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ResourceAdapterOpenedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
}
/**
 * Resource Adapter Opened: A teacher opened the Resource Adapter for a capability.
 * 
 * When to trigger this event:
 * 1. The launcher button is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qgX2wCDfp08a-XdB8wqWI/trigger/VXiPc-Tu0L8-0oEKpAEBd
 * 2. A capability is chosen from the "Adapt with AI" menu. Opening the menu alone does not fire it.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qgX2wCDfp08a-XdB8wqWI/trigger/xjkodz79HxtDRsPkOyd_L
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/qgX2wCDfp08a-XdB8wqWI}
 */
export function resourceAdapterOpened(properties: ResourceAdapterOpenedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "qgX2wCDfp08a-XdB8wqWI", "f74606657fe74a6d3f665eac6549e5062618c4f42d1f5b2c91b056ae394968b6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Resource Adapter Opened", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("qgX2wCDfp08a-XdB8wqWI", "Resource Adapter Opened", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Resource Adapter Opened", eventProperties, "qgX2wCDfp08a-XdB8wqWI", "f74606657fe74a6d3f665eac6549e5062618c4f42d1f5b2c91b056ae394968b6");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Resource Adapter Opened", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface ResourceAdapterClosedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
}
/**
 * Resource Adapter Closed: A teacher closed the Resource Adapter.
 * 
 * When to trigger this event:
 * 1. The teacher closes the dialog. Leaving the page does not fire it.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/o1tdWQMgpTfYj8YIhH5um/trigger/_0OB7VT-SYSUmcDORuywn
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/o1tdWQMgpTfYj8YIhH5um}
 */
export function resourceAdapterClosed(properties: ResourceAdapterClosedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "o1tdWQMgpTfYj8YIhH5um", "0971a9ea3a4ebb6f692486a0208c6a4a542a95305086c0d0844c3a4755cf81eb", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Resource Adapter Closed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("o1tdWQMgpTfYj8YIhH5um", "Resource Adapter Closed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Resource Adapter Closed", eventProperties, "o1tdWQMgpTfYj8YIhH5um", "0971a9ea3a4ebb6f692486a0208c6a4a542a95305086c0d0844c3a4755cf81eb");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Resource Adapter Closed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdaptationStartedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  startMode: StartModeValueType;
}
/**
 * Adaptation Started: An adaptation was started or resumed.
 * 
 * When to trigger this event:
 * 1. The dialog opens a new adaptation (Start Mode: new).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/CZWgvyrvCYNTvk6nKfaKm/trigger/XyUsQBj2WdjpgKnv31spa
 * 2. "Carry on" is clicked and the saved adaptation loads (Start Mode: resumed).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/CZWgvyrvCYNTvk6nKfaKm/trigger/Q_Q60BPknGkV07tLpHXrU
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.startMode: Whether the teacher started a new adaptation or carried on with a saved one.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/CZWgvyrvCYNTvk6nKfaKm}
 */
export function adaptationStarted(properties: AdaptationStartedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "e80dRG544TJhxuW_6rFgH", name: "Start Mode", value: properties.startMode});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "CZWgvyrvCYNTvk6nKfaKm", "c48c1633c02863cf00e09dfab5fa39fa6f03fc667879dcc715d4a318f8c034d6", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Adaptation Started", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("CZWgvyrvCYNTvk6nKfaKm", "Adaptation Started", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptation Started", eventProperties, "CZWgvyrvCYNTvk6nKfaKm", "c48c1633c02863cf00e09dfab5fa39fa6f03fc667879dcc715d4a318f8c034d6");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Adaptation Started", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdaptationRestartRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
}
/**
 * Adaptation Restart Requested: A teacher asked to start an adaptation again from the original.
 * 
 * When to trigger this event:
 * 1. "Remove all scaffolds" is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/eTfZt0ZG07cvPA7MYFTXa/trigger/AE0ctewD_AjN_I1hV49lO
 * 2. "Start from the original" is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/eTfZt0ZG07cvPA7MYFTXa/trigger/WwRAYFOUXSl4gu3tQkT0I
 * 3. "Start again" is clicked after a step fails.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/eTfZt0ZG07cvPA7MYFTXa/trigger/3aZw-SlT70s_tA02s85L2
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/eTfZt0ZG07cvPA7MYFTXa}
 */
export function adaptationRestartRequested(properties: AdaptationRestartRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "eTfZt0ZG07cvPA7MYFTXa", "ea11d2c9a80a42f3e009998f9347d0d9ec4a9731fd0a3327d5ed7a8142e12803", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Adaptation Restart Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("eTfZt0ZG07cvPA7MYFTXa", "Adaptation Restart Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptation Restart Requested", eventProperties, "eTfZt0ZG07cvPA7MYFTXa", "ea11d2c9a80a42f3e009998f9347d0d9ec4a9731fd0a3327d5ed7a8142e12803");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Adaptation Restart Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface NewSuggestionsRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
}
/**
 * New Suggestions Requested: A teacher asked for a fresh set of suggestions.
 * 
 * When to trigger this event:
 * 1. "Generate new suggestions" is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/FjleVxg0iPPNsgNqzC86i/trigger/0l_WkgVDuA_gXfAw_b4-t
 * 2. "Try again" is clicked after finding suggestions fails.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/FjleVxg0iPPNsgNqzC86i/trigger/nWtD27XxtNn8H2oFDR_3A
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/FjleVxg0iPPNsgNqzC86i}
 */
export function newSuggestionsRequested(properties: NewSuggestionsRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "FjleVxg0iPPNsgNqzC86i", "117054853d820e3465d128e5122116c14b291850593803267d8f1b3ec0ed30db", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("New Suggestions Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("FjleVxg0iPPNsgNqzC86i", "New Suggestions Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("New Suggestions Requested", eventProperties, "FjleVxg0iPPNsgNqzC86i", "117054853d820e3465d128e5122116c14b291850593803267d8f1b3ec0ed30db");
    }
    // destination PostHogEU
    PostHogEU.logEvent("New Suggestions Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SuggestionsDisplayedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  jobId: string;
  suggestionCount: number;
  transformationKinds: string[];
}
/**
 * Suggestions Displayed: Suggestions, or the lack of any, were shown to a teacher.
 * 
 * When to trigger this event:
 * 1. A generation's suggestions are shown. Once per generation per dialog visit.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/3UrwxvSrZQcAOiXWykZ1U/trigger/NGyw9-Hpo8yrfGbtyaYqu
 * 2. "No scaffolds suggested" is shown (Suggestion Count: 0).
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/3UrwxvSrZQcAOiXWykZ1U/trigger/KsiR88LKe_pBsHEl2lUAn
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.jobId: UUID of the background job behind the event.
 * @param properties.suggestionCount: How many suggestions the teacher was shown. 0 means none were found.
 * @param properties.transformationKinds: The kinds of transformation suggested.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/3UrwxvSrZQcAOiXWykZ1U}
 */
export function suggestionsDisplayed(properties: SuggestionsDisplayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "n9ebKezfrQZPQThezlmOP", name: "Job Id", value: properties.jobId});
  eventPropertiesArray.push({id: "u0oy_l0AW_6_1OWn69SXa", name: "Suggestion Count", value: properties.suggestionCount});
  eventPropertiesArray.push({id: "ykioNtBHvbPRrA2DxRcD5", name: "Transformation Kinds", value: properties.transformationKinds});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "3UrwxvSrZQcAOiXWykZ1U", "de8c15dac32955b81e162a24aa0ed32e1bf834d508924951519d6a28b0ff9dfe", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Suggestions Displayed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("3UrwxvSrZQcAOiXWykZ1U", "Suggestions Displayed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Suggestions Displayed", eventProperties, "3UrwxvSrZQcAOiXWykZ1U", "de8c15dac32955b81e162a24aa0ed32e1bf834d508924951519d6a28b0ff9dfe");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Suggestions Displayed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TransformationRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  transformationKind: string;
  supportLevel: SupportLevelValueType | null | undefined;
}
/**
 * Transformation Requested: A teacher chose a suggested transformation.
 * 
 * When to trigger this event:
 * 1. A suggested transformation button is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/PcJ1rI3dpGgv01YvvuCLv/trigger/3Mg6rrUPfrVMBVc-GyEVt
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.transformationKind: The kind of change a transformation makes to the resource, such as adding a word bank.
 * @param properties.supportLevel: The level of support a transformation gives.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/PcJ1rI3dpGgv01YvvuCLv}
 */
export function transformationRequested(properties: TransformationRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "6mDfmpiDcWoZqsiWufvhr", name: "Transformation Kind", value: properties.transformationKind});
  properties.supportLevel !== undefined && properties.supportLevel !== null ?
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: properties.supportLevel}) :
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "PcJ1rI3dpGgv01YvvuCLv", "9dfd1c5462eeaef03330e77b88607bd47de895984632bd77031eef8cba8f2583", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Transformation Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("PcJ1rI3dpGgv01YvvuCLv", "Transformation Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Transformation Requested", eventProperties, "PcJ1rI3dpGgv01YvvuCLv", "9dfd1c5462eeaef03330e77b88607bd47de895984632bd77031eef8cba8f2583");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Transformation Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TransformationPreviewDisplayedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  attemptId: string;
  transformationKind: string;
  supportLevel: SupportLevelValueType | null | undefined;
}
/**
 * Transformation Preview Displayed: A generated transformation was shown for review.
 * 
 * When to trigger this event:
 * 1. A generated transformation appears with Undo, Retry and Accept. Once per attempt per visit.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/BdJ_3I_XQyX7s8UUQRGCK/trigger/lyVpp5tX9XhjfW2UFCW9F
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.attemptId: UUID of one generated version of a transformation in the resource adapter.
 * @param properties.transformationKind: The kind of change a transformation makes to the resource, such as adding a word bank.
 * @param properties.supportLevel: The level of support a transformation gives.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/BdJ_3I_XQyX7s8UUQRGCK}
 */
export function transformationPreviewDisplayed(properties: TransformationPreviewDisplayedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "CMrjO3GVUGguuiCS88sVo", name: "Attempt Id", value: properties.attemptId});
  eventPropertiesArray.push({id: "6mDfmpiDcWoZqsiWufvhr", name: "Transformation Kind", value: properties.transformationKind});
  properties.supportLevel !== undefined && properties.supportLevel !== null ?
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: properties.supportLevel}) :
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "BdJ_3I_XQyX7s8UUQRGCK", "6675559764f2a71378f0650071db991fc1a6c52b5ad022b90cffebbf9495bc6a", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Transformation Preview Displayed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("BdJ_3I_XQyX7s8UUQRGCK", "Transformation Preview Displayed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Transformation Preview Displayed", eventProperties, "BdJ_3I_XQyX7s8UUQRGCK", "6675559764f2a71378f0650071db991fc1a6c52b5ad022b90cffebbf9495bc6a");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Transformation Preview Displayed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TransformationReviewRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  reviewAction: ReviewActionValueType;
  transformationKind: string;
  supportLevel: SupportLevelValueType | null | undefined;
}
/**
 * Transformation Review Requested: A teacher chose what to do with a generated transformation.
 * 
 * When to trigger this event:
 * 1. Undo, Retry or Accept is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/v06WBORIxHZ865azX6HDb/trigger/Lz54Ukai6GVcAYjjF1XCK
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.reviewAction: The teacher's decision on a generated transformation.
 * @param properties.transformationKind: The kind of change a transformation makes to the resource, such as adding a word bank.
 * @param properties.supportLevel: The level of support a transformation gives.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/v06WBORIxHZ865azX6HDb}
 */
export function transformationReviewRequested(properties: TransformationReviewRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "eg6rKF7NBqvZAizx5J-Qx", name: "Review Action", value: properties.reviewAction});
  eventPropertiesArray.push({id: "6mDfmpiDcWoZqsiWufvhr", name: "Transformation Kind", value: properties.transformationKind});
  properties.supportLevel !== undefined && properties.supportLevel !== null ?
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: properties.supportLevel}) :
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "v06WBORIxHZ865azX6HDb", "2cfbc0987ead03734ac584f9f440abe9496d506edb1dc914c6d9f06b5727d380", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Transformation Review Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("v06WBORIxHZ865azX6HDb", "Transformation Review Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Transformation Review Requested", eventProperties, "v06WBORIxHZ865azX6HDb", "2cfbc0987ead03734ac584f9f440abe9496d506edb1dc914c6d9f06b5727d380");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Transformation Review Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TransformationReviewedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  reviewAction: ReviewActionValueType;
  transformationKind: string;
  supportLevel: SupportLevelValueType | null | undefined;
}
/**
 * Transformation Reviewed: A teacher's accept or undo was confirmed.
 * 
 * When to trigger this event:
 * 1. The Resource Adapter confirms an Accept or Undo.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/e658af78-a87c-4af9-a65a-83516cca3eee/trigger/w_rk3c0F6GW3-n1LHWBQ5
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.reviewAction: The teacher's decision on a generated transformation.
 * @param properties.transformationKind: The kind of change a transformation makes to the resource, such as adding a word bank.
 * @param properties.supportLevel: The level of support a transformation gives.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/e658af78-a87c-4af9-a65a-83516cca3eee}
 */
export function transformationReviewed(properties: TransformationReviewedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "eg6rKF7NBqvZAizx5J-Qx", name: "Review Action", value: properties.reviewAction});
  eventPropertiesArray.push({id: "6mDfmpiDcWoZqsiWufvhr", name: "Transformation Kind", value: properties.transformationKind});
  properties.supportLevel !== undefined && properties.supportLevel !== null ?
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: properties.supportLevel}) :
    eventPropertiesArray.push({id: "svGu2m5FVsbyO7_d20tOg", name: "Support Level", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "e658af78-a87c-4af9-a65a-83516cca3eee", "63dce40997536333f22951739f3411ef95fb4cc0f0031186fb1c88cb60b91bb3", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Transformation Reviewed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("e658af78-a87c-4af9-a65a-83516cca3eee", "Transformation Reviewed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Transformation Reviewed", eventProperties, "e658af78-a87c-4af9-a65a-83516cca3eee", "63dce40997536333f22951739f3411ef95fb4cc0f0031186fb1c88cb60b91bb3");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Transformation Reviewed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface SuggestionDismissalRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  transformationKinds: string[];
}
/**
 * Suggestion Dismissal Requested: A teacher dismissed the suggestions for part of a resource.
 * 
 * When to trigger this event:
 * 1. "No scaffold required" is clicked.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/P16XQCeQBaeq3o_oEbOtx/trigger/5f6C4jqqBMaPwXey86_hi
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.transformationKinds: The kinds of transformation suggested.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/P16XQCeQBaeq3o_oEbOtx}
 */
export function suggestionDismissalRequested(properties: SuggestionDismissalRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "ykioNtBHvbPRrA2DxRcD5", name: "Transformation Kinds", value: properties.transformationKinds});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "P16XQCeQBaeq3o_oEbOtx", "b8b5e2eedcc81de8f59d8154d9c1ed2e593115dc4efca58c259e8d9de162d688", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Suggestion Dismissal Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("P16XQCeQBaeq3o_oEbOtx", "Suggestion Dismissal Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Suggestion Dismissal Requested", eventProperties, "P16XQCeQBaeq3o_oEbOtx", "b8b5e2eedcc81de8f59d8154d9c1ed2e593115dc4efca58c259e8d9de162d688");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Suggestion Dismissal Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface TransformationRemovalRequestedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
}
/**
 * Transformation Removal Requested: A teacher removed an accepted transformation.
 * 
 * When to trigger this event:
 * 1. "Remove" is clicked on an added scaffold.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Q-tB4gh330vZuIKQkgUpW/trigger/wg_tsVGJb_MNmQhhoCTM6
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/Q-tB4gh330vZuIKQkgUpW}
 */
export function transformationRemovalRequested(properties: TransformationRemovalRequestedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "Q-tB4gh330vZuIKQkgUpW", "26a2571d9d144d837a966cb2dec443fc13d56f0092262850eacda36f1a28abe8", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Transformation Removal Requested", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("Q-tB4gh330vZuIKQkgUpW", "Transformation Removal Requested", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Transformation Removal Requested", eventProperties, "Q-tB4gh330vZuIKQkgUpW", "26a2571d9d144d837a966cb2dec443fc13d56f0092262850eacda36f1a28abe8");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Transformation Removal Requested", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdaptationRequestFailedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string | null | undefined;
  requestAction: RequestActionValueType;
  retryTarget: RetryTargetValueType | null | undefined;
}
/**
 * Adaptation Request Failed: A Resource Adapter request failed.
 * 
 * When to trigger this event:
 * 1. A request fails, for example when the worksheet cannot be loaded. No error text is sent.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/4bYM8g0PUrb_7i24aE_oc/trigger/o2TE3fhvJStRZjCwrsw7M
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.requestAction: The Resource Adapter request involved.
 * @param properties.retryTarget: What a retry is for.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/4bYM8g0PUrb_7i24aE_oc}
 */
export function adaptationRequestFailed(properties: AdaptationRequestFailedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  properties.adaptationId !== undefined && properties.adaptationId !== null ?
    eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId}) :
    eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: null});
  eventPropertiesArray.push({id: "cRnzXVYLwKjRoBpz0qOsF", name: "Request Action", value: properties.requestAction});
  properties.retryTarget !== undefined && properties.retryTarget !== null ?
    eventPropertiesArray.push({id: "-jrVMK9TK3fi4Yu-YFgJl", name: "Retry Target", value: properties.retryTarget}) :
    eventPropertiesArray.push({id: "-jrVMK9TK3fi4Yu-YFgJl", name: "Retry Target", value: null});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "4bYM8g0PUrb_7i24aE_oc", "3437f2aade2c3cda4b2cccddfdccdc7636fca07d8e2f577338d50bc11cb491ce", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Adaptation Request Failed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("4bYM8g0PUrb_7i24aE_oc", "Adaptation Request Failed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptation Request Failed", eventProperties, "4bYM8g0PUrb_7i24aE_oc", "3437f2aade2c3cda4b2cccddfdccdc7636fca07d8e2f577338d50bc11cb491ce");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Adaptation Request Failed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdaptationStepFailedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  jobId: string;
  jobKind: JobKindValueType;
}
/**
 * Adaptation Step Failed: A background step of an adaptation failed.
 * 
 * When to trigger this event:
 * 1. A failed background step is shown, such as "We couldn't find scaffolds". No failure text is sent.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/k803PvlRvYdIw_thQryOV/trigger/F6a9ROVFTFHfEjgHxQkKo
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.jobId: UUID of the background job behind the event.
 * @param properties.jobKind: The kind of background job: e.g. generating suggestions, applying one, or removing, retrying or dismissing a transformation.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/k803PvlRvYdIw_thQryOV}
 */
export function adaptationStepFailed(properties: AdaptationStepFailedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "n9ebKezfrQZPQThezlmOP", name: "Job Id", value: properties.jobId});
  eventPropertiesArray.push({id: "LKCI6opMEryVso5TnzNRZ", name: "Job Kind", value: properties.jobKind});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "k803PvlRvYdIw_thQryOV", "113601f04b03626b64f5564ebd89d1a29b276812418948118a9c52b6807385f2", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Adaptation Step Failed", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("k803PvlRvYdIw_thQryOV", "Adaptation Step Failed", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adaptation Step Failed", eventProperties, "k803PvlRvYdIw_thQryOV", "113601f04b03626b64f5564ebd89d1a29b276812418948118a9c52b6807385f2");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Adaptation Step Failed", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export interface AdaptedResourceDownloadedProperties {
  platform: PlatformValueType;
  product: ProductValueType;
  engagementIntent: EngagementIntentValueType;
  componentType: ComponentTypeValueType;
  eventVersion: EventVersionValueType;
  analyticsUseCase: AnalyticsUseCaseValueType;
  capabilityId: CapabilityIdValueType;
  packageVersion: string;
  adaptationId: string;
  format: FormatValueType;
}
/**
 * Adapted Resource Downloaded: A teacher downloaded their adapted resource.
 * 
 * When to trigger this event:
 * 1. "Download worksheet" is clicked and the file is handed to the browser.
 * View in Avo: https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/5ZfBeMUtKqTp1w2nuKO75/trigger/juKHbGTInNpftwWGKxoAb
 * 
 * @param properties the properties associated with this event
 * @param properties.platform: Describes the 'platform' or 'codebase' from which the event was sent. Historically this would have been acorn, but now this will cover OWA, Aila and Google Classroom. These should typically also have a one to one relationship with the 'sources' as defined in this Avo project (Oak's Tracking Plan).
 * @param properties.product: Product that the event was sent from to clear distinguish between Oak products
 * @param properties.engagementIntent: The level or intent of engagement behind the event. This is a high-level categorisation that helps determine whether this event is one that represents 'use' or 'advocacy for one of Oak's products, or whether this action would be considered to be related to 'exploring' Oak's products, or some kind of 'refinement' which limits the amount of content displayed (such as in a filter or a browse journey.
 * This property should be populated with a single value for each event/product combination (i.e. the instance of each event within a product should determine the level of engagement).
 * @param properties.componentType: The web component used to carry out the action on the Oak object
 * @param properties.eventVersion: The version (semver) of the event, which acts as a tag for when the event was introduced/updated. Helps with handling events that could cause downstream logic to change or create 'breaking ' changes in the downstream pipelines.
 * @param properties.analyticsUseCase: User is engaging with the site as a pupil or a teacher as defined by the page url (eg. thenational.academy/pupils or thenational.academy/teachers
 * NB - This will be removed, but keeping to ease transition from AUC to 'product'
 * @param properties.capabilityId: The Resource Adapter capability the teacher is using, such as adding scaffolding to a worksheet.
 * @param properties.packageVersion: Version of the Resource Adapter UI package that sent the event, for comparing behaviour across releases.
 * @param properties.adaptationId: UUID of the adaptation: one teacher's adapted copy of one lesson resource.
 * @param properties.format: File format of the download.
 * 
 * @see {@link https://www.avo.app/schemas/5PhajbVijwhXVKIJtGMT/events/5ZfBeMUtKqTp1w2nuKO75}
 */
export function adaptedResourceDownloaded(properties: AdaptedResourceDownloadedProperties) {
  // @ts-ignore
  let eventPropertiesArray: array = [];
  eventPropertiesArray.push({id: "M1ukA4HClh", name: "Platform", value: properties.platform});
  eventPropertiesArray.push({id: "JmUs_uxup", name: "Product", value: properties.product});
  eventPropertiesArray.push({id: "xJlB159-KB", name: "Engagement Intent", value: properties.engagementIntent});
  eventPropertiesArray.push({id: "9b_lf1oq8", name: "Component Type", value: properties.componentType});
  eventPropertiesArray.push({id: "3ZqdV-PbJL", name: "Event Version", value: properties.eventVersion});
  eventPropertiesArray.push({id: "DAS5R4dcvH", name: "Analytics Use Case", value: properties.analyticsUseCase});
  eventPropertiesArray.push({id: "ajD7ZBm9O9N24Pg5nPo1x", name: "Capability Id", value: properties.capabilityId});
  eventPropertiesArray.push({id: "yDQBVNy_diWjlbnPnqEFE", name: "Package Version", value: properties.packageVersion});
  eventPropertiesArray.push({id: "Vz5VimpUTU6oblIwKdIX2", name: "Adaptation Id", value: properties.adaptationId});
  eventPropertiesArray.push({id: "ROXeg8rPMRe6s05z1-9qG", name: "Format", value: properties.format});
  let eventProperties = convertPropertiesArrayToMap(eventPropertiesArray)
  // @ts-ignore
  let userPropertiesArray: array = [];
  let userProperties = convertPropertiesArrayToMap(userPropertiesArray)
  // assert properties
  if (__AVO_ENV__ !== AvoEnv.Prod || __WEB_DEBUGGER__) {
    let messages: AvoAssertMessage[] = [];
    // debug console in Avo
    if (!__AVO_NOOP__) {
      _avo_invoke(__AVO_ENV__, "5ZfBeMUtKqTp1w2nuKO75", "c15410710532fc332a4612f692a71ee3df6a0acf31d21719aa75664e166e586d", messages.map(m => Object.assign({}, {tag: m.tag, propertyId: m.propertyId, additionalProperties: m.additionalProperties, actualType: m.actualType})), 'event');
    }
    InternalAvoLogger.logEventSent("Adapted Resource Downloaded", eventProperties, userProperties);
    if (__WEB_DEBUGGER__) {
      // Avo web debugger
      _avo_debugger_log("5ZfBeMUtKqTp1w2nuKO75", "Adapted Resource Downloaded", messages, eventPropertiesArray, userPropertiesArray, []);
    }
  }
  if (!__AVO_NOOP__) {
    if (__INSPECTOR__ != null) {
      // @ts-ignore
      __INSPECTOR__._avoFunctionTrackSchemaFromEvent("Adapted Resource Downloaded", eventProperties, "5ZfBeMUtKqTp1w2nuKO75", "c15410710532fc332a4612f692a71ee3df6a0acf31d21719aa75664e166e586d");
    }
    // destination PostHogEU
    PostHogEU.logEvent("Adapted Resource Downloaded", (Object as any).assign({}, eventProperties));
  } else {
    // do nothing
  }
}

export default {
  AvoEnv,
  initAvo,
  avoInspectorApiKey,
  RetryTarget,
  SearchFilterMatchType,
  SingleSignOnService,
  FilterModificationType,
  ModeratedContentType,
  LessonReleaseCohort,
  EventVersion,
  ResourceTypes,
  VideoLocation,
  UserAccountVerificationStatus,
  ResourceFileType,
  ExamBoard,
  Context,
  ClientEnvironment,
  ComponentType,
  MediaClipsButtonName,
  SchoolOption,
  AnalyticsUseCase,
  QuestionResult,
  DownloadResourceButtonName,
  ResourceType,
  TierName,
  Product,
  JobKind,
  PageName,
  Platform,
  NavigationType,
  Format,
  ContentGuidanceWarning,
  Phase,
  UserRoleType,
  PupilExperienceLessonActivity,
  FilterType,
  ShareMedium,
  CapabilityId,
  SearchSource,
  RequestAction,
  StartMode,
  ReviewAction,
  TeachingMaterialType,
  Pathway,
  Audience,
  AccessBlockType,
  NavigatedFrom,
  KeyStageTitle,
  AccessLevel,
  SupportLevel,
  LearningTier,
  SearchResultType,
  EngagementIntent,
  newsletterSignUpCompleted,
  classroomSelected,
  videoStarted,
  videoPaused,
  videoPlayed,
  videoFinished,
  lessonResourcesDownloaded,
  unitAccessed,
  webinarPageViewed,
  pageview,
  lessonResourceDownloadStarted,
  searchAccessed,
  searchResultOpened,
  searchJourneyInitiated,
  curriculumVisualiserAccessed,
  lessonShared,
  lessonShareStarted,
  searchRefined,
  searchResultExpanded,
  lessonCompleted,
  lessonActivityCompleted,
  lessonActivityCompletedIntroduction,
  lessonActivityCompletedStarterQuiz,
  lessonActivityCompletedLessonVideo,
  lessonActivityCompletedExitQuiz,
  lessonActivityCompletedLessonAudio,
  lessonStarted,
  lessonActivityStarted,
  lessonActivityStartedIntroduction,
  lessonActivityStartedStarterQuiz,
  lessonActivityStartedLessonVideo,
  lessonActivityStartedExitQuiz,
  lessonActivityStartedLessonAudio,
  curriculumResourcesDownloaded,
  lessonActivityAbandoned,
  lessonActivityAbandonedStarterQuiz,
  lessonActivityAbandonedIntroduction,
  lessonActivityAbandonedLessonVideo,
  lessonActivityAbandonedExitQuiz,
  lessonActivityAbandonedLessonAudio,
  lessonAssistantAccessed,
  lessonAccessed,
  lessonAccessedPupilJourney,
  browseRefined,
  browseRefinedAccessed,
  lessonActivityDownloaded,
  lessonActivityDownloadedWorksheet,
  contentGuidanceAccepted,
  contentGuidanceDeclined,
  activityResultsShared,
  lessonSummaryReviewed,
  userSignUpCompleted,
  userOnboardingCompleted,
  userSignIn,
  userSignOut,
  lessonAbandoned,
  browseAccessed,
  questionAttemptSubmitted,
  teacherShareInitiated,
  teacherShareActivated,
  teacherShareConverted,
  unitDownloaded,
  teacherNoteDialogueOpened,
  teacherNoteSaved,
  curriculumVisualiserExited,
  curriculumVisualiserTabAccessed,
  unitOverviewExplored,
  productHomepageAccessed,
  curriculumLandingPageAccessed,
  curriculumExplainerExplored,
  curriculumResourcesDownloadRefined,
  searchFilterModified,
  lessonMediaClipsStarted,
  mediaClipsPlaylistPlayed,
  contentSaved,
  contentUnsaved,
  createTeachingMaterialsInitiated,
  teachingMaterialsSelected,
  teachingMaterialsRefined,
  teachingMaterialDownloaded,
  contentBlockNotificationDisplayed,
  userOnboardingProgressed,
  aboutUsAccessed,
  aboutUsExplored,
  aboutUsContactInitiated,
  classroomSignInCompleted,
  classroomSignInStarted,
  classroomLessonSelected,
  classroomLessonPreviewed,
  classroomLessonsAttached,
  classroomAddOnOpened,
  programmeRefined,
  unitRefined,
  programmeAccessed,
  unitDownloadStarted,
  scrolledTo,
  exitIntended,
  curriculumResourcesAccessed,
  teachWithOakAccessed,
  teachWithOakDownloaded,
  resourceAdapterOpened,
  resourceAdapterClosed,
  adaptationStarted,
  adaptationRestartRequested,
  newSuggestionsRequested,
  suggestionsDisplayed,
  transformationRequested,
  transformationPreviewDisplayed,
  transformationReviewRequested,
  transformationReviewed,
  suggestionDismissalRequested,
  transformationRemovalRequested,
  adaptationRequestFailed,
  adaptationStepFailed,
  adaptedResourceDownloaded,
}

// AVOMODULEMAP:"Avo"
// AVOEVENTMAP:["newsletterSignUpCompleted","classroomSelected","videoStarted","videoPaused","videoPlayed","videoFinished","lessonResourcesDownloaded","unitAccessed","webinarPageViewed","pageview","lessonResourceDownloadStarted","searchAccessed","searchResultOpened","searchJourneyInitiated","curriculumVisualiserAccessed","lessonShared","lessonShareStarted","searchRefined","searchResultExpanded","lessonCompleted","lessonActivityCompleted","lessonActivityCompletedIntroduction","lessonActivityCompletedStarterQuiz","lessonActivityCompletedLessonVideo","lessonActivityCompletedExitQuiz","lessonActivityCompletedLessonAudio","lessonStarted","lessonActivityStarted","lessonActivityStartedIntroduction","lessonActivityStartedStarterQuiz","lessonActivityStartedLessonVideo","lessonActivityStartedExitQuiz","lessonActivityStartedLessonAudio","curriculumResourcesDownloaded","lessonActivityAbandoned","lessonActivityAbandonedStarterQuiz","lessonActivityAbandonedIntroduction","lessonActivityAbandonedLessonVideo","lessonActivityAbandonedExitQuiz","lessonActivityAbandonedLessonAudio","lessonAssistantAccessed","lessonAccessed","lessonAccessedPupilJourney","browseRefined","browseRefinedAccessed","lessonActivityDownloaded","lessonActivityDownloadedWorksheet","contentGuidanceAccepted","contentGuidanceDeclined","activityResultsShared","lessonSummaryReviewed","userSignUpCompleted","userOnboardingCompleted","userSignIn","userSignOut","lessonAbandoned","browseAccessed","questionAttemptSubmitted","teacherShareInitiated","teacherShareActivated","teacherShareConverted","unitDownloaded","teacherNoteDialogueOpened","teacherNoteSaved","curriculumVisualiserExited","curriculumVisualiserTabAccessed","unitOverviewExplored","productHomepageAccessed","curriculumLandingPageAccessed","curriculumExplainerExplored","curriculumResourcesDownloadRefined","searchFilterModified","lessonMediaClipsStarted","mediaClipsPlaylistPlayed","contentSaved","contentUnsaved","createTeachingMaterialsInitiated","teachingMaterialsSelected","teachingMaterialsRefined","teachingMaterialDownloaded","contentBlockNotificationDisplayed","userOnboardingProgressed","aboutUsAccessed","aboutUsExplored","aboutUsContactInitiated","classroomSignInCompleted","classroomSignInStarted","classroomLessonSelected","classroomLessonPreviewed","classroomLessonsAttached","classroomAddOnOpened","programmeRefined","unitRefined","programmeAccessed","unitDownloadStarted","scrolledTo","exitIntended","curriculumResourcesAccessed","teachWithOakAccessed","teachWithOakDownloaded","resourceAdapterOpened","resourceAdapterClosed","adaptationStarted","adaptationRestartRequested","newSuggestionsRequested","suggestionsDisplayed","transformationRequested","transformationPreviewDisplayed","transformationReviewRequested","transformationReviewed","suggestionDismissalRequested","transformationRemovalRequested","adaptationRequestFailed","adaptationStepFailed","adaptedResourceDownloaded"]
